
    <!--
 * 竖版-全局弹窗
 * @LastEditTime: Tue Dec 17 2024 15:43:04 GMT+0800 (中国标准时间)
 -->
 <template>
  <div id="u_c_EEKH149"  :class="[`normal`,`u_c_EEKH149`]" ><div id="u_c_93BI150"  v-show="pageData.previewPopup == 'bag' || pageData.bagPopupState" :class="[`normal popup`,`u_c_93BI150`]" @click="u_c_93BI150_event_F8M123($event)"><div id="u_c_S1GB151"  :class="[`normal popup-content-big`,`u_c_S1GB151`]" @click="u_c_S1GB151_event_2MZ224($event)"><div id="u_c_DVXM152"  :class="[`normal popup-title popup-title-color`,`u_c_DVXM152`]" >{{`${ langData.myPackage }`}}</div><div id="u_c_TXUV154"  :class="[`normal border-color`,`u_c_TXUV154`]" ><table id="u_c_INK7155"  :class="[`normal`,`u_c_INK7155`]" ><thead id="u_c_EZ6A156"  :class="[`normal`,`u_c_EZ6A156`]" ><td id="u_c_MJVL157"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_MJVL157`]" >{{`${ langData.packageTime }`}}</td><td id="u_c_LU2L159"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_LU2L159`]" >{{`${ langData.packageName }`}}</td></thead><tbody id="u_c_KB6X161"  :class="[`normal`,`u_c_KB6X161`]" ><tr id="u_c_GIVF162"  v-for="(packItem, pI) in pageData.myPackageList" :key="pI" :class="[`normal border-color tr `,`u_c_GIVF162`]" ><td id="u_c_O6EY163"  :class="[`normal td border-color txt-size txt-color`,`u_c_O6EY163`]" >{{`${ packItem.time }`}}</td><td id="u_c_OQPL165"  :class="[`normal td border-color txt-size txt-color`,`u_c_OQPL165`]" ><span id="u_c_9F28166"  v-html="packItem.award_name || ''" :class="[`normal`,`u_c_9F28166`]" ></span><span id="u_c_L9U2167"  v-html="`${ langData.giftCode }：${ packItem.card }`" v-show="packItem.awardType == 'sendSerial'" :class="[`normal`,`u_c_L9U2167`]" ></span><a id="u_c_RPCD168" href="javascript:;" v-show="packItem['awardType'] == 'sendCoupon'" :class="[`normal popup-title-color txt-size`,`u_c_RPCD168`]" @click="u_c_RPCD168_event_1JVM17($event)">{{`[${ langData.useBtn }]`}}</a><a id="u_c_QJ7T170" href="javascript:;" v-show="packItem['awardType'] == 'sendSerial'" :class="[`normal txt-size popup-title-color`,`u_c_QJ7T170`]" @click="u_c_QJ7T170_event_QX7K17($event,packItem.card)">{{`[${ langData.copyAndGoExchange }]`}}</a></td></tr></tbody></table><div id="u_c_T83Z172"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_T83Z172`]" ></div></div><a id="u_c_JEBZ173" href="javascript:;" :class="[`normal popup-close`,`u_c_JEBZ173`]" @click="u_c_JEBZ173_event_DMX517($event)"></a></div></div><div id="u_c_4FYP175"  v-show="pageData.previewPopup == 'lastRank' || pageData.lastRankPopupState" :class="[`normal popup`,`u_c_4FYP175`]" @click="u_c_4FYP175_event_F8M123($event)"><div id="u_c_TUG9176"  :class="[`normal popup-content-big`,`u_c_TUG9176`]" @click="u_c_TUG9176_event_2MZ224($event)"><a id="u_c_6N1J198" href="javascript:;" :class="[`normal popup-close`,`u_c_6N1J198`]" @click="u_c_6N1J198_event_DMX517($event)"></a><div id="u_c_3XOE227"  :class="[`normal popup-title popup-title-color`,`u_c_3XOE227`]" >{{`${ pageData.curLastRankType = 'solo' ? langData.soloRank : langData.teamRank }`}}</div><div id="u_c_0FEY199"  :class="[`normal border-color`,`u_c_0FEY199`]" ><table id="u_c_V058200"  :class="[`normal`,`u_c_V058200`]" ><thead id="u_c_U8C4201"  :class="[`normal`,`u_c_U8C4201`]" ><td id="u_c_OKFQ202"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_OKFQ202`]" >{{`${ langData.rank }`}}</td><td id="u_c_7CQY204"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_7CQY204`]" >{{`${ langData.server }`}}</td><td id="u_c_PTZN206"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_PTZN206`]" >{{`${ langData.role }`}}</td><td id="u_c_VRV4208"  v-if="pageData.showRankMoney" :class="[`normal th border-color txt-size popup-title-color`,`u_c_VRV4208`]" >{{`${ langData.countMoney }`}}</td></thead><tbody id="u_c_Z2F7210"  :class="[`normal`,`u_c_Z2F7210`]" ><tr id="u_c_3NW0211"  v-for="(packItem, pI) in (compData.curRankType == 'team' ? pageData.teamRankList : pageData.soloRankList)" :key="pI" :class="[`normal border-color tr `,`u_c_3NW0211`]" ><td id="u_c_PAQY212"  :class="[`normal td border-color txt-size txt-color`,`u_c_PAQY212`]" >{{`${ packItem.rank }`}}</td><td id="u_c_TQ08214"  :class="[`normal td border-color txt-size txt-color`,`u_c_TQ08214`]" >{{`${ packItem.serverName }`}}</td><td id="u_c_QZ3T216"  :class="[`normal td border-color txt-size txt-color`,`u_c_QZ3T216`]" >{{`${ packItem.roleName }`}}</td><td id="u_c_WUCL218"  v-if="pageData.showRankMoney" :class="[`normal td border-color txt-size txt-color`,`u_c_WUCL218`]" >{{`${ packItem.payTotal }`}}</td></tr></tbody></table><div id="u_c_TP6B220"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_TP6B220`]" ></div></div></div></div><div id="u_c_N5TX48"  v-show="pageData.previewPopup == 'teamInfo' || pageData.teamInfoPopupState" :class="[`normal popup`,`u_c_N5TX48`]" @click="u_c_N5TX48_event_F8M123($event)"><div id="u_c_O2L649"  :class="[`normal popup-content-big`,`u_c_O2L649`]" @click="u_c_O2L649_event_2MZ224($event)"><div id="u_c_PT9650"  :class="[`normal popup-title popup-title-color`,`u_c_PT9650`]" >{{`${ langData.myTeam }`}}</div><div id="u_c_S49552"  :class="[`normal border-color`,`u_c_S49552`]" ><table id="u_c_GQOA53"  :class="[`normal`,`u_c_GQOA53`]" ><thead id="u_c_N0O054"  :class="[`normal`,`u_c_N0O054`]" ><td id="u_c_NTM477"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_NTM477`]" >{{`${ langData.roleName }`}}</td><td id="u_c_N48357"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_N48357`]" >{{`${ langData.inviteTime }`}}</td></thead><tbody id="u_c_IOWX59"  :class="[`normal`,`u_c_IOWX59`]" ><tr id="u_c_MSKH60"  v-for="(packItem, pI) in listData.teamList" :key="pI" :class="[`normal border-color tr `,`u_c_MSKH60`]" ><td id="u_c_RQ1579"  :class="[`normal td border-color txt-size txt-color`,`u_c_RQ1579`]" >{{`${ packItem.role_name }`}}{{pI == 0 ? `(${ langData.captain })` : ''}}</td><td id="u_c_OXZT63"  :class="[`normal td border-color txt-size txt-color`,`u_c_OXZT63`]" ><span id="u_c_R9EH64"  v-html="packItem.time" :class="[`normal`,`u_c_R9EH64`]" ></span></td></tr></tbody></table><div id="u_c_TTE470"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_TTE470`]" ></div></div><a id="u_c_VR7N71" href="javascript:;" :class="[`normal popup-close`,`u_c_VR7N71`]" @click="u_c_VR7N71_event_DMX517($event)"></a></div></div><div id="u_c_L29Z174"  v-show="pageData.previewPopup == 'inviteLog' || pageData.inviteLogPopupState" :class="[`normal popup`,`u_c_L29Z174`]" @click="u_c_L29Z174_event_F8M123($event)"><div id="u_c_CJ7W175"  :class="[`normal popup-content-big`,`u_c_CJ7W175`]" @click="u_c_CJ7W175_event_2MZ224($event)"><div id="u_c_HNVX176"  :class="[`normal popup-title popup-title-color`,`u_c_HNVX176`]" >{{langData.inviteLog}}</div><div id="u_c_EG2Q178"  :class="[`normal border-color`,`u_c_EG2Q178`]" ><table id="u_c_GNB7179"  :class="[`normal`,`u_c_GNB7179`]" ><thead id="u_c_HI7Z180"  :class="[`normal`,`u_c_HI7Z180`]" ><td id="u_c_D7T4181"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_D7T4181`]" >{{langData.completeTime}}</td><td id="u_c_I55Y183"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_I55Y183`]" >{{langData.friendName}}</td></thead><tbody id="u_c_OUV7185"  :class="[`normal`,`u_c_OUV7185`]" ><tr id="u_c_IJRB186"  v-for="(packItem, pI) in pageData.inviteLog" :key="pI" :class="[`normal border-color tr `,`u_c_IJRB186`]" ><td id="u_c_OPFB187"  :class="[`normal td border-color txt-size txt-color`,`u_c_OPFB187`]" >{{`${ packItem.time }`}}</td><td id="u_c_PJZV189"  :class="[`normal td border-color txt-size txt-color`,`u_c_PJZV189`]" ><span id="u_c_FLPZ190"  v-html="packItem.roleName" :class="[`normal`,`u_c_FLPZ190`]" ></span></td></tr></tbody></table><div id="u_c_SCGF191"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_SCGF191`]" ></div></div><a id="u_c_P7ST192" href="javascript:;" :class="[`normal popup-close`,`u_c_P7ST192`]" @click="u_c_P7ST192_event_DMX517($event)"></a></div></div><div id="u_c_A7J224"  v-show="pageData.previewPopup == 'taskLog' || pageData.taskLogPopupState" :class="[`normal popup`,`u_c_A7J224`]" @click="u_c_A7J224_event_F8M123($event)"><div id="u_c_ZBE225"  :class="[`normal popup-content-big`,`u_c_ZBE225`]" @click="u_c_ZBE225_event_2MZ224($event)"><div id="u_c_ST6826"  :class="[`normal popup-title popup-title-color`,`u_c_ST6826`]" >{{langData.taskLog}}</div><div id="u_c_29DH28"  :class="[`normal border-color`,`u_c_29DH28`]" ><table id="u_c_55OD29"  :class="[`normal`,`u_c_55OD29`]" ><thead id="u_c_7TVH30"  :class="[`normal`,`u_c_7TVH30`]" ><td id="u_c_4FNG31"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_4FNG31`]" >{{langData.completeTime}}</td><td id="u_c_4BRN33"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_4BRN33`]" >{{langData.taskName}}</td></thead><tbody id="u_c_0PDC35"  :class="[`normal`,`u_c_0PDC35`]" ><tr id="u_c_CLRM36"  v-for="(packItem, pI) in pageData.taskLog" :key="pI" :class="[`normal border-color tr `,`u_c_CLRM36`]" ><td id="u_c_6DO837"  :class="[`normal td border-color txt-size txt-color`,`u_c_6DO837`]" >{{`${ packItem.time }`}}</td><td id="u_c_99XC39"  :class="[`normal td border-color txt-size txt-color`,`u_c_99XC39`]" ><span id="u_c_4NV140"  v-html="packItem.name" :class="[`normal`,`u_c_4NV140`]" ></span></td></tr></tbody></table><div id="u_c_42GT41"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_42GT41`]" ></div></div><a id="u_c_A5AZ42" href="javascript:;" :class="[`normal popup-close`,`u_c_A5AZ42`]" @click="u_c_A5AZ42_event_DMX517($event)"></a></div></div><div id="u_c_JMGQ193"  v-show="pageData.previewPopup == 'inviteExpLog' || pageData.inviterTaskLogPopupState" :class="[`normal popup`,`u_c_JMGQ193`]" @click="u_c_JMGQ193_event_F8M123($event)"><div id="u_c_BNUG194"  :class="[`normal popup-content-big`,`u_c_BNUG194`]" @click="u_c_BNUG194_event_2MZ224($event)"><div id="u_c_BH3T195"  :class="[`normal popup-title popup-title-color`,`u_c_BH3T195`]" >{{langData.taskLog}}</div><div id="u_c_F0VZ197"  :class="[`normal border-color`,`u_c_F0VZ197`]" ><table id="u_c_QCIY198"  :class="[`normal`,`u_c_QCIY198`]" ><thead id="u_c_IO9N199"  :class="[`normal`,`u_c_IO9N199`]" ><td id="u_c_IOVB200"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_IOVB200`]" >{{langData.taskName}}</td><td id="u_c_U7GV202"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_U7GV202`]" >{{langData.completeTime}}</td><td id="u_c_9ZDW204"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_9ZDW204`]" >{{langData.exp}}</td></thead><tbody id="u_c_MH8K206"  :class="[`normal`,`u_c_MH8K206`]" ><tr id="u_c_OBVL207"  v-for="(packItem, pI) in pageData.inviterTaskLog" :key="pI" :class="[`normal border-color tr `,`u_c_OBVL207`]" ><td id="u_c_ML07208"  :class="[`normal td border-color txt-size txt-color`,`u_c_ML07208`]" >{{`${ giftInfo.inviterTask.find(item => item.arrayId == packItem.arrayId && item.subTaskType == packItem.taskType)?.title || '' }`}}</td><td id="u_c_RB9U210"  :class="[`normal td border-color txt-size txt-color`,`u_c_RB9U210`]" >{{`${ packItem.finishTime }`}}</td><td id="u_c_I9R6212"  :class="[`normal td border-color txt-size txt-color`,`u_c_I9R6212`]" >{{`${ packItem.exp }`}}</td></tr></tbody></table><div id="u_c_QSMZ214"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_QSMZ214`]" ></div></div><a id="u_c_HVLV215" href="javascript:;" :class="[`normal popup-close`,`u_c_HVLV215`]" @click="u_c_HVLV215_event_DMX517($event)"></a></div></div><div id="u_c_C5IC216"  v-show="pageData.inviteeTaskLogPopupState" :class="[`normal popup`,`u_c_C5IC216`]" @click="u_c_C5IC216_event_F8M123($event)"><div id="u_c_BV7B217"  :class="[`normal popup-content-big`,`u_c_BV7B217`]" @click="u_c_BV7B217_event_2MZ224($event)"><div id="u_c_MEAK218"  :class="[`normal popup-title popup-title-color`,`u_c_MEAK218`]" >{{langData.taskLog}}</div><div id="u_c_EO1W220"  :class="[`normal border-color`,`u_c_EO1W220`]" ><table id="u_c_R0I4221"  :class="[`normal`,`u_c_R0I4221`]" ><thead id="u_c_TKH9222"  :class="[`normal`,`u_c_TKH9222`]" ><td id="u_c_F50B223"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_F50B223`]" >{{langData.taskName}}</td><td id="u_c_ISPG225"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_ISPG225`]" >{{langData.completeTime}}</td><td id="u_c_MWES227"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_MWES227`]" >{{langData.exp}}</td></thead><tbody id="u_c_QJSK229"  :class="[`normal`,`u_c_QJSK229`]" ><tr id="u_c_OS9P230"  v-for="(packItem, pI) in pageData.inviteeTaskLog" :key="pI" :class="[`normal border-color tr `,`u_c_OS9P230`]" ><td id="u_c_D5FO231"  :class="[`normal td border-color txt-size txt-color`,`u_c_D5FO231`]" >{{`${ giftInfo.inviteeTask.find(item => item.arrayId == packItem.arrayId && item.subTaskType == packItem.taskType)?.title || '' }`}}</td><td id="u_c_OO9E233"  :class="[`normal td border-color txt-size txt-color`,`u_c_OO9E233`]" >{{`${ packItem.finishTime }`}}</td><td id="u_c_QUZN235"  :class="[`normal td border-color txt-size txt-color`,`u_c_QUZN235`]" >{{`${ packItem.exp }`}}</td></tr></tbody></table><div id="u_c_OHFG237"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_OHFG237`]" ></div></div><a id="u_c_BDAJ238" href="javascript:;" :class="[`normal popup-close`,`u_c_BDAJ238`]" @click="u_c_BDAJ238_event_DMX517($event)"></a></div></div><div id="u_c_FMGB239"  v-show="pageData.inviteeOtherPopupState" :class="[`normal popup`,`u_c_FMGB239`]" @click="u_c_FMGB239_event_F8M123($event)"><div id="u_c_95KO240"  :class="[`normal popup-content-big`,`u_c_95KO240`]" @click="u_c_95KO240_event_2MZ224($event)"><div id="u_c_CUB9241"  :class="[`normal popup-title popup-title-color`,`u_c_CUB9241`]" >{{langData.taskLog}}</div><div id="u_c_9W8Y243"  :class="[`normal border-color`,`u_c_9W8Y243`]" ><table id="u_c_CE0G244"  :class="[`normal`,`u_c_CE0G244`]" ><thead id="u_c_H8Z1245"  :class="[`normal`,`u_c_H8Z1245`]" ><td id="u_c_DG2T246"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_DG2T246`]" >{{langData.taskName}}</td><td id="u_c_A3HT248"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_A3HT248`]" >{{langData.completeTime}}</td><td id="u_c_SP4I250"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_SP4I250`]" >{{langData.exp}}</td><td id="u_c_TQBB252"  :class="[`normal th border-color txt-size popup-title-color`,`u_c_TQBB252`]" >{{langData.role}}</td></thead><tbody id="u_c_BPDA254"  :class="[`normal`,`u_c_BPDA254`]" ><tr id="u_c_BG5S255"  v-for="(packItem, pI) in pageData.inviteeOther" :key="pI" :class="[`normal border-color tr `,`u_c_BG5S255`]" ><td id="u_c_PCW6256"  :class="[`normal td border-color txt-size txt-color`,`u_c_PCW6256`]" >{{`${ giftInfo.inviteeTask.find(item => item.arrayId == packItem.arrayId && item.subTaskType == packItem.taskType)?.title || '' }`}}</td><td id="u_c_GGPP258"  :class="[`normal td border-color txt-size txt-color`,`u_c_GGPP258`]" >{{`${ packItem.finishTime }`}}</td><td id="u_c_PYKE260"  :class="[`normal td border-color txt-size txt-color`,`u_c_PYKE260`]" >{{`${ packItem.exp }`}}</td><td id="u_c_BGCM262"  :class="[`normal td border-color txt-size txt-color`,`u_c_BGCM262`]" >{{`${ packItem.roleName || '' }`}}</td></tr></tbody></table><div id="u_c_K27Y264"  v-html="langData.emptyBag" v-show="!pageData.myPackageList.length" :class="[`normal txt-size txt-color`,`u_c_K27Y264`]" ></div></div><a id="u_c_C3YB265" href="javascript:;" :class="[`normal popup-close`,`u_c_C3YB265`]" @click="u_c_C3YB265_event_DMX517($event)"></a></div></div><div id="u_c_TT13266"  v-show="pageData.previewPopup == 'previewGift' || pageData.seeGiftPopupState" :class="[`normal popup`,`u_c_TT13266`]" @click="u_c_TT13266_event_TETB35($event)"><div id="u_c_BR8S267"  :class="[`normal popup-content-big`,`u_c_BR8S267`]" @click="u_c_BR8S267_event_U82518($event)"><div id="u_c_QA30268"  :class="[`normal popup-title-color popup-title`,`u_c_QA30268`]" >{{`${ langData.checkGiftBtn }`}}</div><div id="u_c_GQHB270"  :class="[`normal `,`u_c_GQHB270`]" ><table id="u_c_ESRJ271"  :class="[`normal`,`u_c_ESRJ271`]" ><tbody id="u_c_F9EU272"  :class="[`normal`,`u_c_F9EU272`]" ><tr id="u_c_JNPQ273"  v-for="(seeItem, seeIndex) in pageData.seeGift" :key="seeIndex" :class="[`normal border-color  tr `,`u_c_JNPQ273`]" ><td id="u_c_LD96274"  :class="[`normal td border-color txt-size txt-color`,`u_c_LD96274`]" ><img id="u_c_JQDW275"  :src="seeItem.pic" v-show="seeItem.pic" :class="[`normal`,`u_c_JQDW275`]" /></td><td id="u_c_JLSA36"  :class="[`normal td border-color txt-size txt-color`,`u_c_JLSA36`]" ><div id="u_c_9W0637"  v-html="seeItem.name" :class="[`normal`,`u_c_9W0637`]" ></div><span id="u_c_OWKT38"  v-if="pageData.showRate || pageData.showStock" :class="[`normal`,`u_c_OWKT38`]" >{{`${ langData.lotteryWeight }: `}}</span><span id="u_c_HBXK40"  v-if="pageData.showRate" :class="[`normal`,`u_c_HBXK40`]" >{{`${ pageData.isEdit ? 0 : seeItem.awardWeight }`}}</span><span id="u_c_E33R42"  v-if="pageData.showStock" :class="[`normal`,`u_c_E33R42`]" >{{`(${ pageData.isEdit ? 0 : +seeItem.awardStock || langData.noCountLimit })`}}</span></td></tr></tbody></table></div><a id="u_c_SN0I278" href="javascript:;" :class="[`normal popup-close`,`u_c_SN0I278`]" @click="u_c_SN0I278_event_DMX517($event)"></a></div></div><div id="u_c_HD05279"  v-show="pageData.previewPopup == 'daoju' || pageData.propsPopupState" :class="[`normal popup`,`u_c_HD05279`]" @click="u_c_HD05279_event_TETB35($event)"><div id="u_c_BAIN280"  :class="[`normal popup-content-big`,`u_c_BAIN280`]" @click="u_c_BAIN280_event_U82518($event)"><div id="u_c_J1OY281"  :class="[`normal popup-title popup-title-color`,`u_c_J1OY281`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_HXDL283"  :class="[`normal`,`u_c_HXDL283`]" ><div id="u_c_JV9F284"  :class="[`normal`,`u_c_JV9F284`]" ><div id="u_c_NZ54285"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_NZ54285`]" ></div></div><img id="u_c_D2YH286"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_D2YH286`]" /></div><a id="u_c_BT5T287" href="javascript:;" :class="[`normal sure`,`u_c_BT5T287`]" @click="u_c_BT5T287_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_IOVK289"  v-html="langData.daojuTips" :class="[`normal tips-color txt-size`,`u_c_IOVK289`]" ></div><a id="u_c_MECU290" href="javascript:;" :class="[`normal popup-close`,`u_c_MECU290`]" @click="u_c_MECU290_event_DMX517($event)"></a></div></div><div id="u_c_4KIA91"  v-show="pageData.previewPopup == 'material' || pageData.materialPopupState" :class="[`normal popup`,`u_c_4KIA91`]" @click="u_c_4KIA91_event_TETB35($event)"><div id="u_c_VSBS92"  :class="[`normal popup-content-big`,`u_c_VSBS92`]" @click="u_c_VSBS92_event_U82518($event)"><div id="u_c_WMZQ93"  :class="[`normal popup-title popup-title-color`,`u_c_WMZQ93`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_VHZ195"  :class="[`normal`,`u_c_VHZ195`]" ><div id="u_c_LRU896"  :class="[`normal`,`u_c_LRU896`]" ><div id="u_c_57FV97"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_57FV97`]" ></div></div><img id="u_c_4BZD98"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_4BZD98`]" /></div><a id="u_c_ZPDQ99" href="javascript:;" :class="[`normal sure`,`u_c_ZPDQ99`]" @click="u_c_ZPDQ99_event_YU9U68($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_LDTL101"  v-html="langData.realGiftInfo" :class="[`normal tips-color txt-size`,`u_c_LDTL101`]" ></div><a id="u_c_OMDX102" href="javascript:;" :class="[`normal popup-close`,`u_c_OMDX102`]" @click="u_c_OMDX102_event_DMX517($event)"></a></div></div><div id="u_c_OMHF291"  v-show="pageData.previewPopup == 'youhuiquan' || pageData.quanPopupState" :class="[`normal popup`,`u_c_OMHF291`]" @click="u_c_OMHF291_event_TETB35($event)"><div id="u_c_GZL0292"  :class="[`normal popup-content-big`,`u_c_GZL0292`]" @click="u_c_GZL0292_event_U82518($event)"><div id="u_c_TSXD293"  :class="[`normal popup-title popup-title-color`,`u_c_TSXD293`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_OODK295"  :class="[`normal`,`u_c_OODK295`]" ><div id="u_c_SMOH296"  :class="[`normal`,`u_c_SMOH296`]" ><div id="u_c_AKZ5297"  v-html="pageData.curGiftName" :class="[`normal txt-size txt-color`,`u_c_AKZ5297`]" ></div></div><img id="u_c_9CWK298"  :src="pageData.curGiftPic" v-show="pageData.curGiftPic" :class="[`normal`,`u_c_9CWK298`]" /></div><a id="u_c_MNYN299" href="javascript:;" :class="[`normal  sure`,`u_c_MNYN299`]" @click="u_c_MNYN299_event_35V252($event)">{{`${ langData.useBtn }`}}</a><a id="u_c_NS1R301" href="javascript:;" :class="[`normal popup-close`,`u_c_NS1R301`]" @click="u_c_NS1R301_event_DMX517($event)"></a></div></div><div id="u_c_HLVO302"  v-show="pageData.previewPopup == 'xuhao' || pageData.giftCodePopupState" :class="[`normal popup`,`u_c_HLVO302`]" @click="u_c_HLVO302_event_TXZS38($event)"><div id="u_c_TEW3303"  :class="[`normal popup-content-big`,`u_c_TEW3303`]" @click="u_c_TEW3303_event_EKU139($event)"><div id="u_c_NIE3304"  :class="[`normal popup-title popup-title-color`,`u_c_NIE3304`]" >{{`${ langData.successTitle }`}}</div><div id="u_c_F62T306"  :class="[`normal`,`u_c_F62T306`]" ><div id="u_c_FCR3307"  :class="[`normal txt-size txt-color`,`u_c_FCR3307`]" >{{`${ langData.giftCode }：${ pageData.curGiftName }`}}</div><a id="u_c_NP13309" href="javascript:;" :class="[`normal txt-size popup-title-color`,`u_c_NP13309`]" @click="u_c_NP13309_event_QX7K17($event)">{{`[${ langData.copy }]`}}</a></div><div id="u_c_MDD3311" href="javascript:;" :class="[`${ compData.copyTipsState ? '' : 'hide' }`,`normal txt-size txt-color`,`u_c_MDD3311`]" >{{`${ langData.copySucc }`}}</div><a id="u_c_D7Y3313" href="javascript:;" :class="[`normal popup-close`,`u_c_D7Y3313`]" @click="u_c_D7Y3313_event_KBHJ41($event)"></a><a id="u_c_ATIJ314" href="javascript:;" :class="[`normal sure`,`u_c_ATIJ314`]" @click="u_c_ATIJ314_event_YU9U68($event)">{{`${ langData.gotoExchange }`}}</a></div></div><div id="u_c_NX07322"  v-show="pageData.previewPopup == 'inputInviteCode' || pageData.inviteBindPopupState" :class="[`normal popup`,`u_c_NX07322`]" @click="u_c_NX07322_event_TETB35($event)"><div id="u_c_O43Z323"  :class="[`normal popup-content-big`,`u_c_O43Z323`]" @click="u_c_O43Z323_event_U82518($event)"><div id="u_c_ISFL324"  :class="[`normal popup-title popup-title-color`,`u_c_ISFL324`]" >{{langData.joinTeam}}</div><input id="u_c_HY88326"  v-model="pageData.inviteCodeUrl" :disabled="pageData.inputInviteCode?.length" :placeholder="langData.pleaseTeamCode" :class="[`normal txt-size txt-color invite-input`,`u_c_HY88326`]" /><a id="u_c_F8EP327" href="javascript:;" :class="[`normal popup-close`,`u_c_F8EP327`]" @click="u_c_F8EP327_event_DMX517($event)"></a><div id="u_c_ML0F328"  v-if="+pageData.bindExp > 0" :class="[`normal txt-size tips-color`,`u_c_ML0F328`]" >{{`${ langData.firstBindAward }：${ langData.exp }+ ${ pageData.bindExp }`}}</div><a id="u_c_RWPA330" href="javascript:;" :class="[`normal sure`,`u_c_RWPA330`]" @click="u_c_RWPA330_event_V0IC67($event)">{{langData.joinTeam}}</a></div></div><div id="u_c_AWZN29"  v-show="pageData.previewPopup == 'shareTicket' || pageData.shareTicketPopupState" :class="[`normal popup`,`u_c_AWZN29`]" @click="u_c_AWZN29_event_TETB35($event)"><div id="u_c_9AEY30"  :class="[`normal popup-content-big`,`u_c_9AEY30`]" @click="u_c_9AEY30_event_U82518($event)"><a id="u_c_KAV634" href="javascript:;" :class="[`normal popup-close`,`u_c_KAV634`]" @click="u_c_KAV634_event_DMX517($event)"></a><img id="u_c_BRSA49"  :src="pageData.canvasImg" :class="[`normal`,`u_c_BRSA49`]" /><div id="u_c_5CF243"  v-if="utils.systemType() == 'ios'" :class="[`normal`,`u_c_5CF243`]" >{{`${ langData.pressTosave }`}}</div><div id="u_c_FR0B31"  :class="[`normal popup-title-color`,`u_c_FR0B31`]" ><div id="u_c_9I7I19"  :class="[`normal`,`u_c_9I7I19`]" ></div><div id="u_c_2OTG19"  :class="[`normal`,`u_c_2OTG19`]" >{{`${ langData.step1Title }`}}<span id="u_c_N5XH81"  :class="[`normal highlight copyTag`,`u_c_N5XH81`]" >{{langData.copyTag}}</span></div></div><div id="u_c_TD0150"  :class="[`normal`,`u_c_TD0150`]" ><a id="u_c_A5IO37" href="javascript:;" v-if="utils.systemType() != 'ios'" :class="[`normal sure`,`u_c_A5IO37`]" @click="u_c_A5IO37_event_V0IC67($event)">{{langData.savePic}}</a><a id="u_c_07SK51" href="javascript:;" :class="[`normal sure`,`u_c_07SK51`]" @click="u_c_07SK51_event_V0IC67($event)">{{langData.copy}}</a></div><div id="u_c_WRVM53"  :class="[`normal popup-title-color`,`u_c_WRVM53`]" ><div id="u_c_GV0A20"  :class="[`normal`,`u_c_GV0A20`]" ></div>{{`${ langData.step2Title }`}}</div><div id="u_c_QZJ855"  :class="[`normal`,`u_c_QZJ855`]" ><a id="u_c_MGM958" href="javascript:;" :class="[`normal sure`,`u_c_MGM958`]" @click="u_c_MGM958_event_V0IC67($event)">{{langData.shareToFB}}</a><a id="u_c_DFSO19" href="javascript:;" :class="[`normal sure`,`u_c_DFSO19`]" @click="u_c_DFSO19_event_V0IC67($event)">{{langData.shareToDiscord}}</a><a id="u_c_4CUK19" href="javascript:;" v-if="curLang == 'ja-JP'" :class="[`normal sure`,`u_c_4CUK19`]" @click="u_c_4CUK19_event_V0IC67($event)">{{langData.shareToX}}</a></div></div></div><div id="u_c_DF8T332"  v-show="pageData.previewPopup == 'getInvite' || pageData.inviteMessagePopupState" :class="[`normal popup`,`u_c_DF8T332`]" @click="u_c_DF8T332_event_TETB35($event)"><div id="u_c_EQD4333"  :class="[`normal popup-content-big`,`u_c_EQD4333`]" @click="u_c_EQD4333_event_U82518($event)"><div id="u_c_BRKO334"  :class="[`normal txt-size txt-color`,`u_c_BRKO334`]" >{{`${ langData.welcomeTeamInvite }`}}<div id="u_c_PX60336"  :class="[`normal txt-size txt-color`,`u_c_PX60336`]" >{{pageData.inviteRoleNameUrl}}</div></div><div id="u_c_HEUB338"  :class="[`normal txt-size txt-color`,`u_c_HEUB338`]" >{{langData.teamCode}}<div id="u_c_B1ZY340"  :class="[`normal invite-input`,`u_c_B1ZY340`]" >{{`${ pageData.inviteCodeUrl }`}}</div></div><a id="u_c_NRD6342" href="javascript:;" :class="[`normal sure`,`u_c_NRD6342`]" @click="u_c_NRD6342_event_V0IC67($event)">{{langData.joinTeam}}</a><div id="u_c_RQ4V344"  v-if="false" :class="[`normal txt-size tips-color`,`u_c_RQ4V344`]" >{{langData.inviteBindTips}}</div><a id="u_c_QE3E346" href="javascript:;" :class="[`normal popup-close`,`u_c_QE3E346`]" @click="u_c_QE3E346_event_DMX517($event)"></a></div></div><div id="u_c_PPX633"  v-show="pageData.previewPopup == 'share' || pageData.toInvitePopupState" :class="[`normal popup`,`u_c_PPX633`]" @click="u_c_PPX633_event_TETB35($event)"><div id="u_c_ODH034"  :style="`background-image:url(${ pageData['sharePopupBg'] })`" :class="[`normal popup-content-big`,`u_c_ODH034`]" @click="u_c_ODH034_event_U82518($event)"><div id="u_c_UYAG35"  :style="`color:${ pageData['shareColor'] }`" :class="[`normal popup-title popup-title-color`,`u_c_UYAG35`]" >{{langData.welcomeTeamInvite}}</div><div id="u_c_P4PM37"  :style="`color:${ pageData['shareColor'] }`" :class="[`normal`,`u_c_P4PM37`]" ><div id="u_c_UO0E38"  :class="[`normal txt-size `,`u_c_UO0E38`]" >{{langData.teamCode}}<div id="u_c_DKKB40"  :class="[`normal`,`u_c_DKKB40`]" >{{`${ pageData.inviteCode }`}}</div></div><div id="u_c_HG0342"  :class="[`normal txt-size `,`u_c_HG0342`]" >{{langData.teamAddress}}<div id="u_c_EANT44"  :class="[`normal`,`u_c_EANT44`]" >https://xxxx.xxxx.com</div></div></div><div id="u_c_QKY052"  :style="`color:${ pageData['shareColor'] }`" :class="[`normal `,`u_c_QKY052`]" @click="u_c_QKY052_event_Z18221($event)"><div id="u_c_EMSF53"  v-if="pageData.shareList.map(item => item.type).includes('Twitter')" :class="[`normal`,`u_c_EMSF53`]" @click="u_c_EMSF53_event_V0IC67($event)"><div id="u_c_LQQC54"  :class="[`normal`,`u_c_LQQC54`]" @click="u_c_LQQC54_event_V0IC67($event)"></div>Twitter</div><div id="u_c_U47W56"  v-if="pageData.shareList.map(item => item.type).includes('Facebook')" :class="[`normal`,`u_c_U47W56`]" @click="u_c_U47W56_event_V0IC67($event)"><div id="u_c_SXH157"  :class="[`normal`,`u_c_SXH157`]" @click="u_c_SXH157_event_V0IC67($event)"></div>Facebook</div><div id="u_c_GJVV59"  v-if="pageData.shareList.map(item => item.type).includes('Line')" :class="[`normal`,`u_c_GJVV59`]" @click="u_c_GJVV59_event_V0IC67($event)"><div id="u_c_HA2M60"  :class="[`normal`,`u_c_HA2M60`]" @click="u_c_HA2M60_event_V0IC67($event)"></div>Line</div><div id="u_c_F1FS62"  v-if="pageData.shareList.map(item => item.type).includes('Kakao')" :class="[`normal`,`u_c_F1FS62`]" @click="u_c_F1FS62_event_V0IC67($event)"><div id="u_c_NVWC63"  :class="[`normal`,`u_c_NVWC63`]" @click="u_c_NVWC63_event_V0IC67($event)"></div>Kakao</div><div id="u_c_MHOE65"  v-if="pageData.shareList.map(item => item.type).includes('Naver')" :class="[`normal`,`u_c_MHOE65`]" @click="u_c_MHOE65_event_V0IC67($event)"><div id="u_c_H9WR66"  :class="[`normal`,`u_c_H9WR66`]" @click="u_c_H9WR66_event_V0IC67($event)"></div>Naver</div><div id="u_c_MPYF68"  v-if="pageData.shareList.map(item => item.type).includes('Vk')" :class="[`normal`,`u_c_MPYF68`]" @click="u_c_MPYF68_event_V0IC67($event)"><div id="u_c_U1D569"  :class="[`normal`,`u_c_U1D569`]" @click="u_c_U1D569_event_V0IC67($event)"></div>VK</div><div id="u_c_T86A71"  v-if="pageData.shareList.map(item => item.type).includes('System')" :class="[`normal`,`u_c_T86A71`]" @click="u_c_T86A71_event_V0IC67($event)"><div id="u_c_ORHK72"  :class="[`normal`,`u_c_ORHK72`]" @click="u_c_ORHK72_event_V0IC67($event)"></div>System</div></div><a id="u_c_AFO548" href="javascript:;" :class="[`normal`,`u_c_AFO548`]" @click="u_c_AFO548_event_V0IC67($event)">{{langData.copy}}</a><div id="u_c_OQAA50"  v-if="compData.copyTipsState" :class="[`normal popup-title-color`,`u_c_OQAA50`]" >{{langData.copySucc}}</div><a id="u_c_ICZ552" href="javascript:;" :class="[`normal popup-close`,`u_c_ICZ552`]" @click="u_c_ICZ552_event_DMX517($event)"></a></div></div><div id="u_c_OVDX367"  v-show="pageData.previewPopup == 'bind' || pageData.bindPopupState" :class="[`normal popup`,`u_c_OVDX367`]" @click="u_c_OVDX367_event_F8M123($event)"><div id="u_c_R9S3368"  :class="[`normal popup-content-big`,`u_c_R9S3368`]" @click="u_c_R9S3368_event_2MZ224($event)"><div id="u_c_B27A369"  :class="[`normal popup-title popup-title-color`,`u_c_B27A369`]" >{{`${ langData.bindTitle }`}}</div><div id="u_c_EFHB371"  :class="[`normal`,`u_c_EFHB371`]" ><div id="u_c_E548372"  :class="[`normal select-item `,`u_c_E548372`]" ><select id="u_c_S66Y373"  v-model="pageData.serverItem" :class="[`normal select-item-select select-item-option`,`u_c_S66Y373`]" ><option id="u_c_QFAK374" disabled="disabled" :value="defaultServerItem" :class="[`normal select-item-option`,`u_c_QFAK374`]" >{{`${ langData.selectServer }`}}</option><optgroup id="u_c_RCMS376"  :label="langData.yourServer" :class="[`normal select-item-option`,`u_c_RCMS376`]" ><option id="u_c_H8KL377"  v-for="(sItem, sIndex) in pageData.recentServerList" :key="sIndex" :value="sItem" :class="[`normal select-item-option`,`u_c_H8KL377`]" >{{`${ sItem.sname }`}}</option></optgroup><optgroup id="u_c_G2MY379"  :label="langData.allServer" :class="[`normal select-item-option`,`u_c_G2MY379`]" ><option id="u_c_BPQQ380"  v-for="(sItem, sIndex) in pageData.serverList" :key="sIndex" :value="sItem" :class="[`normal select-item-option`,`u_c_BPQQ380`]" >{{`${ sItem.sname }`}}</option></optgroup></select></div><div id="u_c_GYDD382"  :class="[`normal select-item`,`u_c_GYDD382`]" ><select id="u_c_DRLJ383"  v-model="pageData.roleIndex" :class="[`normal select-item-select select-item-option`,`u_c_DRLJ383`]" ><option id="u_c_PK28384"  v-for="(rItem, rIndex) in pageData.roleList" :key="rIndex" :value="rIndex" :class="[`normal select-item-option`,`u_c_PK28384`]" >{{`${ rItem.roleName }`}}</option></select></div></div><a id="u_c_954V386" href="javascript:;" :class="[`normal sure`,`u_c_954V386`]" @click="u_c_954V386_event_QSVC19($event)">{{`${ langData.bindBtn }`}}</a><div id="u_c_Q6CK388"  v-html="langData.canNoReBind" v-show="!pageData.canReBind" :class="[`normal txt-size tips-color`,`u_c_Q6CK388`]" ></div><a id="u_c_QNLO389" href="javascript:;" :class="[`normal popup-close`,`u_c_QNLO389`]" @click="u_c_QNLO389_event_DMX517($event)"></a></div></div><div id="u_c_NUO931"  v-show="pageData.breakTeamPopupState" :class="[`normal popup`,`u_c_NUO931`]" @click="u_c_NUO931_event_TETB35($event)"><div id="u_c_AMCZ32"  :class="[`normal popup-content-big`,`u_c_AMCZ32`]" @click="u_c_AMCZ32_event_U82518($event)"><div id="u_c_7TOD33"  :class="[`normal popup-title-color popup-title`,`u_c_7TOD33`]" >{{langData.breakSuccTips}}</div><a id="u_c_OWNH35" href="javascript:;" :class="[`normal sure`,`u_c_OWNH35`]" @click="u_c_OWNH35_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_UQRW38"  :class="[`normal txt-size tips-color`,`u_c_UQRW38`]" >{{langData.breakTips}}</div><a id="u_c_GD8Y37" href="javascript:;" :class="[`normal popup-close`,`u_c_GD8Y37`]" @click="u_c_GD8Y37_event_DMX517($event)"></a></div></div><div id="u_c_O19F42"  v-show="pageData.exitTeamPopupState" :class="[`normal popup`,`u_c_O19F42`]" @click="u_c_O19F42_event_TETB35($event)"><div id="u_c_5MKI43"  :class="[`normal popup-content-big`,`u_c_5MKI43`]" @click="u_c_5MKI43_event_U82518($event)"><div id="u_c_S93244"  :class="[`normal popup-title-color popup-title`,`u_c_S93244`]" >{{langData.teamExitTips}}</div><a id="u_c_UL5C46" href="javascript:;" :class="[`normal sure`,`u_c_UL5C46`]" @click="u_c_UL5C46_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_NEZ348"  :class="[`normal txt-size tips-color`,`u_c_NEZ348`]" >{{langData.teamTips}}</div><a id="u_c_16M150" href="javascript:;" :class="[`normal popup-close`,`u_c_16M150`]" @click="u_c_16M150_event_DMX517($event)"></a></div></div><div id="u_c_Q8ME51"  v-show="pageData.denyExitTeamPopupState" :class="[`normal popup`,`u_c_Q8ME51`]" @click="u_c_Q8ME51_event_TETB35($event)"><div id="u_c_0ALV52"  :class="[`normal popup-content-big`,`u_c_0ALV52`]" @click="u_c_0ALV52_event_U82518($event)"><div id="u_c_1CGX53"  :class="[`normal popup-title-color popup-title`,`u_c_1CGX53`]" >{{langData.teamExitDenyTips}}</div><a id="u_c_RZ6G55" href="javascript:;" :class="[`normal sure`,`u_c_RZ6G55`]" @click="u_c_RZ6G55_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><div id="u_c_45K757"  :class="[`normal txt-size tips-color`,`u_c_45K757`]" >{{langData.teamTips}}</div><a id="u_c_8IJG59" href="javascript:;" :class="[`normal popup-close`,`u_c_8IJG59`]" @click="u_c_8IJG59_event_DMX517($event)"></a></div></div><div id="u_c_O92G390"  v-show="pageData.previewPopup == 'tips' || pageData.tipsPopupState" :class="[`normal popup`,`u_c_O92G390`]" @click="u_c_O92G390_event_TETB35($event)"><div id="u_c_EGF4391"  :class="[`normal popup-content-big`,`u_c_EGF4391`]" @click="u_c_EGF4391_event_U82518($event)"><div id="u_c_TL1N392"  v-html="pageData.tips" :class="[`normal popup-title-color popup-title`,`u_c_TL1N392`]" ></div><a id="u_c_QFPE394" href="javascript:;" :class="[`normal sure`,`u_c_QFPE394`]" @click="u_c_QFPE394_event_V0IC67($event)">{{`${ langData.sureBtn }`}}</a><a id="u_c_QUWX396" href="javascript:;" :class="[`normal popup-close`,`u_c_QUWX396`]" @click="u_c_QUWX396_event_DMX517($event)"></a></div></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Language from "@/hooks/language.js";
import Router from "@/hooks/router.js";
import bridge from "@/utils/sdkBridge.js";
import { useRoute } from 'vue-router';
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import useClipboard from "vue-clipboard3"

    const { curLang, getLangTxt,langData } = Language();
    const routerData = inject("routerData",{});
    const pageData = inject("pageData", {});
    const COMP_DATA_LANG = {"default":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"zh-CN":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"zh-TW":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"en-US":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"ja-JP":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"ko-KR":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"th-TH":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"vi-VN":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"de-DE":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"fr-FR":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"ru-RU":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"es-ES":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"pt-PT":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"it-IT":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"tr-TR":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"pl-PL":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"id-ID":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`},"ar-SA":{"infoContent":"123123","copyTipsState":false,"previewPopup":`tips`}};
    const compData = reactive(COMP_DATA_LANG[curLang] || COMP_DATA_LANG['en-US']||{});
    let pagePlatform = "global"
    const router = Router();
    const route = useRoute();
    const compName = '全局弹窗';

    // 自定义setup - 开始
    const {
  toClipboard
} = useClipboard();
let hasLoadServer = false;
const showTips = inject("showTips", (txt, code) => {})
const checkIsBind = inject("checkIsBind", () => {})
const checkIsLogin = inject("checkIsLogin", () => {})
const giftInfo = inject("giftInfo", {})
const getCurLink = inject("getCurLink", (link) => {})
const inviteBind = inject("inviteBind", () => {})
const initActivity = inject("initActivity", () => {})
const listData = inject("listData", {})
const isIosAppWebview = window?.webkit?.messageHandlers?.callSDKMethodWithParameters;
const ticketShare = inject("ticketShare", () => {});
const defaultServerItem = [
  {
    sid: "",
    id: "",
    sname: ""
  },
]
const defaultRoleItem = [{
  roleID: "",
  roleName: getLangTxt("selectRole")
}]
const curPlatform = utils.getMainHost() == "gm99.com" ? "gm99" : "global"

const init = () => {
  compData.bindPopupState = false
  compData.bagPopupState = false
  compData.infoPopupState = false
  compData.tipsPopupState = false
  compData.propsPopupState = false
  compData.quanPopupState = false
  compData.seeGiftPopupState = false
  compData.giftCodePopupState = false
  compData.previewPopup = "";

  pageData.serverList = _.cloneDeep(defaultServerItem)
  pageData.roleList = _.cloneDeep(defaultRoleItem)

}

init()

watch(
  () => pageData.bindPopupState,
  async (value) => {
    // if (hasLoadServer) return;
    if (!value) return;
    await initServerList();
    initLinkServer();
    hasLoadServer = true;
  }
)

watch(
  () => pageData.serverItem,
  async (value) => {
    if (!value || !value.sid) return
    await initRoleList()
    initLinkRole()
  }
)

const initServerList = async () => {
  pageData.serverList = []
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=listServerNew`,
    omnion: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=listServerNew`,
  }
  let res = await request.getJSON(link[curPlatform])
  if (res.result == 1) {
    res?.data?.all_servers ?
      pageData.serverList.push(...res.data.all_servers) :
      "";
    res?.data?.recent_servers ?
      pageData.recentServerList.push(...res.data.recent_servers) :
      "";
  }
}

const initRoleList = async () => {
  pageData.roleList = _.cloneDeep(defaultRoleItem)
  const link = {
    global: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
    gm99: `//eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=getMobileGameRole`,
    omnion: `//gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=getMobileGameRole`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.sid,
    }),
  })
  if (res.result == 1) {
    pageData.roleList.push(...res.data)
    if (res.data.length == 1) {
      pageData.roleIndex = 1
    }
  }
}

const initLinkServer = () => {
  let linkParam =
    utils.getUrlParams("serverId") ||
    utils.getUrlParams("server_id") ||
    utils.getUrlParams("serverID")
  let _index = 0
  for (let i in pageData.serverList) {
    if (pageData.serverList[i].id == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.serverItem = pageData.serverList[_index];
  }
}

const initLinkRole = () => {
  let linkParam =
    utils.getUrlParams("roleId") || utils.getUrlParams("roleID")
  let _index = 0
  for (let i in pageData.roleList) {
    if (pageData.roleList[i].roleID == linkParam) {
      _index = i
      break
    }
  }
  if (_index > 0) {
    pageData.roleIndex = _index
  }
}

const canClickBindSubmit = ref(true)
const canClickInviteBind = ref(true)
const bindRole = async () => {
  const link = {
    global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
    gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=bind`,
    omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
      pageData.pageId
    }&action=bind`,
  }
  let res = await request.getJSON(link[curPlatform], {
    params: JSON.stringify({
      server_id: pageData.serverItem.id,
      server_sid: pageData.serverItem.sid,
      role_id: pageData.roleList[pageData.roleIndex].roleID,
      role_name: encodeURIComponent(encodeURIComponent(pageData.roleList[pageData.roleIndex].roleName)),
      server_name: pageData.serverItem.sname,
      language: curLang,
    }),
  })
  if (res.result == 1) {
    pageData.serverName = res.data.bindData.server_name;
    pageData.roleName = res.data.bindData.role_name;
    pageData.bindPopupState = false
    pageData.isBind = true
    initActivity()
    try {
      window.__updatePointUploadCookie(
        "role_id",
        res.data.bind_data.role_id
      )
      window.__updatePointUploadCookie(
        "role_name",
        res.data.bind_data.role_name
      )
      window.__updatePointUploadCookie(
        "server_id",
        res.data.bind_data.server_id
      )
    } catch (error) {}
  } else {
    showTips(getLangTxt(res.code, getLangTxt("common")), res.code)
  }
}
watch(() => compData.copyTipsState, value => {
  if (value) {
    setTimeout(() => {
      compData.copyTipsState = false;
    }, 2000)
  }
});
      // 背包弹窗的click事件
      const u_c_93BI150_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_S1GB151_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 查看的click事件
      const u_c_RPCD168_event_1JVM17= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 复制并前往的click事件
      const u_c_QJ7T170_event_QX7K17= async (e,code)=>{
        try {try{
  await toClipboard(code);
}catch(e){}

bridge.open(pageData.exchangeLink,"_self")} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_JEBZ173_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 上期排行榜单弹窗的click事件
      const u_c_4FYP175_event_F8M123= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_TUG9176_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_6N1J198_event_DMX517= async (e)=>{
        try {pageData.bagPopupState = false} catch (error) {console.log(error)}
      };
      // 查看小队信息弹窗的click事件
      const u_c_N5TX48_event_F8M123= async (e)=>{
        try {pageData.teamInfoPopupState = false} catch (error) {console.log(error)}
      };
      // 背包弹窗内容的click事件
      const u_c_O2L649_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_VR7N71_event_DMX517= async (e)=>{
        try {pageData.teamInfoPopupState = false} catch (error) {console.log(error)}
      };
      // 邀请记录弹窗的click事件
      const u_c_L29Z174_event_F8M123= async (e)=>{
        try {pageData.inviteLogPopupState = false} catch (error) {console.log(error)}
      };
      // 邀请弹窗内容的click事件
      const u_c_CJ7W175_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_P7ST192_event_DMX517= async (e)=>{
        try {pageData.inviteLogPopupState = false} catch (error) {console.log(error)}
      };
      // 任务日志弹窗的click事件
      const u_c_A7J224_event_F8M123= async (e)=>{
        try {pageData.taskLogPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_ZBE225_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_A5AZ42_event_DMX517= async (e)=>{
        try {pageData.taskLogPopupState = false} catch (error) {console.log(error)}
      };
      // 该玩家的邀请人经验值明细弹窗的click事件
      const u_c_JMGQ193_event_F8M123= async (e)=>{
        try {pageData.inviterTaskLogPopupState = false} catch (error) {console.log(error)}
      };
      // 邀请弹窗内容的click事件
      const u_c_BNUG194_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_HVLV215_event_DMX517= async (e)=>{
        try {pageData.inviterTaskLogPopupState = false} catch (error) {console.log(error)}
      };
      // 该玩家的受邀请人经验值明细弹窗的click事件
      const u_c_C5IC216_event_F8M123= async (e)=>{
        try {pageData.inviteeTaskLogPopupState = false} catch (error) {console.log(error)}
      };
      // 邀请弹窗内容的click事件
      const u_c_BV7B217_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_BDAJ238_event_DMX517= async (e)=>{
        try {pageData.inviteeTaskLogPopupState = false} catch (error) {console.log(error)}
      };
      // 被邀请玩家的受邀请人经验值明细弹窗的click事件
      const u_c_FMGB239_event_F8M123= async (e)=>{
        try {pageData.inviteeOtherPopupState = false} catch (error) {console.log(error)}
      };
      // 邀请弹窗内容的click事件
      const u_c_95KO240_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_C3YB265_event_DMX517= async (e)=>{
        try {pageData.inviteeOtherPopupState = false} catch (error) {console.log(error)}
      };
      // 查看奖励弹窗的click事件
      const u_c_TT13266_event_TETB35= async (e)=>{
        try {pageData.seeGiftPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_BR8S267_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_SN0I278_event_DMX517= async (e)=>{
        try {pageData.seeGiftPopupState = false} catch (error) {console.log(error)}
      };
      // 道具领取成功弹窗的click事件
      const u_c_HD05279_event_TETB35= async (e)=>{
        try {pageData.propsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_BAIN280_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_BT5T287_event_YU9U68= async (e)=>{
        try {pageData.propsPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_MECU290_event_DMX517= async (e)=>{
        try {pageData.propsPopupState = false} catch (error) {console.log(error)}
      };
      // 实体奖励领取成功弹窗的click事件
      const u_c_4KIA91_event_TETB35= async (e)=>{
        try {pageData.materialPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_VSBS92_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_ZPDQ99_event_YU9U68= async (e)=>{
        try {pageData.materialPopupState = false;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_OMDX102_event_DMX517= async (e)=>{
        try {pageData.materialPopupState = false} catch (error) {console.log(error)}
      };
      // 优惠券领取成功弹窗的click事件
      const u_c_OMHF291_event_TETB35= async (e)=>{
        try {pageData.quanPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_GZL0292_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_MNYN299_event_35V252= async (e)=>{
        try {bridge.open(pageData.storeLink)} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_NS1R301_event_DMX517= async (e)=>{
        try {pageData.quanPopupState = false} catch (error) {console.log(error)}
      };
      // 序列号领取成功弹窗的click事件
      const u_c_HLVO302_event_TXZS38= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_TEW3303_event_EKU139= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_NP13309_event_QX7K17= async (e)=>{
        try {await toClipboard(pageData.curGiftName);
compData.copyTipsState = true;} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_D7Y3313_event_KBHJ41= async (e)=>{
        try {pageData.giftCodePopupState = false} catch (error) {console.log(error)}
      };
      // 前往兑换的click事件
      const u_c_ATIJ314_event_YU9U68= async (e)=>{
        try {try{
  await toClipboard(pageData.curGiftName);
  compData.copyTipsState = true;
  await utils.sleep(1)
}catch(e){}

bridge.open(pageData.exchangeLink,"_self")} catch (error) {console.log(error)}
      };
      // 输入邀请码弹窗的click事件
      const u_c_NX07322_event_TETB35= async (e)=>{
        try {pageData.inviteBindPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_O43Z323_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_F8EP327_event_DMX517= async (e)=>{
        try {pageData.inviteBindPopupState = false} catch (error) {console.log(error)}
      };
      // 绑定按钮的click事件
      const u_c_RWPA330_event_V0IC67= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "确认按钮",
  eventReason: '输入邀请码弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await inviteBind(pageData.inviteCodeUrl)
pageData.inviteBindPopupState=false} catch (error) {console.log(error)}
      };
      // 门票分享弹窗的click事件
      const u_c_AWZN29_event_TETB35= async (e)=>{
        try {pageData.inviteBindPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_9AEY30_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_KAV634_event_DMX517= async (e)=>{
        try {pageData.shareTicketPopupState = false} catch (error) {console.log(error)}
      };
      // 保存图片的click事件
      const u_c_A5IO37_event_V0IC67= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "保存图片",
  eventReason: '门票分享弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})

const isSpecificWebView = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/FBAN|FBAV|Facebook/i.test(userAgent)) {
        return "Facebook";
    } else if (/Twitter/i.test(userAgent)) {
        return "Twitter";
    } else if (/Line/i.test(userAgent)) {
        return "LINE";
    } else if (/Discord/i.test(userAgent)) {
        return "Discord";
    }

    return null;
}

// FB 安卓下提示外部打开
const isFBAndroid =
  isSpecificWebView() && /Android/.test(navigator.userAgent);
if (isFBAndroid) {
  showTips(langData.openOuterTips);
  return;
}

// 下载图片 
const link = document.createElement("a");
link.href = pageData.canvasImg;
link.download = "ticket";
link.click();} catch (error) {console.log(error)}
      };
      // 复制的click事件
      const u_c_07SK51_event_V0IC67= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "复制按钮",
  eventReason: '门票分享弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
// 开始复制 todo
 await toClipboard(langData.copyTag);} catch (error) {console.log(error)}
      };
      // 分享到FB的click事件
      const u_c_MGM958_event_V0IC67= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "分享到FB",
  eventReason: '门票分享弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
let link =
  curLang === "zh-TW" ?
  "https://www.facebook.com/PnS.TW" :
  "https://www.facebook.com/PnS.37Games/";
window.open(link);} catch (error) {console.log(error)}
      };
      // 分享到Discord的click事件
      const u_c_DFSO19_event_V0IC67= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "分享到Discord",
  eventReason: '门票分享弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
window.open("https://discord.com/invite/puzzlesandsurvival");} catch (error) {console.log(error)}
      };
      // 分享到X的click事件
      const u_c_4CUK19_event_V0IC67= async (e)=>{
        try {window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "分享到 X",
  eventReason: '门票分享弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
window.open("https://x.com/37games_pnsjp");} catch (error) {console.log(error)}
      };
      // 收到的邀请信息弹窗的click事件
      const u_c_DF8T332_event_TETB35= async (e)=>{
        try {pageData.inviteMessagePopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_EQD4333_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_NRD6342_event_V0IC67= async (e)=>{
        try {if (!checkIsLogin()) return;
if (!checkIsBind()) return;
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "确认按钮",
  eventReason: '收到组队邀请弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
await inviteBind(pageData.inviteCodeUrl)
pageData.inviteMessagePopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_QE3E346_event_DMX517= async (e)=>{
        try {pageData.inviteMessagePopupState = false} catch (error) {console.log(error)}
      };
      // 生成邀请信息弹窗的click事件
      const u_c_PPX633_event_TETB35= async (e)=>{
        try {pageData.toInvitePopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_ODH034_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 分享渠道的click事件
      const u_c_QKY052_event_Z18221= async (e)=>{
        try {} catch (error) {console.log(error)}
      };
      // 分享-Twitter的click事件
      const u_c_EMSF53_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享item的click事件
      const u_c_LQQC54_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-Facebook的click事件
      const u_c_U47W56_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享item的click事件
      const u_c_SXH157_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-Line的click事件
      const u_c_GJVV59_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享item的click事件
      const u_c_HA2M60_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-Kakao的click事件
      const u_c_F1FS62_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享item的click事件
      const u_c_NVWC63_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-Naver的click事件
      const u_c_MHOE65_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-item的click事件
      const u_c_H9WR66_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-VK的click事件
      const u_c_MPYF68_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-item的click事件
      const u_c_U1D569_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享-系统的click事件
      const u_c_T86A71_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 分享item的click事件
      const u_c_ORHK72_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 复制按钮的click事件
      const u_c_AFO548_event_V0IC67= async (e)=>{
        try {try{
  await toClipboard(pageData.inviteLink);
    compData.copyTipsState = true
}catch(e){}
} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_ICZ552_event_DMX517= async (e)=>{
        try {pageData.toInvitePopupState = false} catch (error) {console.log(error)}
      };
      // 绑定弹窗的click事件
      const u_c_OVDX367_event_F8M123= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 弹窗内容的click事件
      const u_c_R9S3368_event_2MZ224= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认绑定的click事件
      const u_c_954V386_event_QSVC19= async (e)=>{
        try {if (!pageData.serverItem || !pageData.serverItem.sid) {
  alert(getLangTxt("selectServer"))
  return
}
if (!pageData.roleIndex) {
  alert(getLangTxt("selectRole"))
  return
}
if (!canClickBindSubmit.value) return
canClickBindSubmit.value = false
await bindRole()
canClickBindSubmit.value = true} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_QNLO389_event_DMX517= async (e)=>{
        try {pageData.bindPopupState = false} catch (error) {console.log(error)}
      };
      // 解散队伍提示弹窗的click事件
      const u_c_NUO931_event_TETB35= async (e)=>{
        try {pageData.breakTeamPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_AMCZ32_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_OWNH35_event_V0IC67= async (e)=>{
        try {const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=breakTeam`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=breakTeam`,
  omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=breakTeam`,
};
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "确认按钮",
  eventReason: '解散队伍弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
let res = await request.getJSON(link[curPlatform]);
if (res?.result != 1) {
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
  return;
}
await initActivity();
pageData.breakTeamPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_GD8Y37_event_DMX517= async (e)=>{
        try {pageData.breakTeamPopupState = false} catch (error) {console.log(error)}
      };
      // 退出队伍确认弹窗的click事件
      const u_c_O19F42_event_TETB35= async (e)=>{
        try {pageData.exitTeamPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_5MKI43_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_UL5C46_event_V0IC67= async (e)=>{
        try {const link = {
  gm99: `https://eventsapi.gm99.com/activity/execute?name=${pageData.pageId}&action=exitTeam`,
  global: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=exitTeam`,
  omnion: `https://gactivityapi.${utils.getMainHost()}/activity/execute?name=${
    pageData.pageId
  }&action=exitTeam`,
};
window.activityDataLayer.push({
  eventName: "click_button",
  eventType: "确认按钮",
  eventReason: '退出队伍弹窗',
  gameId: pageData.gameId,
  aid: pageData.pageId,
})
let res = await request.getJSON(link[curPlatform]);
if (res?.result != 1) {
  showTips(getLangTxt(res.code, getLangTxt("common")), res.code);
  return;
}
await initActivity();
pageData.exitTeamPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_16M150_event_DMX517= async (e)=>{
        try {pageData.exitTeamPopupState = false} catch (error) {console.log(error)}
      };
      // 不可退出队伍提示弹窗的click事件
      const u_c_Q8ME51_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_0ALV52_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_RZ6G55_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_8IJG59_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 提示语弹窗的click事件
      const u_c_O92G390_event_TETB35= async (e)=>{
        try {pageData.tipsPopupState=false} catch (error) {console.log(error)}
      };
      // 弹窗框的click事件
      const u_c_EGF4391_event_U82518= async (e)=>{
        try {e.stopPropagation();} catch (error) {console.log(error)}
      };
      // 确认按钮的click事件
      const u_c_QFPE394_event_V0IC67= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      };
      // 关闭按钮的click事件
      const u_c_QUWX396_event_DMX517= async (e)=>{
        try {pageData.tipsPopupState = false} catch (error) {console.log(error)}
      }
    // 自定义setup - 结束


</script>
<style lang="scss" scoped>
.default{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.default{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.default{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_EZ6A156.normal{
position:relative;

}
}.default{
.u_c_MJVL157.normal{
position:relative;

}
}.default{
.u_c_LU2L159.normal{
position:relative;

}
}.default{
.u_c_KB6X161.normal{
position:relative;

}
}.default{
.u_c_GIVF162.normal{
position:relative;

}
}.default{
.u_c_O6EY163.normal{
position:relative;

}
}.default{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_L9U2167.normal{
position:relative;

}
}.default{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.default{
.u_c_QJ7T170.normal{
position:relative;

}
}.default{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.default{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.default{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.default{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.default{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_U8C4201.normal{
position:relative;

}
}.default{
.u_c_OKFQ202.normal{
position:relative;

}
}.default{
.u_c_7CQY204.normal{
position:relative;

}
}.default{
.u_c_PTZN206.normal{
position:relative;

}
}.default{
.u_c_VRV4208.normal{
position:relative;

}
}.default{
.u_c_Z2F7210.normal{
position:relative;

}
}.default{
.u_c_3NW0211.normal{
position:relative;

}
}.default{
.u_c_PAQY212.normal{
position:relative;

}
}.default{
.u_c_TQ08214.normal{
position:relative;

}
}.default{
.u_c_QZ3T216.normal{
position:relative;

}
}.default{
.u_c_WUCL218.normal{
position:relative;

}
}.default{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.default{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_N0O054.normal{
position:relative;

}
}.default{
.u_c_NTM477.normal{
position:relative;

}
}.default{
.u_c_N48357.normal{
position:relative;

}
}.default{
.u_c_IOWX59.normal{
position:relative;

}
}.default{
.u_c_MSKH60.normal{
position:relative;

}
}.default{
.u_c_RQ1579.normal{
position:relative;

}
}.default{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.default{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.default{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_HI7Z180.normal{
position:relative;

}
}.default{
.u_c_D7T4181.normal{
position:relative;

}
}.default{
.u_c_I55Y183.normal{
position:relative;

}
}.default{
.u_c_OUV7185.normal{
position:relative;

}
}.default{
.u_c_IJRB186.normal{
position:relative;

}
}.default{
.u_c_OPFB187.normal{
position:relative;

}
}.default{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.default{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.default{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_7TVH30.normal{
position:relative;

}
}.default{
.u_c_4FNG31.normal{
position:relative;

}
}.default{
.u_c_4BRN33.normal{
position:relative;

}
}.default{
.u_c_0PDC35.normal{
position:relative;

}
}.default{
.u_c_CLRM36.normal{
position:relative;

}
}.default{
.u_c_6DO837.normal{
position:relative;

}
}.default{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.default{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.default{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.default{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_IO9N199.normal{
position:relative;

}
}.default{
.u_c_IOVB200.normal{
position:relative;

}
}.default{
.u_c_U7GV202.normal{
position:relative;

}
}.default{
.u_c_9ZDW204.normal{
position:relative;

}
}.default{
.u_c_MH8K206.normal{
position:relative;

}
}.default{
.u_c_OBVL207.normal{
position:relative;

}
}.default{
.u_c_ML07208.normal{
position:relative;

}
}.default{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.default{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.default{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_TKH9222.normal{
position:relative;

}
}.default{
.u_c_F50B223.normal{
position:relative;

}
}.default{
.u_c_ISPG225.normal{
position:relative;

}
}.default{
.u_c_MWES227.normal{
position:relative;

}
}.default{
.u_c_QJSK229.normal{
position:relative;

}
}.default{
.u_c_OS9P230.normal{
position:relative;

}
}.default{
.u_c_D5FO231.normal{
position:relative;

}
}.default{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.default{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.default{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.default{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.default{
.u_c_H8Z1245.normal{
position:relative;

}
}.default{
.u_c_DG2T246.normal{
position:relative;

}
}.default{
.u_c_A3HT248.normal{
position:relative;

}
}.default{
.u_c_SP4I250.normal{
position:relative;

}
}.default{
.u_c_TQBB252.normal{
position:relative;

}
}.default{
.u_c_BPDA254.normal{
position:relative;

}
}.default{
.u_c_BG5S255.normal{
position:relative;

}
}.default{
.u_c_PCW6256.normal{
position:relative;

}
}.default{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.default{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.default{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.default{
.u_c_TT13266.normal{
position:relative;

}
}.default{
.u_c_BR8S267.normal{
position:relative;

}
}.default{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.default{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.default{
.u_c_F9EU272.normal{
position:relative;

}
}.default{
.u_c_JNPQ273.normal{
position:relative;

}
}.default{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.default{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.default{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.default{
.u_c_9W0637.normal{
position:relative;

}
}.default{
.u_c_OWKT38.normal{
position:relative;

}
}.default{
.u_c_HBXK40.normal{
position:relative;

}
}.default{
.u_c_E33R42.normal{
position:relative;

}
}.default{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.default{
.u_c_HD05279.normal{
position:relative;

}
}.default{
.u_c_BAIN280.normal{
position:relative;

}
}.default{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.default{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.default{
.u_c_JV9F284.normal{
position:relative;

}
}.default{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.default{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.default{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.default{
.u_c_4KIA91.normal{
position:relative;

}
}.default{
.u_c_VSBS92.normal{
position:relative;

}
}.default{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.default{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.default{
.u_c_LRU896.normal{
position:relative;

}
}.default{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.default{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.default{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.default{
.u_c_OMHF291.normal{
position:relative;

}
}.default{
.u_c_GZL0292.normal{
position:relative;

}
}.default{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.default{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.default{
.u_c_SMOH296.normal{
position:relative;

}
}.default{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.default{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.default{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.default{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_TEW3303.normal{
position:relative;

}
}.default{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.default{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.default{
.u_c_FCR3307.normal{
position:relative;

}
}.default{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.default{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.default{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.default{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.default{
.u_c_NX07322.normal{
position:relative;

}
}.default{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.default{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.default{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.default{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.default{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.default{
.u_c_AWZN29.normal{
position:relative;

}
}.default{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.default{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.default{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.default{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.default{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.default{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.default{
.u_c_2OTG19.normal{
position:relative;

}
}.default{
.u_c_N5XH81.normal{
position:relative;

}
}.default{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.default{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.default{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.default{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.default{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.default{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.default{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_DF8T332.normal{
position:relative;

}
}.default{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.default{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.default{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.default{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.default{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.default{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.default{
.u_c_PPX633.normal{
position:relative;

}
}.default{
.u_c_ODH034.normal{
position:relative;

}
}.default{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.default{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.default{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.default{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.default{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.default{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.default{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.default{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.default{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.default{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.default{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.default{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.default{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.default{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.default{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.default{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.default{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.default{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.default{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.default{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.default{
.u_c_E548372.normal{
position:relative;

}
}.default{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_GYDD382.normal{
position:relative;

}
}.default{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.default{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.default{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.default{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.default{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.default{
.u_c_AMCZ32.normal{
position:relative;

}
}.default{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.default{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.default{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.default{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.default{
.u_c_5MKI43.normal{
position:relative;

}
}.default{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.default{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.default{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.default{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.default{
.u_c_0ALV52.normal{
position:relative;

}
}.default{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.default{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.default{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.default{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.default{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.default{
.u_c_EGF4391.normal{
position:relative;

}
}.default{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.default{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.default{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-CN{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.zh-CN{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.zh-CN{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_EZ6A156.normal{
position:relative;

}
}.zh-CN{
.u_c_MJVL157.normal{
position:relative;

}
}.zh-CN{
.u_c_LU2L159.normal{
position:relative;

}
}.zh-CN{
.u_c_KB6X161.normal{
position:relative;

}
}.zh-CN{
.u_c_GIVF162.normal{
position:relative;

}
}.zh-CN{
.u_c_O6EY163.normal{
position:relative;

}
}.zh-CN{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.zh-CN{
.u_c_L9U2167.normal{
position:relative;

}
}.zh-CN{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.zh-CN{
.u_c_QJ7T170.normal{
position:relative;

}
}.zh-CN{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.zh-CN{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.zh-CN{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.zh-CN{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.zh-CN{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_U8C4201.normal{
position:relative;

}
}.zh-CN{
.u_c_OKFQ202.normal{
position:relative;

}
}.zh-CN{
.u_c_7CQY204.normal{
position:relative;

}
}.zh-CN{
.u_c_PTZN206.normal{
position:relative;

}
}.zh-CN{
.u_c_VRV4208.normal{
position:relative;

}
}.zh-CN{
.u_c_Z2F7210.normal{
position:relative;

}
}.zh-CN{
.u_c_3NW0211.normal{
position:relative;

}
}.zh-CN{
.u_c_PAQY212.normal{
position:relative;

}
}.zh-CN{
.u_c_TQ08214.normal{
position:relative;

}
}.zh-CN{
.u_c_QZ3T216.normal{
position:relative;

}
}.zh-CN{
.u_c_WUCL218.normal{
position:relative;

}
}.zh-CN{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.zh-CN{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_N0O054.normal{
position:relative;

}
}.zh-CN{
.u_c_NTM477.normal{
position:relative;

}
}.zh-CN{
.u_c_N48357.normal{
position:relative;

}
}.zh-CN{
.u_c_IOWX59.normal{
position:relative;

}
}.zh-CN{
.u_c_MSKH60.normal{
position:relative;

}
}.zh-CN{
.u_c_RQ1579.normal{
position:relative;

}
}.zh-CN{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.zh-CN{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.zh-CN{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.zh-CN{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_HI7Z180.normal{
position:relative;

}
}.zh-CN{
.u_c_D7T4181.normal{
position:relative;

}
}.zh-CN{
.u_c_I55Y183.normal{
position:relative;

}
}.zh-CN{
.u_c_OUV7185.normal{
position:relative;

}
}.zh-CN{
.u_c_IJRB186.normal{
position:relative;

}
}.zh-CN{
.u_c_OPFB187.normal{
position:relative;

}
}.zh-CN{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.zh-CN{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.zh-CN{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.zh-CN{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_7TVH30.normal{
position:relative;

}
}.zh-CN{
.u_c_4FNG31.normal{
position:relative;

}
}.zh-CN{
.u_c_4BRN33.normal{
position:relative;

}
}.zh-CN{
.u_c_0PDC35.normal{
position:relative;

}
}.zh-CN{
.u_c_CLRM36.normal{
position:relative;

}
}.zh-CN{
.u_c_6DO837.normal{
position:relative;

}
}.zh-CN{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.zh-CN{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-CN{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.zh-CN{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_IO9N199.normal{
position:relative;

}
}.zh-CN{
.u_c_IOVB200.normal{
position:relative;

}
}.zh-CN{
.u_c_U7GV202.normal{
position:relative;

}
}.zh-CN{
.u_c_9ZDW204.normal{
position:relative;

}
}.zh-CN{
.u_c_MH8K206.normal{
position:relative;

}
}.zh-CN{
.u_c_OBVL207.normal{
position:relative;

}
}.zh-CN{
.u_c_ML07208.normal{
position:relative;

}
}.zh-CN{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.zh-CN{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.zh-CN{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_TKH9222.normal{
position:relative;

}
}.zh-CN{
.u_c_F50B223.normal{
position:relative;

}
}.zh-CN{
.u_c_ISPG225.normal{
position:relative;

}
}.zh-CN{
.u_c_MWES227.normal{
position:relative;

}
}.zh-CN{
.u_c_QJSK229.normal{
position:relative;

}
}.zh-CN{
.u_c_OS9P230.normal{
position:relative;

}
}.zh-CN{
.u_c_D5FO231.normal{
position:relative;

}
}.zh-CN{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-CN{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.zh-CN{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-CN{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.zh-CN{
.u_c_H8Z1245.normal{
position:relative;

}
}.zh-CN{
.u_c_DG2T246.normal{
position:relative;

}
}.zh-CN{
.u_c_A3HT248.normal{
position:relative;

}
}.zh-CN{
.u_c_SP4I250.normal{
position:relative;

}
}.zh-CN{
.u_c_TQBB252.normal{
position:relative;

}
}.zh-CN{
.u_c_BPDA254.normal{
position:relative;

}
}.zh-CN{
.u_c_BG5S255.normal{
position:relative;

}
}.zh-CN{
.u_c_PCW6256.normal{
position:relative;

}
}.zh-CN{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-CN{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-CN{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-CN{
.u_c_TT13266.normal{
position:relative;

}
}.zh-CN{
.u_c_BR8S267.normal{
position:relative;

}
}.zh-CN{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.zh-CN{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-CN{
.u_c_F9EU272.normal{
position:relative;

}
}.zh-CN{
.u_c_JNPQ273.normal{
position:relative;

}
}.zh-CN{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.zh-CN{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.zh-CN{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-CN{
.u_c_9W0637.normal{
position:relative;

}
}.zh-CN{
.u_c_OWKT38.normal{
position:relative;

}
}.zh-CN{
.u_c_HBXK40.normal{
position:relative;

}
}.zh-CN{
.u_c_E33R42.normal{
position:relative;

}
}.zh-CN{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-CN{
.u_c_HD05279.normal{
position:relative;

}
}.zh-CN{
.u_c_BAIN280.normal{
position:relative;

}
}.zh-CN{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.zh-CN{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.zh-CN{
.u_c_JV9F284.normal{
position:relative;

}
}.zh-CN{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.zh-CN{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-CN{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-CN{
.u_c_4KIA91.normal{
position:relative;

}
}.zh-CN{
.u_c_VSBS92.normal{
position:relative;

}
}.zh-CN{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.zh-CN{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.zh-CN{
.u_c_LRU896.normal{
position:relative;

}
}.zh-CN{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.zh-CN{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-CN{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-CN{
.u_c_OMHF291.normal{
position:relative;

}
}.zh-CN{
.u_c_GZL0292.normal{
position:relative;

}
}.zh-CN{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.zh-CN{
.u_c_SMOH296.normal{
position:relative;

}
}.zh-CN{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-CN{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-CN{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.zh-CN{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_TEW3303.normal{
position:relative;

}
}.zh-CN{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.zh-CN{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.zh-CN{
.u_c_FCR3307.normal{
position:relative;

}
}.zh-CN{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.zh-CN{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.zh-CN{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.zh-CN{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-CN{
.u_c_NX07322.normal{
position:relative;

}
}.zh-CN{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.zh-CN{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.zh-CN{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.zh-CN{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.zh-CN{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-CN{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.zh-CN{
.u_c_AWZN29.normal{
position:relative;

}
}.zh-CN{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.zh-CN{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.zh-CN{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.zh-CN{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.zh-CN{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.zh-CN{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.zh-CN{
.u_c_2OTG19.normal{
position:relative;

}
}.zh-CN{
.u_c_N5XH81.normal{
position:relative;

}
}.zh-CN{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.zh-CN{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.zh-CN{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.zh-CN{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.zh-CN{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.zh-CN{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.zh-CN{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.zh-CN{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.zh-CN{
.u_c_DF8T332.normal{
position:relative;

}
}.zh-CN{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.zh-CN{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.zh-CN{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.zh-CN{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.zh-CN{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.zh-CN{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.zh-CN{
.u_c_PPX633.normal{
position:relative;

}
}.zh-CN{
.u_c_ODH034.normal{
position:relative;

}
}.zh-CN{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.zh-CN{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.zh-CN{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.zh-CN{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.zh-CN{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.zh-CN{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.zh-CN{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.zh-CN{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.zh-CN{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.zh-CN{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.zh-CN{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.zh-CN{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.zh-CN{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.zh-CN{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-CN{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.zh-CN{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.zh-CN{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-CN{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.zh-CN{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.zh-CN{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.zh-CN{
.u_c_E548372.normal{
position:relative;

}
}.zh-CN{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_GYDD382.normal{
position:relative;

}
}.zh-CN{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-CN{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.zh-CN{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-CN{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.zh-CN{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.zh-CN{
.u_c_AMCZ32.normal{
position:relative;

}
}.zh-CN{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.zh-CN{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.zh-CN{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-CN{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.zh-CN{
.u_c_5MKI43.normal{
position:relative;

}
}.zh-CN{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.zh-CN{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.zh-CN{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-CN{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.zh-CN{
.u_c_0ALV52.normal{
position:relative;

}
}.zh-CN{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.zh-CN{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.zh-CN{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.zh-CN{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-CN{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.zh-CN{
.u_c_EGF4391.normal{
position:relative;

}
}.zh-CN{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.zh-CN{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.zh-CN{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-TW{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.zh-TW{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.zh-TW{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_EZ6A156.normal{
position:relative;

}
}.zh-TW{
.u_c_MJVL157.normal{
position:relative;

}
}.zh-TW{
.u_c_LU2L159.normal{
position:relative;

}
}.zh-TW{
.u_c_KB6X161.normal{
position:relative;

}
}.zh-TW{
.u_c_GIVF162.normal{
position:relative;

}
}.zh-TW{
.u_c_O6EY163.normal{
position:relative;

}
}.zh-TW{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_L9U2167.normal{
position:relative;

}
}.zh-TW{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.zh-TW{
.u_c_QJ7T170.normal{
position:relative;

}
}.zh-TW{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.zh-TW{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.zh-TW{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.zh-TW{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.zh-TW{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_U8C4201.normal{
position:relative;

}
}.zh-TW{
.u_c_OKFQ202.normal{
position:relative;

}
}.zh-TW{
.u_c_7CQY204.normal{
position:relative;

}
}.zh-TW{
.u_c_PTZN206.normal{
position:relative;

}
}.zh-TW{
.u_c_VRV4208.normal{
position:relative;

}
}.zh-TW{
.u_c_Z2F7210.normal{
position:relative;

}
}.zh-TW{
.u_c_3NW0211.normal{
position:relative;

}
}.zh-TW{
.u_c_PAQY212.normal{
position:relative;

}
}.zh-TW{
.u_c_TQ08214.normal{
position:relative;

}
}.zh-TW{
.u_c_QZ3T216.normal{
position:relative;

}
}.zh-TW{
.u_c_WUCL218.normal{
position:relative;

}
}.zh-TW{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.zh-TW{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_N0O054.normal{
position:relative;

}
}.zh-TW{
.u_c_NTM477.normal{
position:relative;

}
}.zh-TW{
.u_c_N48357.normal{
position:relative;

}
}.zh-TW{
.u_c_IOWX59.normal{
position:relative;

}
}.zh-TW{
.u_c_MSKH60.normal{
position:relative;

}
}.zh-TW{
.u_c_RQ1579.normal{
position:relative;

}
}.zh-TW{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.zh-TW{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.zh-TW{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_HI7Z180.normal{
position:relative;

}
}.zh-TW{
.u_c_D7T4181.normal{
position:relative;

}
}.zh-TW{
.u_c_I55Y183.normal{
position:relative;

}
}.zh-TW{
.u_c_OUV7185.normal{
position:relative;

}
}.zh-TW{
.u_c_IJRB186.normal{
position:relative;

}
}.zh-TW{
.u_c_OPFB187.normal{
position:relative;

}
}.zh-TW{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.zh-TW{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.zh-TW{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_7TVH30.normal{
position:relative;

}
}.zh-TW{
.u_c_4FNG31.normal{
position:relative;

}
}.zh-TW{
.u_c_4BRN33.normal{
position:relative;

}
}.zh-TW{
.u_c_0PDC35.normal{
position:relative;

}
}.zh-TW{
.u_c_CLRM36.normal{
position:relative;

}
}.zh-TW{
.u_c_6DO837.normal{
position:relative;

}
}.zh-TW{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.zh-TW{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-TW{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.zh-TW{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_IO9N199.normal{
position:relative;

}
}.zh-TW{
.u_c_IOVB200.normal{
position:relative;

}
}.zh-TW{
.u_c_U7GV202.normal{
position:relative;

}
}.zh-TW{
.u_c_9ZDW204.normal{
position:relative;

}
}.zh-TW{
.u_c_MH8K206.normal{
position:relative;

}
}.zh-TW{
.u_c_OBVL207.normal{
position:relative;

}
}.zh-TW{
.u_c_ML07208.normal{
position:relative;

}
}.zh-TW{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.zh-TW{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.zh-TW{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_TKH9222.normal{
position:relative;

}
}.zh-TW{
.u_c_F50B223.normal{
position:relative;

}
}.zh-TW{
.u_c_ISPG225.normal{
position:relative;

}
}.zh-TW{
.u_c_MWES227.normal{
position:relative;

}
}.zh-TW{
.u_c_QJSK229.normal{
position:relative;

}
}.zh-TW{
.u_c_OS9P230.normal{
position:relative;

}
}.zh-TW{
.u_c_D5FO231.normal{
position:relative;

}
}.zh-TW{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-TW{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.zh-TW{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.zh-TW{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.zh-TW{
.u_c_H8Z1245.normal{
position:relative;

}
}.zh-TW{
.u_c_DG2T246.normal{
position:relative;

}
}.zh-TW{
.u_c_A3HT248.normal{
position:relative;

}
}.zh-TW{
.u_c_SP4I250.normal{
position:relative;

}
}.zh-TW{
.u_c_TQBB252.normal{
position:relative;

}
}.zh-TW{
.u_c_BPDA254.normal{
position:relative;

}
}.zh-TW{
.u_c_BG5S255.normal{
position:relative;

}
}.zh-TW{
.u_c_PCW6256.normal{
position:relative;

}
}.zh-TW{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.zh-TW{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.zh-TW{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.zh-TW{
.u_c_TT13266.normal{
position:relative;

}
}.zh-TW{
.u_c_BR8S267.normal{
position:relative;

}
}.zh-TW{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.zh-TW{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.zh-TW{
.u_c_F9EU272.normal{
position:relative;

}
}.zh-TW{
.u_c_JNPQ273.normal{
position:relative;

}
}.zh-TW{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.zh-TW{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.zh-TW{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.zh-TW{
.u_c_9W0637.normal{
position:relative;

}
}.zh-TW{
.u_c_OWKT38.normal{
position:relative;

}
}.zh-TW{
.u_c_HBXK40.normal{
position:relative;

}
}.zh-TW{
.u_c_E33R42.normal{
position:relative;

}
}.zh-TW{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.zh-TW{
.u_c_HD05279.normal{
position:relative;

}
}.zh-TW{
.u_c_BAIN280.normal{
position:relative;

}
}.zh-TW{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.zh-TW{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.zh-TW{
.u_c_JV9F284.normal{
position:relative;

}
}.zh-TW{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.zh-TW{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-TW{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-TW{
.u_c_4KIA91.normal{
position:relative;

}
}.zh-TW{
.u_c_VSBS92.normal{
position:relative;

}
}.zh-TW{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.zh-TW{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.zh-TW{
.u_c_LRU896.normal{
position:relative;

}
}.zh-TW{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.zh-TW{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.zh-TW{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.zh-TW{
.u_c_OMHF291.normal{
position:relative;

}
}.zh-TW{
.u_c_GZL0292.normal{
position:relative;

}
}.zh-TW{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.zh-TW{
.u_c_SMOH296.normal{
position:relative;

}
}.zh-TW{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.zh-TW{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.zh-TW{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.zh-TW{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_TEW3303.normal{
position:relative;

}
}.zh-TW{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.zh-TW{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.zh-TW{
.u_c_FCR3307.normal{
position:relative;

}
}.zh-TW{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.zh-TW{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.zh-TW{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.zh-TW{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.zh-TW{
.u_c_NX07322.normal{
position:relative;

}
}.zh-TW{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.zh-TW{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.zh-TW{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.zh-TW{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.zh-TW{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.zh-TW{
.u_c_AWZN29.normal{
position:relative;

}
}.zh-TW{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.zh-TW{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.zh-TW{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.zh-TW{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.zh-TW{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.zh-TW{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.zh-TW{
.u_c_2OTG19.normal{
position:relative;

}
}.zh-TW{
.u_c_N5XH81.normal{
position:relative;

}
}.zh-TW{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.zh-TW{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.zh-TW{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.zh-TW{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.zh-TW{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.zh-TW{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_DF8T332.normal{
position:relative;

}
}.zh-TW{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.zh-TW{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.zh-TW{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.zh-TW{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.zh-TW{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.zh-TW{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.zh-TW{
.u_c_PPX633.normal{
position:relative;

}
}.zh-TW{
.u_c_ODH034.normal{
position:relative;

}
}.zh-TW{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.zh-TW{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.zh-TW{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.zh-TW{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.zh-TW{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.zh-TW{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.zh-TW{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.zh-TW{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.zh-TW{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.zh-TW{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.zh-TW{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.zh-TW{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.zh-TW{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.zh-TW{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.zh-TW{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.zh-TW{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.zh-TW{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.zh-TW{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.zh-TW{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.zh-TW{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.zh-TW{
.u_c_E548372.normal{
position:relative;

}
}.zh-TW{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_GYDD382.normal{
position:relative;

}
}.zh-TW{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.zh-TW{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.zh-TW{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.zh-TW{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.zh-TW{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.zh-TW{
.u_c_AMCZ32.normal{
position:relative;

}
}.zh-TW{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.zh-TW{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.zh-TW{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-TW{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.zh-TW{
.u_c_5MKI43.normal{
position:relative;

}
}.zh-TW{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.zh-TW{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.zh-TW{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-TW{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.zh-TW{
.u_c_0ALV52.normal{
position:relative;

}
}.zh-TW{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.zh-TW{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.zh-TW{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.zh-TW{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.zh-TW{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.zh-TW{
.u_c_EGF4391.normal{
position:relative;

}
}.zh-TW{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.zh-TW{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.zh-TW{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.en-US{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.en-US{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.en-US{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_EZ6A156.normal{
position:relative;

}
}.en-US{
.u_c_MJVL157.normal{
position:relative;

}
}.en-US{
.u_c_LU2L159.normal{
position:relative;

}
}.en-US{
.u_c_KB6X161.normal{
position:relative;

}
}.en-US{
.u_c_GIVF162.normal{
position:relative;

}
}.en-US{
.u_c_O6EY163.normal{
position:relative;

}
}.en-US{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_L9U2167.normal{
position:relative;

}
}.en-US{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.en-US{
.u_c_QJ7T170.normal{
position:relative;

}
}.en-US{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.en-US{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.en-US{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.en-US{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.en-US{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_U8C4201.normal{
position:relative;

}
}.en-US{
.u_c_OKFQ202.normal{
position:relative;

}
}.en-US{
.u_c_7CQY204.normal{
position:relative;

}
}.en-US{
.u_c_PTZN206.normal{
position:relative;

}
}.en-US{
.u_c_VRV4208.normal{
position:relative;

}
}.en-US{
.u_c_Z2F7210.normal{
position:relative;

}
}.en-US{
.u_c_3NW0211.normal{
position:relative;

}
}.en-US{
.u_c_PAQY212.normal{
position:relative;

}
}.en-US{
.u_c_TQ08214.normal{
position:relative;

}
}.en-US{
.u_c_QZ3T216.normal{
position:relative;

}
}.en-US{
.u_c_WUCL218.normal{
position:relative;

}
}.en-US{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.en-US{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_N0O054.normal{
position:relative;

}
}.en-US{
.u_c_NTM477.normal{
position:relative;

}
}.en-US{
.u_c_N48357.normal{
position:relative;

}
}.en-US{
.u_c_IOWX59.normal{
position:relative;

}
}.en-US{
.u_c_MSKH60.normal{
position:relative;

}
}.en-US{
.u_c_RQ1579.normal{
position:relative;

}
}.en-US{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.en-US{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.en-US{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_HI7Z180.normal{
position:relative;

}
}.en-US{
.u_c_D7T4181.normal{
position:relative;

}
}.en-US{
.u_c_I55Y183.normal{
position:relative;

}
}.en-US{
.u_c_OUV7185.normal{
position:relative;

}
}.en-US{
.u_c_IJRB186.normal{
position:relative;

}
}.en-US{
.u_c_OPFB187.normal{
position:relative;

}
}.en-US{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.en-US{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.en-US{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_7TVH30.normal{
position:relative;

}
}.en-US{
.u_c_4FNG31.normal{
position:relative;

}
}.en-US{
.u_c_4BRN33.normal{
position:relative;

}
}.en-US{
.u_c_0PDC35.normal{
position:relative;

}
}.en-US{
.u_c_CLRM36.normal{
position:relative;

}
}.en-US{
.u_c_6DO837.normal{
position:relative;

}
}.en-US{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.en-US{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.en-US{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.en-US{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_IO9N199.normal{
position:relative;

}
}.en-US{
.u_c_IOVB200.normal{
position:relative;

}
}.en-US{
.u_c_U7GV202.normal{
position:relative;

}
}.en-US{
.u_c_9ZDW204.normal{
position:relative;

}
}.en-US{
.u_c_MH8K206.normal{
position:relative;

}
}.en-US{
.u_c_OBVL207.normal{
position:relative;

}
}.en-US{
.u_c_ML07208.normal{
position:relative;

}
}.en-US{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.en-US{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.en-US{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_TKH9222.normal{
position:relative;

}
}.en-US{
.u_c_F50B223.normal{
position:relative;

}
}.en-US{
.u_c_ISPG225.normal{
position:relative;

}
}.en-US{
.u_c_MWES227.normal{
position:relative;

}
}.en-US{
.u_c_QJSK229.normal{
position:relative;

}
}.en-US{
.u_c_OS9P230.normal{
position:relative;

}
}.en-US{
.u_c_D5FO231.normal{
position:relative;

}
}.en-US{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.en-US{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.en-US{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.en-US{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.en-US{
.u_c_H8Z1245.normal{
position:relative;

}
}.en-US{
.u_c_DG2T246.normal{
position:relative;

}
}.en-US{
.u_c_A3HT248.normal{
position:relative;

}
}.en-US{
.u_c_SP4I250.normal{
position:relative;

}
}.en-US{
.u_c_TQBB252.normal{
position:relative;

}
}.en-US{
.u_c_BPDA254.normal{
position:relative;

}
}.en-US{
.u_c_BG5S255.normal{
position:relative;

}
}.en-US{
.u_c_PCW6256.normal{
position:relative;

}
}.en-US{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.en-US{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.en-US{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.en-US{
.u_c_TT13266.normal{
position:relative;

}
}.en-US{
.u_c_BR8S267.normal{
position:relative;

}
}.en-US{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.en-US{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.en-US{
.u_c_F9EU272.normal{
position:relative;

}
}.en-US{
.u_c_JNPQ273.normal{
position:relative;

}
}.en-US{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.en-US{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.en-US{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.en-US{
.u_c_9W0637.normal{
position:relative;

}
}.en-US{
.u_c_OWKT38.normal{
position:relative;

}
}.en-US{
.u_c_HBXK40.normal{
position:relative;

}
}.en-US{
.u_c_E33R42.normal{
position:relative;

}
}.en-US{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.en-US{
.u_c_HD05279.normal{
position:relative;

}
}.en-US{
.u_c_BAIN280.normal{
position:relative;

}
}.en-US{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.en-US{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.en-US{
.u_c_JV9F284.normal{
position:relative;

}
}.en-US{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.en-US{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.en-US{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.en-US{
.u_c_4KIA91.normal{
position:relative;

}
}.en-US{
.u_c_VSBS92.normal{
position:relative;

}
}.en-US{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.en-US{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.en-US{
.u_c_LRU896.normal{
position:relative;

}
}.en-US{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.en-US{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.en-US{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.en-US{
.u_c_OMHF291.normal{
position:relative;

}
}.en-US{
.u_c_GZL0292.normal{
position:relative;

}
}.en-US{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.en-US{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.en-US{
.u_c_SMOH296.normal{
position:relative;

}
}.en-US{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.en-US{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.en-US{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.en-US{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_TEW3303.normal{
position:relative;

}
}.en-US{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.en-US{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.en-US{
.u_c_FCR3307.normal{
position:relative;

}
}.en-US{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.en-US{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.en-US{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.en-US{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.en-US{
.u_c_NX07322.normal{
position:relative;

}
}.en-US{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.en-US{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.en-US{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.en-US{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.en-US{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.en-US{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.en-US{
.u_c_AWZN29.normal{
position:relative;

}
}.en-US{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.en-US{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.en-US{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.en-US{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.en-US{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.en-US{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.en-US{
.u_c_2OTG19.normal{
position:relative;

}
}.en-US{
.u_c_N5XH81.normal{
position:relative;

}
}.en-US{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.en-US{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.en-US{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.en-US{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.en-US{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.en-US{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.en-US{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.en-US{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.en-US{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.en-US{
.u_c_DF8T332.normal{
position:relative;

}
}.en-US{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.en-US{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.en-US{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.en-US{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.en-US{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.en-US{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.en-US{
.u_c_PPX633.normal{
position:relative;

}
}.en-US{
.u_c_ODH034.normal{
position:relative;

}
}.en-US{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.en-US{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.en-US{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.en-US{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.en-US{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.en-US{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.en-US{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.en-US{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.en-US{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.en-US{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.en-US{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.en-US{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.en-US{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.en-US{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.en-US{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.en-US{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.en-US{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.en-US{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.en-US{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.en-US{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.en-US{
.u_c_E548372.normal{
position:relative;

}
}.en-US{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_GYDD382.normal{
position:relative;

}
}.en-US{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.en-US{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.en-US{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.en-US{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.en-US{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.en-US{
.u_c_AMCZ32.normal{
position:relative;

}
}.en-US{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.en-US{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.en-US{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.en-US{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.en-US{
.u_c_5MKI43.normal{
position:relative;

}
}.en-US{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.en-US{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.en-US{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.en-US{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.en-US{
.u_c_0ALV52.normal{
position:relative;

}
}.en-US{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.en-US{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.en-US{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.en-US{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.en-US{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.en-US{
.u_c_EGF4391.normal{
position:relative;

}
}.en-US{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.en-US{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.en-US{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ja-JP{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.ja-JP{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.ja-JP{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_EZ6A156.normal{
position:relative;

}
}.ja-JP{
.u_c_MJVL157.normal{
position:relative;

}
}.ja-JP{
.u_c_LU2L159.normal{
position:relative;

}
}.ja-JP{
.u_c_KB6X161.normal{
position:relative;

}
}.ja-JP{
.u_c_GIVF162.normal{
position:relative;

}
}.ja-JP{
.u_c_O6EY163.normal{
position:relative;

}
}.ja-JP{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.ja-JP{
.u_c_L9U2167.normal{
position:relative;

}
}.ja-JP{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.ja-JP{
.u_c_QJ7T170.normal{
position:relative;

}
}.ja-JP{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ja-JP{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ja-JP{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.ja-JP{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.ja-JP{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_U8C4201.normal{
position:relative;

}
}.ja-JP{
.u_c_OKFQ202.normal{
position:relative;

}
}.ja-JP{
.u_c_7CQY204.normal{
position:relative;

}
}.ja-JP{
.u_c_PTZN206.normal{
position:relative;

}
}.ja-JP{
.u_c_VRV4208.normal{
position:relative;

}
}.ja-JP{
.u_c_Z2F7210.normal{
position:relative;

}
}.ja-JP{
.u_c_3NW0211.normal{
position:relative;

}
}.ja-JP{
.u_c_PAQY212.normal{
position:relative;

}
}.ja-JP{
.u_c_TQ08214.normal{
position:relative;

}
}.ja-JP{
.u_c_QZ3T216.normal{
position:relative;

}
}.ja-JP{
.u_c_WUCL218.normal{
position:relative;

}
}.ja-JP{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.ja-JP{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_N0O054.normal{
position:relative;

}
}.ja-JP{
.u_c_NTM477.normal{
position:relative;

}
}.ja-JP{
.u_c_N48357.normal{
position:relative;

}
}.ja-JP{
.u_c_IOWX59.normal{
position:relative;

}
}.ja-JP{
.u_c_MSKH60.normal{
position:relative;

}
}.ja-JP{
.u_c_RQ1579.normal{
position:relative;

}
}.ja-JP{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.ja-JP{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ja-JP{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.ja-JP{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_HI7Z180.normal{
position:relative;

}
}.ja-JP{
.u_c_D7T4181.normal{
position:relative;

}
}.ja-JP{
.u_c_I55Y183.normal{
position:relative;

}
}.ja-JP{
.u_c_OUV7185.normal{
position:relative;

}
}.ja-JP{
.u_c_IJRB186.normal{
position:relative;

}
}.ja-JP{
.u_c_OPFB187.normal{
position:relative;

}
}.ja-JP{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.ja-JP{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.ja-JP{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.ja-JP{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_7TVH30.normal{
position:relative;

}
}.ja-JP{
.u_c_4FNG31.normal{
position:relative;

}
}.ja-JP{
.u_c_4BRN33.normal{
position:relative;

}
}.ja-JP{
.u_c_0PDC35.normal{
position:relative;

}
}.ja-JP{
.u_c_CLRM36.normal{
position:relative;

}
}.ja-JP{
.u_c_6DO837.normal{
position:relative;

}
}.ja-JP{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.ja-JP{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ja-JP{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.ja-JP{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_IO9N199.normal{
position:relative;

}
}.ja-JP{
.u_c_IOVB200.normal{
position:relative;

}
}.ja-JP{
.u_c_U7GV202.normal{
position:relative;

}
}.ja-JP{
.u_c_9ZDW204.normal{
position:relative;

}
}.ja-JP{
.u_c_MH8K206.normal{
position:relative;

}
}.ja-JP{
.u_c_OBVL207.normal{
position:relative;

}
}.ja-JP{
.u_c_ML07208.normal{
position:relative;

}
}.ja-JP{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.ja-JP{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.ja-JP{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_TKH9222.normal{
position:relative;

}
}.ja-JP{
.u_c_F50B223.normal{
position:relative;

}
}.ja-JP{
.u_c_ISPG225.normal{
position:relative;

}
}.ja-JP{
.u_c_MWES227.normal{
position:relative;

}
}.ja-JP{
.u_c_QJSK229.normal{
position:relative;

}
}.ja-JP{
.u_c_OS9P230.normal{
position:relative;

}
}.ja-JP{
.u_c_D5FO231.normal{
position:relative;

}
}.ja-JP{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ja-JP{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.ja-JP{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ja-JP{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.ja-JP{
.u_c_H8Z1245.normal{
position:relative;

}
}.ja-JP{
.u_c_DG2T246.normal{
position:relative;

}
}.ja-JP{
.u_c_A3HT248.normal{
position:relative;

}
}.ja-JP{
.u_c_SP4I250.normal{
position:relative;

}
}.ja-JP{
.u_c_TQBB252.normal{
position:relative;

}
}.ja-JP{
.u_c_BPDA254.normal{
position:relative;

}
}.ja-JP{
.u_c_BG5S255.normal{
position:relative;

}
}.ja-JP{
.u_c_PCW6256.normal{
position:relative;

}
}.ja-JP{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ja-JP{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ja-JP{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ja-JP{
.u_c_TT13266.normal{
position:relative;

}
}.ja-JP{
.u_c_BR8S267.normal{
position:relative;

}
}.ja-JP{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.ja-JP{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ja-JP{
.u_c_F9EU272.normal{
position:relative;

}
}.ja-JP{
.u_c_JNPQ273.normal{
position:relative;

}
}.ja-JP{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ja-JP{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.ja-JP{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ja-JP{
.u_c_9W0637.normal{
position:relative;

}
}.ja-JP{
.u_c_OWKT38.normal{
position:relative;

}
}.ja-JP{
.u_c_HBXK40.normal{
position:relative;

}
}.ja-JP{
.u_c_E33R42.normal{
position:relative;

}
}.ja-JP{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ja-JP{
.u_c_HD05279.normal{
position:relative;

}
}.ja-JP{
.u_c_BAIN280.normal{
position:relative;

}
}.ja-JP{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.ja-JP{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.ja-JP{
.u_c_JV9F284.normal{
position:relative;

}
}.ja-JP{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.ja-JP{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ja-JP{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ja-JP{
.u_c_4KIA91.normal{
position:relative;

}
}.ja-JP{
.u_c_VSBS92.normal{
position:relative;

}
}.ja-JP{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.ja-JP{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.ja-JP{
.u_c_LRU896.normal{
position:relative;

}
}.ja-JP{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.ja-JP{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ja-JP{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ja-JP{
.u_c_OMHF291.normal{
position:relative;

}
}.ja-JP{
.u_c_GZL0292.normal{
position:relative;

}
}.ja-JP{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.ja-JP{
.u_c_SMOH296.normal{
position:relative;

}
}.ja-JP{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ja-JP{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ja-JP{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ja-JP{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_TEW3303.normal{
position:relative;

}
}.ja-JP{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.ja-JP{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.ja-JP{
.u_c_FCR3307.normal{
position:relative;

}
}.ja-JP{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ja-JP{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.ja-JP{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ja-JP{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ja-JP{
.u_c_NX07322.normal{
position:relative;

}
}.ja-JP{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ja-JP{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.ja-JP{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.ja-JP{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ja-JP{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ja-JP{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ja-JP{
.u_c_AWZN29.normal{
position:relative;

}
}.ja-JP{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ja-JP{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.ja-JP{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.ja-JP{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.ja-JP{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.ja-JP{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ja-JP{
.u_c_2OTG19.normal{
position:relative;

}
}.ja-JP{
.u_c_N5XH81.normal{
position:relative;

}
}.ja-JP{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ja-JP{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ja-JP{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.ja-JP{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ja-JP{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ja-JP{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ja-JP{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ja-JP{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ja-JP{
.u_c_DF8T332.normal{
position:relative;

}
}.ja-JP{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.ja-JP{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.ja-JP{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ja-JP{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.ja-JP{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.ja-JP{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.ja-JP{
.u_c_PPX633.normal{
position:relative;

}
}.ja-JP{
.u_c_ODH034.normal{
position:relative;

}
}.ja-JP{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.ja-JP{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.ja-JP{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.ja-JP{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ja-JP{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.ja-JP{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.ja-JP{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.ja-JP{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.ja-JP{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.ja-JP{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.ja-JP{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.ja-JP{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.ja-JP{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.ja-JP{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ja-JP{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.ja-JP{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.ja-JP{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ja-JP{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.ja-JP{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.ja-JP{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.ja-JP{
.u_c_E548372.normal{
position:relative;

}
}.ja-JP{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_GYDD382.normal{
position:relative;

}
}.ja-JP{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ja-JP{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.ja-JP{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ja-JP{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.ja-JP{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.ja-JP{
.u_c_AMCZ32.normal{
position:relative;

}
}.ja-JP{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.ja-JP{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ja-JP{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ja-JP{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.ja-JP{
.u_c_5MKI43.normal{
position:relative;

}
}.ja-JP{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.ja-JP{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ja-JP{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ja-JP{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.ja-JP{
.u_c_0ALV52.normal{
position:relative;

}
}.ja-JP{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.ja-JP{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.ja-JP{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ja-JP{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ja-JP{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.ja-JP{
.u_c_EGF4391.normal{
position:relative;

}
}.ja-JP{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.ja-JP{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.ja-JP{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ko-KR{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.ko-KR{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.ko-KR{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_EZ6A156.normal{
position:relative;

}
}.ko-KR{
.u_c_MJVL157.normal{
position:relative;

}
}.ko-KR{
.u_c_LU2L159.normal{
position:relative;

}
}.ko-KR{
.u_c_KB6X161.normal{
position:relative;

}
}.ko-KR{
.u_c_GIVF162.normal{
position:relative;

}
}.ko-KR{
.u_c_O6EY163.normal{
position:relative;

}
}.ko-KR{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.ko-KR{
.u_c_L9U2167.normal{
position:relative;

}
}.ko-KR{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.ko-KR{
.u_c_QJ7T170.normal{
position:relative;

}
}.ko-KR{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ko-KR{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ko-KR{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.ko-KR{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.ko-KR{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_U8C4201.normal{
position:relative;

}
}.ko-KR{
.u_c_OKFQ202.normal{
position:relative;

}
}.ko-KR{
.u_c_7CQY204.normal{
position:relative;

}
}.ko-KR{
.u_c_PTZN206.normal{
position:relative;

}
}.ko-KR{
.u_c_VRV4208.normal{
position:relative;

}
}.ko-KR{
.u_c_Z2F7210.normal{
position:relative;

}
}.ko-KR{
.u_c_3NW0211.normal{
position:relative;

}
}.ko-KR{
.u_c_PAQY212.normal{
position:relative;

}
}.ko-KR{
.u_c_TQ08214.normal{
position:relative;

}
}.ko-KR{
.u_c_QZ3T216.normal{
position:relative;

}
}.ko-KR{
.u_c_WUCL218.normal{
position:relative;

}
}.ko-KR{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.ko-KR{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_N0O054.normal{
position:relative;

}
}.ko-KR{
.u_c_NTM477.normal{
position:relative;

}
}.ko-KR{
.u_c_N48357.normal{
position:relative;

}
}.ko-KR{
.u_c_IOWX59.normal{
position:relative;

}
}.ko-KR{
.u_c_MSKH60.normal{
position:relative;

}
}.ko-KR{
.u_c_RQ1579.normal{
position:relative;

}
}.ko-KR{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.ko-KR{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ko-KR{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.ko-KR{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_HI7Z180.normal{
position:relative;

}
}.ko-KR{
.u_c_D7T4181.normal{
position:relative;

}
}.ko-KR{
.u_c_I55Y183.normal{
position:relative;

}
}.ko-KR{
.u_c_OUV7185.normal{
position:relative;

}
}.ko-KR{
.u_c_IJRB186.normal{
position:relative;

}
}.ko-KR{
.u_c_OPFB187.normal{
position:relative;

}
}.ko-KR{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.ko-KR{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.ko-KR{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.ko-KR{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_7TVH30.normal{
position:relative;

}
}.ko-KR{
.u_c_4FNG31.normal{
position:relative;

}
}.ko-KR{
.u_c_4BRN33.normal{
position:relative;

}
}.ko-KR{
.u_c_0PDC35.normal{
position:relative;

}
}.ko-KR{
.u_c_CLRM36.normal{
position:relative;

}
}.ko-KR{
.u_c_6DO837.normal{
position:relative;

}
}.ko-KR{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.ko-KR{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ko-KR{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.ko-KR{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_IO9N199.normal{
position:relative;

}
}.ko-KR{
.u_c_IOVB200.normal{
position:relative;

}
}.ko-KR{
.u_c_U7GV202.normal{
position:relative;

}
}.ko-KR{
.u_c_9ZDW204.normal{
position:relative;

}
}.ko-KR{
.u_c_MH8K206.normal{
position:relative;

}
}.ko-KR{
.u_c_OBVL207.normal{
position:relative;

}
}.ko-KR{
.u_c_ML07208.normal{
position:relative;

}
}.ko-KR{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.ko-KR{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.ko-KR{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_TKH9222.normal{
position:relative;

}
}.ko-KR{
.u_c_F50B223.normal{
position:relative;

}
}.ko-KR{
.u_c_ISPG225.normal{
position:relative;

}
}.ko-KR{
.u_c_MWES227.normal{
position:relative;

}
}.ko-KR{
.u_c_QJSK229.normal{
position:relative;

}
}.ko-KR{
.u_c_OS9P230.normal{
position:relative;

}
}.ko-KR{
.u_c_D5FO231.normal{
position:relative;

}
}.ko-KR{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ko-KR{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.ko-KR{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ko-KR{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.ko-KR{
.u_c_H8Z1245.normal{
position:relative;

}
}.ko-KR{
.u_c_DG2T246.normal{
position:relative;

}
}.ko-KR{
.u_c_A3HT248.normal{
position:relative;

}
}.ko-KR{
.u_c_SP4I250.normal{
position:relative;

}
}.ko-KR{
.u_c_TQBB252.normal{
position:relative;

}
}.ko-KR{
.u_c_BPDA254.normal{
position:relative;

}
}.ko-KR{
.u_c_BG5S255.normal{
position:relative;

}
}.ko-KR{
.u_c_PCW6256.normal{
position:relative;

}
}.ko-KR{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ko-KR{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ko-KR{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ko-KR{
.u_c_TT13266.normal{
position:relative;

}
}.ko-KR{
.u_c_BR8S267.normal{
position:relative;

}
}.ko-KR{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.ko-KR{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ko-KR{
.u_c_F9EU272.normal{
position:relative;

}
}.ko-KR{
.u_c_JNPQ273.normal{
position:relative;

}
}.ko-KR{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ko-KR{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.ko-KR{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ko-KR{
.u_c_9W0637.normal{
position:relative;

}
}.ko-KR{
.u_c_OWKT38.normal{
position:relative;

}
}.ko-KR{
.u_c_HBXK40.normal{
position:relative;

}
}.ko-KR{
.u_c_E33R42.normal{
position:relative;

}
}.ko-KR{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ko-KR{
.u_c_HD05279.normal{
position:relative;

}
}.ko-KR{
.u_c_BAIN280.normal{
position:relative;

}
}.ko-KR{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.ko-KR{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.ko-KR{
.u_c_JV9F284.normal{
position:relative;

}
}.ko-KR{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.ko-KR{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ko-KR{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ko-KR{
.u_c_4KIA91.normal{
position:relative;

}
}.ko-KR{
.u_c_VSBS92.normal{
position:relative;

}
}.ko-KR{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.ko-KR{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.ko-KR{
.u_c_LRU896.normal{
position:relative;

}
}.ko-KR{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.ko-KR{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ko-KR{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ko-KR{
.u_c_OMHF291.normal{
position:relative;

}
}.ko-KR{
.u_c_GZL0292.normal{
position:relative;

}
}.ko-KR{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.ko-KR{
.u_c_SMOH296.normal{
position:relative;

}
}.ko-KR{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ko-KR{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ko-KR{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ko-KR{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_TEW3303.normal{
position:relative;

}
}.ko-KR{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.ko-KR{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.ko-KR{
.u_c_FCR3307.normal{
position:relative;

}
}.ko-KR{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ko-KR{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.ko-KR{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ko-KR{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ko-KR{
.u_c_NX07322.normal{
position:relative;

}
}.ko-KR{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ko-KR{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.ko-KR{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.ko-KR{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ko-KR{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ko-KR{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ko-KR{
.u_c_AWZN29.normal{
position:relative;

}
}.ko-KR{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ko-KR{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.ko-KR{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.ko-KR{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.ko-KR{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.ko-KR{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ko-KR{
.u_c_2OTG19.normal{
position:relative;

}
}.ko-KR{
.u_c_N5XH81.normal{
position:relative;

}
}.ko-KR{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ko-KR{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ko-KR{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.ko-KR{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ko-KR{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ko-KR{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ko-KR{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ko-KR{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ko-KR{
.u_c_DF8T332.normal{
position:relative;

}
}.ko-KR{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.ko-KR{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.ko-KR{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ko-KR{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.ko-KR{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.ko-KR{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.ko-KR{
.u_c_PPX633.normal{
position:relative;

}
}.ko-KR{
.u_c_ODH034.normal{
position:relative;

}
}.ko-KR{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.ko-KR{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.ko-KR{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.ko-KR{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ko-KR{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.ko-KR{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.ko-KR{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.ko-KR{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.ko-KR{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.ko-KR{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.ko-KR{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.ko-KR{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.ko-KR{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.ko-KR{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ko-KR{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.ko-KR{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.ko-KR{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ko-KR{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.ko-KR{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.ko-KR{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.ko-KR{
.u_c_E548372.normal{
position:relative;

}
}.ko-KR{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_GYDD382.normal{
position:relative;

}
}.ko-KR{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ko-KR{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.ko-KR{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ko-KR{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.ko-KR{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.ko-KR{
.u_c_AMCZ32.normal{
position:relative;

}
}.ko-KR{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.ko-KR{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ko-KR{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ko-KR{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.ko-KR{
.u_c_5MKI43.normal{
position:relative;

}
}.ko-KR{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.ko-KR{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ko-KR{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ko-KR{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.ko-KR{
.u_c_0ALV52.normal{
position:relative;

}
}.ko-KR{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.ko-KR{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.ko-KR{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ko-KR{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ko-KR{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.ko-KR{
.u_c_EGF4391.normal{
position:relative;

}
}.ko-KR{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.ko-KR{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.ko-KR{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.th-TH{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.th-TH{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.th-TH{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_EZ6A156.normal{
position:relative;

}
}.th-TH{
.u_c_MJVL157.normal{
position:relative;

}
}.th-TH{
.u_c_LU2L159.normal{
position:relative;

}
}.th-TH{
.u_c_KB6X161.normal{
position:relative;

}
}.th-TH{
.u_c_GIVF162.normal{
position:relative;

}
}.th-TH{
.u_c_O6EY163.normal{
position:relative;

}
}.th-TH{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_L9U2167.normal{
position:relative;

}
}.th-TH{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.th-TH{
.u_c_QJ7T170.normal{
position:relative;

}
}.th-TH{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.th-TH{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.th-TH{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.th-TH{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.th-TH{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_U8C4201.normal{
position:relative;

}
}.th-TH{
.u_c_OKFQ202.normal{
position:relative;

}
}.th-TH{
.u_c_7CQY204.normal{
position:relative;

}
}.th-TH{
.u_c_PTZN206.normal{
position:relative;

}
}.th-TH{
.u_c_VRV4208.normal{
position:relative;

}
}.th-TH{
.u_c_Z2F7210.normal{
position:relative;

}
}.th-TH{
.u_c_3NW0211.normal{
position:relative;

}
}.th-TH{
.u_c_PAQY212.normal{
position:relative;

}
}.th-TH{
.u_c_TQ08214.normal{
position:relative;

}
}.th-TH{
.u_c_QZ3T216.normal{
position:relative;

}
}.th-TH{
.u_c_WUCL218.normal{
position:relative;

}
}.th-TH{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.th-TH{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_N0O054.normal{
position:relative;

}
}.th-TH{
.u_c_NTM477.normal{
position:relative;

}
}.th-TH{
.u_c_N48357.normal{
position:relative;

}
}.th-TH{
.u_c_IOWX59.normal{
position:relative;

}
}.th-TH{
.u_c_MSKH60.normal{
position:relative;

}
}.th-TH{
.u_c_RQ1579.normal{
position:relative;

}
}.th-TH{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.th-TH{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.th-TH{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_HI7Z180.normal{
position:relative;

}
}.th-TH{
.u_c_D7T4181.normal{
position:relative;

}
}.th-TH{
.u_c_I55Y183.normal{
position:relative;

}
}.th-TH{
.u_c_OUV7185.normal{
position:relative;

}
}.th-TH{
.u_c_IJRB186.normal{
position:relative;

}
}.th-TH{
.u_c_OPFB187.normal{
position:relative;

}
}.th-TH{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.th-TH{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.th-TH{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_7TVH30.normal{
position:relative;

}
}.th-TH{
.u_c_4FNG31.normal{
position:relative;

}
}.th-TH{
.u_c_4BRN33.normal{
position:relative;

}
}.th-TH{
.u_c_0PDC35.normal{
position:relative;

}
}.th-TH{
.u_c_CLRM36.normal{
position:relative;

}
}.th-TH{
.u_c_6DO837.normal{
position:relative;

}
}.th-TH{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.th-TH{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.th-TH{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.th-TH{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_IO9N199.normal{
position:relative;

}
}.th-TH{
.u_c_IOVB200.normal{
position:relative;

}
}.th-TH{
.u_c_U7GV202.normal{
position:relative;

}
}.th-TH{
.u_c_9ZDW204.normal{
position:relative;

}
}.th-TH{
.u_c_MH8K206.normal{
position:relative;

}
}.th-TH{
.u_c_OBVL207.normal{
position:relative;

}
}.th-TH{
.u_c_ML07208.normal{
position:relative;

}
}.th-TH{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.th-TH{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.th-TH{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_TKH9222.normal{
position:relative;

}
}.th-TH{
.u_c_F50B223.normal{
position:relative;

}
}.th-TH{
.u_c_ISPG225.normal{
position:relative;

}
}.th-TH{
.u_c_MWES227.normal{
position:relative;

}
}.th-TH{
.u_c_QJSK229.normal{
position:relative;

}
}.th-TH{
.u_c_OS9P230.normal{
position:relative;

}
}.th-TH{
.u_c_D5FO231.normal{
position:relative;

}
}.th-TH{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.th-TH{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.th-TH{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.th-TH{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.th-TH{
.u_c_H8Z1245.normal{
position:relative;

}
}.th-TH{
.u_c_DG2T246.normal{
position:relative;

}
}.th-TH{
.u_c_A3HT248.normal{
position:relative;

}
}.th-TH{
.u_c_SP4I250.normal{
position:relative;

}
}.th-TH{
.u_c_TQBB252.normal{
position:relative;

}
}.th-TH{
.u_c_BPDA254.normal{
position:relative;

}
}.th-TH{
.u_c_BG5S255.normal{
position:relative;

}
}.th-TH{
.u_c_PCW6256.normal{
position:relative;

}
}.th-TH{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.th-TH{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.th-TH{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.th-TH{
.u_c_TT13266.normal{
position:relative;

}
}.th-TH{
.u_c_BR8S267.normal{
position:relative;

}
}.th-TH{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.th-TH{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.th-TH{
.u_c_F9EU272.normal{
position:relative;

}
}.th-TH{
.u_c_JNPQ273.normal{
position:relative;

}
}.th-TH{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.th-TH{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.th-TH{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.th-TH{
.u_c_9W0637.normal{
position:relative;

}
}.th-TH{
.u_c_OWKT38.normal{
position:relative;

}
}.th-TH{
.u_c_HBXK40.normal{
position:relative;

}
}.th-TH{
.u_c_E33R42.normal{
position:relative;

}
}.th-TH{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.th-TH{
.u_c_HD05279.normal{
position:relative;

}
}.th-TH{
.u_c_BAIN280.normal{
position:relative;

}
}.th-TH{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.th-TH{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.th-TH{
.u_c_JV9F284.normal{
position:relative;

}
}.th-TH{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.th-TH{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.th-TH{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.th-TH{
.u_c_4KIA91.normal{
position:relative;

}
}.th-TH{
.u_c_VSBS92.normal{
position:relative;

}
}.th-TH{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.th-TH{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.th-TH{
.u_c_LRU896.normal{
position:relative;

}
}.th-TH{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.th-TH{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.th-TH{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.th-TH{
.u_c_OMHF291.normal{
position:relative;

}
}.th-TH{
.u_c_GZL0292.normal{
position:relative;

}
}.th-TH{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.th-TH{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.th-TH{
.u_c_SMOH296.normal{
position:relative;

}
}.th-TH{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.th-TH{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.th-TH{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.th-TH{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_TEW3303.normal{
position:relative;

}
}.th-TH{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.th-TH{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.th-TH{
.u_c_FCR3307.normal{
position:relative;

}
}.th-TH{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.th-TH{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.th-TH{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.th-TH{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.th-TH{
.u_c_NX07322.normal{
position:relative;

}
}.th-TH{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.th-TH{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.th-TH{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.th-TH{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.th-TH{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.th-TH{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.th-TH{
.u_c_AWZN29.normal{
position:relative;

}
}.th-TH{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.th-TH{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.th-TH{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.th-TH{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.th-TH{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.th-TH{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.th-TH{
.u_c_2OTG19.normal{
position:relative;

}
}.th-TH{
.u_c_N5XH81.normal{
position:relative;

}
}.th-TH{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.th-TH{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.th-TH{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.th-TH{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.th-TH{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.th-TH{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.th-TH{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.th-TH{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.th-TH{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.th-TH{
.u_c_DF8T332.normal{
position:relative;

}
}.th-TH{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.th-TH{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.th-TH{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.th-TH{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.th-TH{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.th-TH{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.th-TH{
.u_c_PPX633.normal{
position:relative;

}
}.th-TH{
.u_c_ODH034.normal{
position:relative;

}
}.th-TH{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.th-TH{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.th-TH{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.th-TH{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.th-TH{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.th-TH{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.th-TH{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.th-TH{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.th-TH{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.th-TH{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.th-TH{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.th-TH{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.th-TH{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.th-TH{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.th-TH{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.th-TH{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.th-TH{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.th-TH{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.th-TH{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.th-TH{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.th-TH{
.u_c_E548372.normal{
position:relative;

}
}.th-TH{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_GYDD382.normal{
position:relative;

}
}.th-TH{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.th-TH{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.th-TH{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.th-TH{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.th-TH{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.th-TH{
.u_c_AMCZ32.normal{
position:relative;

}
}.th-TH{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.th-TH{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.th-TH{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.th-TH{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.th-TH{
.u_c_5MKI43.normal{
position:relative;

}
}.th-TH{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.th-TH{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.th-TH{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.th-TH{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.th-TH{
.u_c_0ALV52.normal{
position:relative;

}
}.th-TH{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.th-TH{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.th-TH{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.th-TH{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.th-TH{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.th-TH{
.u_c_EGF4391.normal{
position:relative;

}
}.th-TH{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.th-TH{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.th-TH{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.vi-VN{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.vi-VN{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.vi-VN{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_EZ6A156.normal{
position:relative;

}
}.vi-VN{
.u_c_MJVL157.normal{
position:relative;

}
}.vi-VN{
.u_c_LU2L159.normal{
position:relative;

}
}.vi-VN{
.u_c_KB6X161.normal{
position:relative;

}
}.vi-VN{
.u_c_GIVF162.normal{
position:relative;

}
}.vi-VN{
.u_c_O6EY163.normal{
position:relative;

}
}.vi-VN{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.vi-VN{
.u_c_L9U2167.normal{
position:relative;

}
}.vi-VN{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.vi-VN{
.u_c_QJ7T170.normal{
position:relative;

}
}.vi-VN{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.vi-VN{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.vi-VN{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.vi-VN{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.vi-VN{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_U8C4201.normal{
position:relative;

}
}.vi-VN{
.u_c_OKFQ202.normal{
position:relative;

}
}.vi-VN{
.u_c_7CQY204.normal{
position:relative;

}
}.vi-VN{
.u_c_PTZN206.normal{
position:relative;

}
}.vi-VN{
.u_c_VRV4208.normal{
position:relative;

}
}.vi-VN{
.u_c_Z2F7210.normal{
position:relative;

}
}.vi-VN{
.u_c_3NW0211.normal{
position:relative;

}
}.vi-VN{
.u_c_PAQY212.normal{
position:relative;

}
}.vi-VN{
.u_c_TQ08214.normal{
position:relative;

}
}.vi-VN{
.u_c_QZ3T216.normal{
position:relative;

}
}.vi-VN{
.u_c_WUCL218.normal{
position:relative;

}
}.vi-VN{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.vi-VN{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_N0O054.normal{
position:relative;

}
}.vi-VN{
.u_c_NTM477.normal{
position:relative;

}
}.vi-VN{
.u_c_N48357.normal{
position:relative;

}
}.vi-VN{
.u_c_IOWX59.normal{
position:relative;

}
}.vi-VN{
.u_c_MSKH60.normal{
position:relative;

}
}.vi-VN{
.u_c_RQ1579.normal{
position:relative;

}
}.vi-VN{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.vi-VN{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.vi-VN{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.vi-VN{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_HI7Z180.normal{
position:relative;

}
}.vi-VN{
.u_c_D7T4181.normal{
position:relative;

}
}.vi-VN{
.u_c_I55Y183.normal{
position:relative;

}
}.vi-VN{
.u_c_OUV7185.normal{
position:relative;

}
}.vi-VN{
.u_c_IJRB186.normal{
position:relative;

}
}.vi-VN{
.u_c_OPFB187.normal{
position:relative;

}
}.vi-VN{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.vi-VN{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.vi-VN{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.vi-VN{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_7TVH30.normal{
position:relative;

}
}.vi-VN{
.u_c_4FNG31.normal{
position:relative;

}
}.vi-VN{
.u_c_4BRN33.normal{
position:relative;

}
}.vi-VN{
.u_c_0PDC35.normal{
position:relative;

}
}.vi-VN{
.u_c_CLRM36.normal{
position:relative;

}
}.vi-VN{
.u_c_6DO837.normal{
position:relative;

}
}.vi-VN{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.vi-VN{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.vi-VN{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.vi-VN{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_IO9N199.normal{
position:relative;

}
}.vi-VN{
.u_c_IOVB200.normal{
position:relative;

}
}.vi-VN{
.u_c_U7GV202.normal{
position:relative;

}
}.vi-VN{
.u_c_9ZDW204.normal{
position:relative;

}
}.vi-VN{
.u_c_MH8K206.normal{
position:relative;

}
}.vi-VN{
.u_c_OBVL207.normal{
position:relative;

}
}.vi-VN{
.u_c_ML07208.normal{
position:relative;

}
}.vi-VN{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.vi-VN{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.vi-VN{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_TKH9222.normal{
position:relative;

}
}.vi-VN{
.u_c_F50B223.normal{
position:relative;

}
}.vi-VN{
.u_c_ISPG225.normal{
position:relative;

}
}.vi-VN{
.u_c_MWES227.normal{
position:relative;

}
}.vi-VN{
.u_c_QJSK229.normal{
position:relative;

}
}.vi-VN{
.u_c_OS9P230.normal{
position:relative;

}
}.vi-VN{
.u_c_D5FO231.normal{
position:relative;

}
}.vi-VN{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.vi-VN{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.vi-VN{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.vi-VN{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.vi-VN{
.u_c_H8Z1245.normal{
position:relative;

}
}.vi-VN{
.u_c_DG2T246.normal{
position:relative;

}
}.vi-VN{
.u_c_A3HT248.normal{
position:relative;

}
}.vi-VN{
.u_c_SP4I250.normal{
position:relative;

}
}.vi-VN{
.u_c_TQBB252.normal{
position:relative;

}
}.vi-VN{
.u_c_BPDA254.normal{
position:relative;

}
}.vi-VN{
.u_c_BG5S255.normal{
position:relative;

}
}.vi-VN{
.u_c_PCW6256.normal{
position:relative;

}
}.vi-VN{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.vi-VN{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.vi-VN{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.vi-VN{
.u_c_TT13266.normal{
position:relative;

}
}.vi-VN{
.u_c_BR8S267.normal{
position:relative;

}
}.vi-VN{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.vi-VN{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.vi-VN{
.u_c_F9EU272.normal{
position:relative;

}
}.vi-VN{
.u_c_JNPQ273.normal{
position:relative;

}
}.vi-VN{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.vi-VN{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.vi-VN{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.vi-VN{
.u_c_9W0637.normal{
position:relative;

}
}.vi-VN{
.u_c_OWKT38.normal{
position:relative;

}
}.vi-VN{
.u_c_HBXK40.normal{
position:relative;

}
}.vi-VN{
.u_c_E33R42.normal{
position:relative;

}
}.vi-VN{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.vi-VN{
.u_c_HD05279.normal{
position:relative;

}
}.vi-VN{
.u_c_BAIN280.normal{
position:relative;

}
}.vi-VN{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.vi-VN{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.vi-VN{
.u_c_JV9F284.normal{
position:relative;

}
}.vi-VN{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.vi-VN{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.vi-VN{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.vi-VN{
.u_c_4KIA91.normal{
position:relative;

}
}.vi-VN{
.u_c_VSBS92.normal{
position:relative;

}
}.vi-VN{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.vi-VN{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.vi-VN{
.u_c_LRU896.normal{
position:relative;

}
}.vi-VN{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.vi-VN{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.vi-VN{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.vi-VN{
.u_c_OMHF291.normal{
position:relative;

}
}.vi-VN{
.u_c_GZL0292.normal{
position:relative;

}
}.vi-VN{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.vi-VN{
.u_c_SMOH296.normal{
position:relative;

}
}.vi-VN{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.vi-VN{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.vi-VN{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.vi-VN{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_TEW3303.normal{
position:relative;

}
}.vi-VN{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.vi-VN{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.vi-VN{
.u_c_FCR3307.normal{
position:relative;

}
}.vi-VN{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.vi-VN{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.vi-VN{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.vi-VN{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.vi-VN{
.u_c_NX07322.normal{
position:relative;

}
}.vi-VN{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.vi-VN{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.vi-VN{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.vi-VN{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.vi-VN{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.vi-VN{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.vi-VN{
.u_c_AWZN29.normal{
position:relative;

}
}.vi-VN{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.vi-VN{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.vi-VN{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.vi-VN{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.vi-VN{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.vi-VN{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.vi-VN{
.u_c_2OTG19.normal{
position:relative;

}
}.vi-VN{
.u_c_N5XH81.normal{
position:relative;

}
}.vi-VN{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.vi-VN{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.vi-VN{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.vi-VN{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.vi-VN{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.vi-VN{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.vi-VN{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.vi-VN{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.vi-VN{
.u_c_DF8T332.normal{
position:relative;

}
}.vi-VN{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.vi-VN{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.vi-VN{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.vi-VN{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.vi-VN{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.vi-VN{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.vi-VN{
.u_c_PPX633.normal{
position:relative;

}
}.vi-VN{
.u_c_ODH034.normal{
position:relative;

}
}.vi-VN{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.vi-VN{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.vi-VN{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.vi-VN{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.vi-VN{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.vi-VN{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.vi-VN{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.vi-VN{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.vi-VN{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.vi-VN{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.vi-VN{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.vi-VN{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.vi-VN{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.vi-VN{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.vi-VN{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.vi-VN{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.vi-VN{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.vi-VN{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.vi-VN{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.vi-VN{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.vi-VN{
.u_c_E548372.normal{
position:relative;

}
}.vi-VN{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_GYDD382.normal{
position:relative;

}
}.vi-VN{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.vi-VN{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.vi-VN{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.vi-VN{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.vi-VN{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.vi-VN{
.u_c_AMCZ32.normal{
position:relative;

}
}.vi-VN{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.vi-VN{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.vi-VN{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.vi-VN{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.vi-VN{
.u_c_5MKI43.normal{
position:relative;

}
}.vi-VN{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.vi-VN{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.vi-VN{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.vi-VN{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.vi-VN{
.u_c_0ALV52.normal{
position:relative;

}
}.vi-VN{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.vi-VN{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.vi-VN{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.vi-VN{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.vi-VN{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.vi-VN{
.u_c_EGF4391.normal{
position:relative;

}
}.vi-VN{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.vi-VN{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.vi-VN{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.de-DE{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.de-DE{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.de-DE{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_EZ6A156.normal{
position:relative;

}
}.de-DE{
.u_c_MJVL157.normal{
position:relative;

}
}.de-DE{
.u_c_LU2L159.normal{
position:relative;

}
}.de-DE{
.u_c_KB6X161.normal{
position:relative;

}
}.de-DE{
.u_c_GIVF162.normal{
position:relative;

}
}.de-DE{
.u_c_O6EY163.normal{
position:relative;

}
}.de-DE{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.de-DE{
.u_c_L9U2167.normal{
position:relative;

}
}.de-DE{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.de-DE{
.u_c_QJ7T170.normal{
position:relative;

}
}.de-DE{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.de-DE{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.de-DE{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.de-DE{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.de-DE{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_U8C4201.normal{
position:relative;

}
}.de-DE{
.u_c_OKFQ202.normal{
position:relative;

}
}.de-DE{
.u_c_7CQY204.normal{
position:relative;

}
}.de-DE{
.u_c_PTZN206.normal{
position:relative;

}
}.de-DE{
.u_c_VRV4208.normal{
position:relative;

}
}.de-DE{
.u_c_Z2F7210.normal{
position:relative;

}
}.de-DE{
.u_c_3NW0211.normal{
position:relative;

}
}.de-DE{
.u_c_PAQY212.normal{
position:relative;

}
}.de-DE{
.u_c_TQ08214.normal{
position:relative;

}
}.de-DE{
.u_c_QZ3T216.normal{
position:relative;

}
}.de-DE{
.u_c_WUCL218.normal{
position:relative;

}
}.de-DE{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.de-DE{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_N0O054.normal{
position:relative;

}
}.de-DE{
.u_c_NTM477.normal{
position:relative;

}
}.de-DE{
.u_c_N48357.normal{
position:relative;

}
}.de-DE{
.u_c_IOWX59.normal{
position:relative;

}
}.de-DE{
.u_c_MSKH60.normal{
position:relative;

}
}.de-DE{
.u_c_RQ1579.normal{
position:relative;

}
}.de-DE{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.de-DE{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.de-DE{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.de-DE{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_HI7Z180.normal{
position:relative;

}
}.de-DE{
.u_c_D7T4181.normal{
position:relative;

}
}.de-DE{
.u_c_I55Y183.normal{
position:relative;

}
}.de-DE{
.u_c_OUV7185.normal{
position:relative;

}
}.de-DE{
.u_c_IJRB186.normal{
position:relative;

}
}.de-DE{
.u_c_OPFB187.normal{
position:relative;

}
}.de-DE{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.de-DE{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.de-DE{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.de-DE{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_7TVH30.normal{
position:relative;

}
}.de-DE{
.u_c_4FNG31.normal{
position:relative;

}
}.de-DE{
.u_c_4BRN33.normal{
position:relative;

}
}.de-DE{
.u_c_0PDC35.normal{
position:relative;

}
}.de-DE{
.u_c_CLRM36.normal{
position:relative;

}
}.de-DE{
.u_c_6DO837.normal{
position:relative;

}
}.de-DE{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.de-DE{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.de-DE{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.de-DE{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_IO9N199.normal{
position:relative;

}
}.de-DE{
.u_c_IOVB200.normal{
position:relative;

}
}.de-DE{
.u_c_U7GV202.normal{
position:relative;

}
}.de-DE{
.u_c_9ZDW204.normal{
position:relative;

}
}.de-DE{
.u_c_MH8K206.normal{
position:relative;

}
}.de-DE{
.u_c_OBVL207.normal{
position:relative;

}
}.de-DE{
.u_c_ML07208.normal{
position:relative;

}
}.de-DE{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.de-DE{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.de-DE{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_TKH9222.normal{
position:relative;

}
}.de-DE{
.u_c_F50B223.normal{
position:relative;

}
}.de-DE{
.u_c_ISPG225.normal{
position:relative;

}
}.de-DE{
.u_c_MWES227.normal{
position:relative;

}
}.de-DE{
.u_c_QJSK229.normal{
position:relative;

}
}.de-DE{
.u_c_OS9P230.normal{
position:relative;

}
}.de-DE{
.u_c_D5FO231.normal{
position:relative;

}
}.de-DE{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.de-DE{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.de-DE{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.de-DE{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.de-DE{
.u_c_H8Z1245.normal{
position:relative;

}
}.de-DE{
.u_c_DG2T246.normal{
position:relative;

}
}.de-DE{
.u_c_A3HT248.normal{
position:relative;

}
}.de-DE{
.u_c_SP4I250.normal{
position:relative;

}
}.de-DE{
.u_c_TQBB252.normal{
position:relative;

}
}.de-DE{
.u_c_BPDA254.normal{
position:relative;

}
}.de-DE{
.u_c_BG5S255.normal{
position:relative;

}
}.de-DE{
.u_c_PCW6256.normal{
position:relative;

}
}.de-DE{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.de-DE{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.de-DE{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.de-DE{
.u_c_TT13266.normal{
position:relative;

}
}.de-DE{
.u_c_BR8S267.normal{
position:relative;

}
}.de-DE{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.de-DE{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.de-DE{
.u_c_F9EU272.normal{
position:relative;

}
}.de-DE{
.u_c_JNPQ273.normal{
position:relative;

}
}.de-DE{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.de-DE{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.de-DE{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.de-DE{
.u_c_9W0637.normal{
position:relative;

}
}.de-DE{
.u_c_OWKT38.normal{
position:relative;

}
}.de-DE{
.u_c_HBXK40.normal{
position:relative;

}
}.de-DE{
.u_c_E33R42.normal{
position:relative;

}
}.de-DE{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.de-DE{
.u_c_HD05279.normal{
position:relative;

}
}.de-DE{
.u_c_BAIN280.normal{
position:relative;

}
}.de-DE{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.de-DE{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.de-DE{
.u_c_JV9F284.normal{
position:relative;

}
}.de-DE{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.de-DE{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.de-DE{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.de-DE{
.u_c_4KIA91.normal{
position:relative;

}
}.de-DE{
.u_c_VSBS92.normal{
position:relative;

}
}.de-DE{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.de-DE{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.de-DE{
.u_c_LRU896.normal{
position:relative;

}
}.de-DE{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.de-DE{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.de-DE{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.de-DE{
.u_c_OMHF291.normal{
position:relative;

}
}.de-DE{
.u_c_GZL0292.normal{
position:relative;

}
}.de-DE{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.de-DE{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.de-DE{
.u_c_SMOH296.normal{
position:relative;

}
}.de-DE{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.de-DE{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.de-DE{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.de-DE{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_TEW3303.normal{
position:relative;

}
}.de-DE{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.de-DE{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.de-DE{
.u_c_FCR3307.normal{
position:relative;

}
}.de-DE{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.de-DE{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.de-DE{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.de-DE{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.de-DE{
.u_c_NX07322.normal{
position:relative;

}
}.de-DE{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.de-DE{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.de-DE{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.de-DE{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.de-DE{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.de-DE{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.de-DE{
.u_c_AWZN29.normal{
position:relative;

}
}.de-DE{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.de-DE{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.de-DE{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.de-DE{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.de-DE{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.de-DE{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.de-DE{
.u_c_2OTG19.normal{
position:relative;

}
}.de-DE{
.u_c_N5XH81.normal{
position:relative;

}
}.de-DE{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.de-DE{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.de-DE{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.de-DE{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.de-DE{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.de-DE{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.de-DE{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.de-DE{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.de-DE{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.de-DE{
.u_c_DF8T332.normal{
position:relative;

}
}.de-DE{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.de-DE{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.de-DE{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.de-DE{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.de-DE{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.de-DE{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.de-DE{
.u_c_PPX633.normal{
position:relative;

}
}.de-DE{
.u_c_ODH034.normal{
position:relative;

}
}.de-DE{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.de-DE{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.de-DE{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.de-DE{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.de-DE{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.de-DE{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.de-DE{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.de-DE{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.de-DE{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.de-DE{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.de-DE{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.de-DE{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.de-DE{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.de-DE{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.de-DE{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.de-DE{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.de-DE{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.de-DE{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.de-DE{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.de-DE{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.de-DE{
.u_c_E548372.normal{
position:relative;

}
}.de-DE{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_GYDD382.normal{
position:relative;

}
}.de-DE{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.de-DE{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.de-DE{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.de-DE{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.de-DE{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.de-DE{
.u_c_AMCZ32.normal{
position:relative;

}
}.de-DE{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.de-DE{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.de-DE{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.de-DE{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.de-DE{
.u_c_5MKI43.normal{
position:relative;

}
}.de-DE{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.de-DE{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.de-DE{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.de-DE{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.de-DE{
.u_c_0ALV52.normal{
position:relative;

}
}.de-DE{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.de-DE{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.de-DE{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.de-DE{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.de-DE{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.de-DE{
.u_c_EGF4391.normal{
position:relative;

}
}.de-DE{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.de-DE{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.de-DE{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.fr-FR{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.fr-FR{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.fr-FR{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_EZ6A156.normal{
position:relative;

}
}.fr-FR{
.u_c_MJVL157.normal{
position:relative;

}
}.fr-FR{
.u_c_LU2L159.normal{
position:relative;

}
}.fr-FR{
.u_c_KB6X161.normal{
position:relative;

}
}.fr-FR{
.u_c_GIVF162.normal{
position:relative;

}
}.fr-FR{
.u_c_O6EY163.normal{
position:relative;

}
}.fr-FR{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.fr-FR{
.u_c_L9U2167.normal{
position:relative;

}
}.fr-FR{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.fr-FR{
.u_c_QJ7T170.normal{
position:relative;

}
}.fr-FR{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.fr-FR{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.fr-FR{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.fr-FR{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.fr-FR{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_U8C4201.normal{
position:relative;

}
}.fr-FR{
.u_c_OKFQ202.normal{
position:relative;

}
}.fr-FR{
.u_c_7CQY204.normal{
position:relative;

}
}.fr-FR{
.u_c_PTZN206.normal{
position:relative;

}
}.fr-FR{
.u_c_VRV4208.normal{
position:relative;

}
}.fr-FR{
.u_c_Z2F7210.normal{
position:relative;

}
}.fr-FR{
.u_c_3NW0211.normal{
position:relative;

}
}.fr-FR{
.u_c_PAQY212.normal{
position:relative;

}
}.fr-FR{
.u_c_TQ08214.normal{
position:relative;

}
}.fr-FR{
.u_c_QZ3T216.normal{
position:relative;

}
}.fr-FR{
.u_c_WUCL218.normal{
position:relative;

}
}.fr-FR{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.fr-FR{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_N0O054.normal{
position:relative;

}
}.fr-FR{
.u_c_NTM477.normal{
position:relative;

}
}.fr-FR{
.u_c_N48357.normal{
position:relative;

}
}.fr-FR{
.u_c_IOWX59.normal{
position:relative;

}
}.fr-FR{
.u_c_MSKH60.normal{
position:relative;

}
}.fr-FR{
.u_c_RQ1579.normal{
position:relative;

}
}.fr-FR{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.fr-FR{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.fr-FR{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.fr-FR{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_HI7Z180.normal{
position:relative;

}
}.fr-FR{
.u_c_D7T4181.normal{
position:relative;

}
}.fr-FR{
.u_c_I55Y183.normal{
position:relative;

}
}.fr-FR{
.u_c_OUV7185.normal{
position:relative;

}
}.fr-FR{
.u_c_IJRB186.normal{
position:relative;

}
}.fr-FR{
.u_c_OPFB187.normal{
position:relative;

}
}.fr-FR{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.fr-FR{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.fr-FR{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.fr-FR{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_7TVH30.normal{
position:relative;

}
}.fr-FR{
.u_c_4FNG31.normal{
position:relative;

}
}.fr-FR{
.u_c_4BRN33.normal{
position:relative;

}
}.fr-FR{
.u_c_0PDC35.normal{
position:relative;

}
}.fr-FR{
.u_c_CLRM36.normal{
position:relative;

}
}.fr-FR{
.u_c_6DO837.normal{
position:relative;

}
}.fr-FR{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.fr-FR{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.fr-FR{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.fr-FR{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_IO9N199.normal{
position:relative;

}
}.fr-FR{
.u_c_IOVB200.normal{
position:relative;

}
}.fr-FR{
.u_c_U7GV202.normal{
position:relative;

}
}.fr-FR{
.u_c_9ZDW204.normal{
position:relative;

}
}.fr-FR{
.u_c_MH8K206.normal{
position:relative;

}
}.fr-FR{
.u_c_OBVL207.normal{
position:relative;

}
}.fr-FR{
.u_c_ML07208.normal{
position:relative;

}
}.fr-FR{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.fr-FR{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.fr-FR{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_TKH9222.normal{
position:relative;

}
}.fr-FR{
.u_c_F50B223.normal{
position:relative;

}
}.fr-FR{
.u_c_ISPG225.normal{
position:relative;

}
}.fr-FR{
.u_c_MWES227.normal{
position:relative;

}
}.fr-FR{
.u_c_QJSK229.normal{
position:relative;

}
}.fr-FR{
.u_c_OS9P230.normal{
position:relative;

}
}.fr-FR{
.u_c_D5FO231.normal{
position:relative;

}
}.fr-FR{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.fr-FR{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.fr-FR{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.fr-FR{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.fr-FR{
.u_c_H8Z1245.normal{
position:relative;

}
}.fr-FR{
.u_c_DG2T246.normal{
position:relative;

}
}.fr-FR{
.u_c_A3HT248.normal{
position:relative;

}
}.fr-FR{
.u_c_SP4I250.normal{
position:relative;

}
}.fr-FR{
.u_c_TQBB252.normal{
position:relative;

}
}.fr-FR{
.u_c_BPDA254.normal{
position:relative;

}
}.fr-FR{
.u_c_BG5S255.normal{
position:relative;

}
}.fr-FR{
.u_c_PCW6256.normal{
position:relative;

}
}.fr-FR{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.fr-FR{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.fr-FR{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.fr-FR{
.u_c_TT13266.normal{
position:relative;

}
}.fr-FR{
.u_c_BR8S267.normal{
position:relative;

}
}.fr-FR{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.fr-FR{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.fr-FR{
.u_c_F9EU272.normal{
position:relative;

}
}.fr-FR{
.u_c_JNPQ273.normal{
position:relative;

}
}.fr-FR{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.fr-FR{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.fr-FR{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.fr-FR{
.u_c_9W0637.normal{
position:relative;

}
}.fr-FR{
.u_c_OWKT38.normal{
position:relative;

}
}.fr-FR{
.u_c_HBXK40.normal{
position:relative;

}
}.fr-FR{
.u_c_E33R42.normal{
position:relative;

}
}.fr-FR{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.fr-FR{
.u_c_HD05279.normal{
position:relative;

}
}.fr-FR{
.u_c_BAIN280.normal{
position:relative;

}
}.fr-FR{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.fr-FR{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.fr-FR{
.u_c_JV9F284.normal{
position:relative;

}
}.fr-FR{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.fr-FR{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.fr-FR{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.fr-FR{
.u_c_4KIA91.normal{
position:relative;

}
}.fr-FR{
.u_c_VSBS92.normal{
position:relative;

}
}.fr-FR{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.fr-FR{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.fr-FR{
.u_c_LRU896.normal{
position:relative;

}
}.fr-FR{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.fr-FR{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.fr-FR{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.fr-FR{
.u_c_OMHF291.normal{
position:relative;

}
}.fr-FR{
.u_c_GZL0292.normal{
position:relative;

}
}.fr-FR{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.fr-FR{
.u_c_SMOH296.normal{
position:relative;

}
}.fr-FR{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.fr-FR{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.fr-FR{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.fr-FR{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_TEW3303.normal{
position:relative;

}
}.fr-FR{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.fr-FR{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.fr-FR{
.u_c_FCR3307.normal{
position:relative;

}
}.fr-FR{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.fr-FR{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.fr-FR{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.fr-FR{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.fr-FR{
.u_c_NX07322.normal{
position:relative;

}
}.fr-FR{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.fr-FR{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.fr-FR{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.fr-FR{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.fr-FR{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.fr-FR{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.fr-FR{
.u_c_AWZN29.normal{
position:relative;

}
}.fr-FR{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.fr-FR{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.fr-FR{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.fr-FR{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.fr-FR{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.fr-FR{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.fr-FR{
.u_c_2OTG19.normal{
position:relative;

}
}.fr-FR{
.u_c_N5XH81.normal{
position:relative;

}
}.fr-FR{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.fr-FR{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.fr-FR{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.fr-FR{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.fr-FR{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.fr-FR{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.fr-FR{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.fr-FR{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.fr-FR{
.u_c_DF8T332.normal{
position:relative;

}
}.fr-FR{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.fr-FR{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.fr-FR{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.fr-FR{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.fr-FR{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.fr-FR{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.fr-FR{
.u_c_PPX633.normal{
position:relative;

}
}.fr-FR{
.u_c_ODH034.normal{
position:relative;

}
}.fr-FR{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.fr-FR{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.fr-FR{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.fr-FR{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.fr-FR{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.fr-FR{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.fr-FR{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.fr-FR{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.fr-FR{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.fr-FR{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.fr-FR{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.fr-FR{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.fr-FR{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.fr-FR{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.fr-FR{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.fr-FR{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.fr-FR{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.fr-FR{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.fr-FR{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.fr-FR{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.fr-FR{
.u_c_E548372.normal{
position:relative;

}
}.fr-FR{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_GYDD382.normal{
position:relative;

}
}.fr-FR{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.fr-FR{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.fr-FR{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.fr-FR{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.fr-FR{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.fr-FR{
.u_c_AMCZ32.normal{
position:relative;

}
}.fr-FR{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.fr-FR{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.fr-FR{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.fr-FR{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.fr-FR{
.u_c_5MKI43.normal{
position:relative;

}
}.fr-FR{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.fr-FR{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.fr-FR{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.fr-FR{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.fr-FR{
.u_c_0ALV52.normal{
position:relative;

}
}.fr-FR{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.fr-FR{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.fr-FR{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.fr-FR{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.fr-FR{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.fr-FR{
.u_c_EGF4391.normal{
position:relative;

}
}.fr-FR{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.fr-FR{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.fr-FR{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ru-RU{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.ru-RU{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.ru-RU{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_EZ6A156.normal{
position:relative;

}
}.ru-RU{
.u_c_MJVL157.normal{
position:relative;

}
}.ru-RU{
.u_c_LU2L159.normal{
position:relative;

}
}.ru-RU{
.u_c_KB6X161.normal{
position:relative;

}
}.ru-RU{
.u_c_GIVF162.normal{
position:relative;

}
}.ru-RU{
.u_c_O6EY163.normal{
position:relative;

}
}.ru-RU{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_L9U2167.normal{
position:relative;

}
}.ru-RU{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.ru-RU{
.u_c_QJ7T170.normal{
position:relative;

}
}.ru-RU{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ru-RU{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ru-RU{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.ru-RU{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.ru-RU{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_U8C4201.normal{
position:relative;

}
}.ru-RU{
.u_c_OKFQ202.normal{
position:relative;

}
}.ru-RU{
.u_c_7CQY204.normal{
position:relative;

}
}.ru-RU{
.u_c_PTZN206.normal{
position:relative;

}
}.ru-RU{
.u_c_VRV4208.normal{
position:relative;

}
}.ru-RU{
.u_c_Z2F7210.normal{
position:relative;

}
}.ru-RU{
.u_c_3NW0211.normal{
position:relative;

}
}.ru-RU{
.u_c_PAQY212.normal{
position:relative;

}
}.ru-RU{
.u_c_TQ08214.normal{
position:relative;

}
}.ru-RU{
.u_c_QZ3T216.normal{
position:relative;

}
}.ru-RU{
.u_c_WUCL218.normal{
position:relative;

}
}.ru-RU{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.ru-RU{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_N0O054.normal{
position:relative;

}
}.ru-RU{
.u_c_NTM477.normal{
position:relative;

}
}.ru-RU{
.u_c_N48357.normal{
position:relative;

}
}.ru-RU{
.u_c_IOWX59.normal{
position:relative;

}
}.ru-RU{
.u_c_MSKH60.normal{
position:relative;

}
}.ru-RU{
.u_c_RQ1579.normal{
position:relative;

}
}.ru-RU{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ru-RU{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.ru-RU{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_HI7Z180.normal{
position:relative;

}
}.ru-RU{
.u_c_D7T4181.normal{
position:relative;

}
}.ru-RU{
.u_c_I55Y183.normal{
position:relative;

}
}.ru-RU{
.u_c_OUV7185.normal{
position:relative;

}
}.ru-RU{
.u_c_IJRB186.normal{
position:relative;

}
}.ru-RU{
.u_c_OPFB187.normal{
position:relative;

}
}.ru-RU{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.ru-RU{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.ru-RU{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_7TVH30.normal{
position:relative;

}
}.ru-RU{
.u_c_4FNG31.normal{
position:relative;

}
}.ru-RU{
.u_c_4BRN33.normal{
position:relative;

}
}.ru-RU{
.u_c_0PDC35.normal{
position:relative;

}
}.ru-RU{
.u_c_CLRM36.normal{
position:relative;

}
}.ru-RU{
.u_c_6DO837.normal{
position:relative;

}
}.ru-RU{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.ru-RU{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ru-RU{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.ru-RU{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_IO9N199.normal{
position:relative;

}
}.ru-RU{
.u_c_IOVB200.normal{
position:relative;

}
}.ru-RU{
.u_c_U7GV202.normal{
position:relative;

}
}.ru-RU{
.u_c_9ZDW204.normal{
position:relative;

}
}.ru-RU{
.u_c_MH8K206.normal{
position:relative;

}
}.ru-RU{
.u_c_OBVL207.normal{
position:relative;

}
}.ru-RU{
.u_c_ML07208.normal{
position:relative;

}
}.ru-RU{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.ru-RU{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.ru-RU{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_TKH9222.normal{
position:relative;

}
}.ru-RU{
.u_c_F50B223.normal{
position:relative;

}
}.ru-RU{
.u_c_ISPG225.normal{
position:relative;

}
}.ru-RU{
.u_c_MWES227.normal{
position:relative;

}
}.ru-RU{
.u_c_QJSK229.normal{
position:relative;

}
}.ru-RU{
.u_c_OS9P230.normal{
position:relative;

}
}.ru-RU{
.u_c_D5FO231.normal{
position:relative;

}
}.ru-RU{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ru-RU{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.ru-RU{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ru-RU{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.ru-RU{
.u_c_H8Z1245.normal{
position:relative;

}
}.ru-RU{
.u_c_DG2T246.normal{
position:relative;

}
}.ru-RU{
.u_c_A3HT248.normal{
position:relative;

}
}.ru-RU{
.u_c_SP4I250.normal{
position:relative;

}
}.ru-RU{
.u_c_TQBB252.normal{
position:relative;

}
}.ru-RU{
.u_c_BPDA254.normal{
position:relative;

}
}.ru-RU{
.u_c_BG5S255.normal{
position:relative;

}
}.ru-RU{
.u_c_PCW6256.normal{
position:relative;

}
}.ru-RU{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ru-RU{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ru-RU{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ru-RU{
.u_c_TT13266.normal{
position:relative;

}
}.ru-RU{
.u_c_BR8S267.normal{
position:relative;

}
}.ru-RU{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.ru-RU{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ru-RU{
.u_c_F9EU272.normal{
position:relative;

}
}.ru-RU{
.u_c_JNPQ273.normal{
position:relative;

}
}.ru-RU{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ru-RU{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.ru-RU{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ru-RU{
.u_c_9W0637.normal{
position:relative;

}
}.ru-RU{
.u_c_OWKT38.normal{
position:relative;

}
}.ru-RU{
.u_c_HBXK40.normal{
position:relative;

}
}.ru-RU{
.u_c_E33R42.normal{
position:relative;

}
}.ru-RU{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ru-RU{
.u_c_HD05279.normal{
position:relative;

}
}.ru-RU{
.u_c_BAIN280.normal{
position:relative;

}
}.ru-RU{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.ru-RU{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.ru-RU{
.u_c_JV9F284.normal{
position:relative;

}
}.ru-RU{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.ru-RU{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ru-RU{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ru-RU{
.u_c_4KIA91.normal{
position:relative;

}
}.ru-RU{
.u_c_VSBS92.normal{
position:relative;

}
}.ru-RU{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.ru-RU{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.ru-RU{
.u_c_LRU896.normal{
position:relative;

}
}.ru-RU{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.ru-RU{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ru-RU{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ru-RU{
.u_c_OMHF291.normal{
position:relative;

}
}.ru-RU{
.u_c_GZL0292.normal{
position:relative;

}
}.ru-RU{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.ru-RU{
.u_c_SMOH296.normal{
position:relative;

}
}.ru-RU{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ru-RU{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ru-RU{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ru-RU{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_TEW3303.normal{
position:relative;

}
}.ru-RU{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.ru-RU{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.ru-RU{
.u_c_FCR3307.normal{
position:relative;

}
}.ru-RU{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ru-RU{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.ru-RU{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ru-RU{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ru-RU{
.u_c_NX07322.normal{
position:relative;

}
}.ru-RU{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ru-RU{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.ru-RU{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.ru-RU{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ru-RU{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ru-RU{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ru-RU{
.u_c_AWZN29.normal{
position:relative;

}
}.ru-RU{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ru-RU{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.ru-RU{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.ru-RU{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.ru-RU{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.ru-RU{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ru-RU{
.u_c_2OTG19.normal{
position:relative;

}
}.ru-RU{
.u_c_N5XH81.normal{
position:relative;

}
}.ru-RU{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ru-RU{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ru-RU{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.ru-RU{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ru-RU{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ru-RU{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ru-RU{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ru-RU{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ru-RU{
.u_c_DF8T332.normal{
position:relative;

}
}.ru-RU{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.ru-RU{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.ru-RU{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ru-RU{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.ru-RU{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.ru-RU{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.ru-RU{
.u_c_PPX633.normal{
position:relative;

}
}.ru-RU{
.u_c_ODH034.normal{
position:relative;

}
}.ru-RU{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.ru-RU{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.ru-RU{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.ru-RU{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ru-RU{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.ru-RU{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.ru-RU{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.ru-RU{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.ru-RU{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.ru-RU{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.ru-RU{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.ru-RU{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.ru-RU{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.ru-RU{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ru-RU{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.ru-RU{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.ru-RU{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ru-RU{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.ru-RU{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.ru-RU{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.ru-RU{
.u_c_E548372.normal{
position:relative;

}
}.ru-RU{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_GYDD382.normal{
position:relative;

}
}.ru-RU{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ru-RU{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.ru-RU{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ru-RU{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.ru-RU{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.ru-RU{
.u_c_AMCZ32.normal{
position:relative;

}
}.ru-RU{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.ru-RU{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ru-RU{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ru-RU{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.ru-RU{
.u_c_5MKI43.normal{
position:relative;

}
}.ru-RU{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.ru-RU{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ru-RU{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ru-RU{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.ru-RU{
.u_c_0ALV52.normal{
position:relative;

}
}.ru-RU{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.ru-RU{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.ru-RU{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ru-RU{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ru-RU{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.ru-RU{
.u_c_EGF4391.normal{
position:relative;

}
}.ru-RU{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.ru-RU{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.ru-RU{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.es-ES{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.es-ES{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.es-ES{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_EZ6A156.normal{
position:relative;

}
}.es-ES{
.u_c_MJVL157.normal{
position:relative;

}
}.es-ES{
.u_c_LU2L159.normal{
position:relative;

}
}.es-ES{
.u_c_KB6X161.normal{
position:relative;

}
}.es-ES{
.u_c_GIVF162.normal{
position:relative;

}
}.es-ES{
.u_c_O6EY163.normal{
position:relative;

}
}.es-ES{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.es-ES{
.u_c_L9U2167.normal{
position:relative;

}
}.es-ES{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.es-ES{
.u_c_QJ7T170.normal{
position:relative;

}
}.es-ES{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.es-ES{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.es-ES{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.es-ES{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.es-ES{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_U8C4201.normal{
position:relative;

}
}.es-ES{
.u_c_OKFQ202.normal{
position:relative;

}
}.es-ES{
.u_c_7CQY204.normal{
position:relative;

}
}.es-ES{
.u_c_PTZN206.normal{
position:relative;

}
}.es-ES{
.u_c_VRV4208.normal{
position:relative;

}
}.es-ES{
.u_c_Z2F7210.normal{
position:relative;

}
}.es-ES{
.u_c_3NW0211.normal{
position:relative;

}
}.es-ES{
.u_c_PAQY212.normal{
position:relative;

}
}.es-ES{
.u_c_TQ08214.normal{
position:relative;

}
}.es-ES{
.u_c_QZ3T216.normal{
position:relative;

}
}.es-ES{
.u_c_WUCL218.normal{
position:relative;

}
}.es-ES{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.es-ES{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_N0O054.normal{
position:relative;

}
}.es-ES{
.u_c_NTM477.normal{
position:relative;

}
}.es-ES{
.u_c_N48357.normal{
position:relative;

}
}.es-ES{
.u_c_IOWX59.normal{
position:relative;

}
}.es-ES{
.u_c_MSKH60.normal{
position:relative;

}
}.es-ES{
.u_c_RQ1579.normal{
position:relative;

}
}.es-ES{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.es-ES{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.es-ES{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.es-ES{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_HI7Z180.normal{
position:relative;

}
}.es-ES{
.u_c_D7T4181.normal{
position:relative;

}
}.es-ES{
.u_c_I55Y183.normal{
position:relative;

}
}.es-ES{
.u_c_OUV7185.normal{
position:relative;

}
}.es-ES{
.u_c_IJRB186.normal{
position:relative;

}
}.es-ES{
.u_c_OPFB187.normal{
position:relative;

}
}.es-ES{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.es-ES{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.es-ES{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.es-ES{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_7TVH30.normal{
position:relative;

}
}.es-ES{
.u_c_4FNG31.normal{
position:relative;

}
}.es-ES{
.u_c_4BRN33.normal{
position:relative;

}
}.es-ES{
.u_c_0PDC35.normal{
position:relative;

}
}.es-ES{
.u_c_CLRM36.normal{
position:relative;

}
}.es-ES{
.u_c_6DO837.normal{
position:relative;

}
}.es-ES{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.es-ES{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.es-ES{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.es-ES{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_IO9N199.normal{
position:relative;

}
}.es-ES{
.u_c_IOVB200.normal{
position:relative;

}
}.es-ES{
.u_c_U7GV202.normal{
position:relative;

}
}.es-ES{
.u_c_9ZDW204.normal{
position:relative;

}
}.es-ES{
.u_c_MH8K206.normal{
position:relative;

}
}.es-ES{
.u_c_OBVL207.normal{
position:relative;

}
}.es-ES{
.u_c_ML07208.normal{
position:relative;

}
}.es-ES{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.es-ES{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.es-ES{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_TKH9222.normal{
position:relative;

}
}.es-ES{
.u_c_F50B223.normal{
position:relative;

}
}.es-ES{
.u_c_ISPG225.normal{
position:relative;

}
}.es-ES{
.u_c_MWES227.normal{
position:relative;

}
}.es-ES{
.u_c_QJSK229.normal{
position:relative;

}
}.es-ES{
.u_c_OS9P230.normal{
position:relative;

}
}.es-ES{
.u_c_D5FO231.normal{
position:relative;

}
}.es-ES{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.es-ES{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.es-ES{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.es-ES{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.es-ES{
.u_c_H8Z1245.normal{
position:relative;

}
}.es-ES{
.u_c_DG2T246.normal{
position:relative;

}
}.es-ES{
.u_c_A3HT248.normal{
position:relative;

}
}.es-ES{
.u_c_SP4I250.normal{
position:relative;

}
}.es-ES{
.u_c_TQBB252.normal{
position:relative;

}
}.es-ES{
.u_c_BPDA254.normal{
position:relative;

}
}.es-ES{
.u_c_BG5S255.normal{
position:relative;

}
}.es-ES{
.u_c_PCW6256.normal{
position:relative;

}
}.es-ES{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.es-ES{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.es-ES{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.es-ES{
.u_c_TT13266.normal{
position:relative;

}
}.es-ES{
.u_c_BR8S267.normal{
position:relative;

}
}.es-ES{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.es-ES{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.es-ES{
.u_c_F9EU272.normal{
position:relative;

}
}.es-ES{
.u_c_JNPQ273.normal{
position:relative;

}
}.es-ES{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.es-ES{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.es-ES{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.es-ES{
.u_c_9W0637.normal{
position:relative;

}
}.es-ES{
.u_c_OWKT38.normal{
position:relative;

}
}.es-ES{
.u_c_HBXK40.normal{
position:relative;

}
}.es-ES{
.u_c_E33R42.normal{
position:relative;

}
}.es-ES{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.es-ES{
.u_c_HD05279.normal{
position:relative;

}
}.es-ES{
.u_c_BAIN280.normal{
position:relative;

}
}.es-ES{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.es-ES{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.es-ES{
.u_c_JV9F284.normal{
position:relative;

}
}.es-ES{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.es-ES{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.es-ES{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.es-ES{
.u_c_4KIA91.normal{
position:relative;

}
}.es-ES{
.u_c_VSBS92.normal{
position:relative;

}
}.es-ES{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.es-ES{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.es-ES{
.u_c_LRU896.normal{
position:relative;

}
}.es-ES{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.es-ES{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.es-ES{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.es-ES{
.u_c_OMHF291.normal{
position:relative;

}
}.es-ES{
.u_c_GZL0292.normal{
position:relative;

}
}.es-ES{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.es-ES{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.es-ES{
.u_c_SMOH296.normal{
position:relative;

}
}.es-ES{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.es-ES{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.es-ES{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.es-ES{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_TEW3303.normal{
position:relative;

}
}.es-ES{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.es-ES{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.es-ES{
.u_c_FCR3307.normal{
position:relative;

}
}.es-ES{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.es-ES{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.es-ES{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.es-ES{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.es-ES{
.u_c_NX07322.normal{
position:relative;

}
}.es-ES{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.es-ES{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.es-ES{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.es-ES{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.es-ES{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.es-ES{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.es-ES{
.u_c_AWZN29.normal{
position:relative;

}
}.es-ES{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.es-ES{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.es-ES{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.es-ES{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.es-ES{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.es-ES{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.es-ES{
.u_c_2OTG19.normal{
position:relative;

}
}.es-ES{
.u_c_N5XH81.normal{
position:relative;

}
}.es-ES{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.es-ES{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.es-ES{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.es-ES{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.es-ES{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.es-ES{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.es-ES{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.es-ES{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.es-ES{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.es-ES{
.u_c_DF8T332.normal{
position:relative;

}
}.es-ES{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.es-ES{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.es-ES{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.es-ES{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.es-ES{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.es-ES{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.es-ES{
.u_c_PPX633.normal{
position:relative;

}
}.es-ES{
.u_c_ODH034.normal{
position:relative;

}
}.es-ES{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.es-ES{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.es-ES{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.es-ES{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.es-ES{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.es-ES{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.es-ES{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.es-ES{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.es-ES{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.es-ES{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.es-ES{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.es-ES{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.es-ES{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.es-ES{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.es-ES{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.es-ES{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.es-ES{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.es-ES{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.es-ES{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.es-ES{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.es-ES{
.u_c_E548372.normal{
position:relative;

}
}.es-ES{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_GYDD382.normal{
position:relative;

}
}.es-ES{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.es-ES{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.es-ES{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.es-ES{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.es-ES{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.es-ES{
.u_c_AMCZ32.normal{
position:relative;

}
}.es-ES{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.es-ES{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.es-ES{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.es-ES{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.es-ES{
.u_c_5MKI43.normal{
position:relative;

}
}.es-ES{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.es-ES{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.es-ES{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.es-ES{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.es-ES{
.u_c_0ALV52.normal{
position:relative;

}
}.es-ES{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.es-ES{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.es-ES{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.es-ES{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.es-ES{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.es-ES{
.u_c_EGF4391.normal{
position:relative;

}
}.es-ES{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.es-ES{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.es-ES{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pt-PT{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.pt-PT{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.pt-PT{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_EZ6A156.normal{
position:relative;

}
}.pt-PT{
.u_c_MJVL157.normal{
position:relative;

}
}.pt-PT{
.u_c_LU2L159.normal{
position:relative;

}
}.pt-PT{
.u_c_KB6X161.normal{
position:relative;

}
}.pt-PT{
.u_c_GIVF162.normal{
position:relative;

}
}.pt-PT{
.u_c_O6EY163.normal{
position:relative;

}
}.pt-PT{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_L9U2167.normal{
position:relative;

}
}.pt-PT{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.pt-PT{
.u_c_QJ7T170.normal{
position:relative;

}
}.pt-PT{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.pt-PT{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.pt-PT{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.pt-PT{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.pt-PT{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_U8C4201.normal{
position:relative;

}
}.pt-PT{
.u_c_OKFQ202.normal{
position:relative;

}
}.pt-PT{
.u_c_7CQY204.normal{
position:relative;

}
}.pt-PT{
.u_c_PTZN206.normal{
position:relative;

}
}.pt-PT{
.u_c_VRV4208.normal{
position:relative;

}
}.pt-PT{
.u_c_Z2F7210.normal{
position:relative;

}
}.pt-PT{
.u_c_3NW0211.normal{
position:relative;

}
}.pt-PT{
.u_c_PAQY212.normal{
position:relative;

}
}.pt-PT{
.u_c_TQ08214.normal{
position:relative;

}
}.pt-PT{
.u_c_QZ3T216.normal{
position:relative;

}
}.pt-PT{
.u_c_WUCL218.normal{
position:relative;

}
}.pt-PT{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.pt-PT{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_N0O054.normal{
position:relative;

}
}.pt-PT{
.u_c_NTM477.normal{
position:relative;

}
}.pt-PT{
.u_c_N48357.normal{
position:relative;

}
}.pt-PT{
.u_c_IOWX59.normal{
position:relative;

}
}.pt-PT{
.u_c_MSKH60.normal{
position:relative;

}
}.pt-PT{
.u_c_RQ1579.normal{
position:relative;

}
}.pt-PT{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.pt-PT{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.pt-PT{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_HI7Z180.normal{
position:relative;

}
}.pt-PT{
.u_c_D7T4181.normal{
position:relative;

}
}.pt-PT{
.u_c_I55Y183.normal{
position:relative;

}
}.pt-PT{
.u_c_OUV7185.normal{
position:relative;

}
}.pt-PT{
.u_c_IJRB186.normal{
position:relative;

}
}.pt-PT{
.u_c_OPFB187.normal{
position:relative;

}
}.pt-PT{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.pt-PT{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.pt-PT{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_7TVH30.normal{
position:relative;

}
}.pt-PT{
.u_c_4FNG31.normal{
position:relative;

}
}.pt-PT{
.u_c_4BRN33.normal{
position:relative;

}
}.pt-PT{
.u_c_0PDC35.normal{
position:relative;

}
}.pt-PT{
.u_c_CLRM36.normal{
position:relative;

}
}.pt-PT{
.u_c_6DO837.normal{
position:relative;

}
}.pt-PT{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.pt-PT{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pt-PT{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.pt-PT{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_IO9N199.normal{
position:relative;

}
}.pt-PT{
.u_c_IOVB200.normal{
position:relative;

}
}.pt-PT{
.u_c_U7GV202.normal{
position:relative;

}
}.pt-PT{
.u_c_9ZDW204.normal{
position:relative;

}
}.pt-PT{
.u_c_MH8K206.normal{
position:relative;

}
}.pt-PT{
.u_c_OBVL207.normal{
position:relative;

}
}.pt-PT{
.u_c_ML07208.normal{
position:relative;

}
}.pt-PT{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.pt-PT{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.pt-PT{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_TKH9222.normal{
position:relative;

}
}.pt-PT{
.u_c_F50B223.normal{
position:relative;

}
}.pt-PT{
.u_c_ISPG225.normal{
position:relative;

}
}.pt-PT{
.u_c_MWES227.normal{
position:relative;

}
}.pt-PT{
.u_c_QJSK229.normal{
position:relative;

}
}.pt-PT{
.u_c_OS9P230.normal{
position:relative;

}
}.pt-PT{
.u_c_D5FO231.normal{
position:relative;

}
}.pt-PT{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pt-PT{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.pt-PT{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pt-PT{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.pt-PT{
.u_c_H8Z1245.normal{
position:relative;

}
}.pt-PT{
.u_c_DG2T246.normal{
position:relative;

}
}.pt-PT{
.u_c_A3HT248.normal{
position:relative;

}
}.pt-PT{
.u_c_SP4I250.normal{
position:relative;

}
}.pt-PT{
.u_c_TQBB252.normal{
position:relative;

}
}.pt-PT{
.u_c_BPDA254.normal{
position:relative;

}
}.pt-PT{
.u_c_BG5S255.normal{
position:relative;

}
}.pt-PT{
.u_c_PCW6256.normal{
position:relative;

}
}.pt-PT{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pt-PT{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pt-PT{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pt-PT{
.u_c_TT13266.normal{
position:relative;

}
}.pt-PT{
.u_c_BR8S267.normal{
position:relative;

}
}.pt-PT{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.pt-PT{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pt-PT{
.u_c_F9EU272.normal{
position:relative;

}
}.pt-PT{
.u_c_JNPQ273.normal{
position:relative;

}
}.pt-PT{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.pt-PT{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.pt-PT{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pt-PT{
.u_c_9W0637.normal{
position:relative;

}
}.pt-PT{
.u_c_OWKT38.normal{
position:relative;

}
}.pt-PT{
.u_c_HBXK40.normal{
position:relative;

}
}.pt-PT{
.u_c_E33R42.normal{
position:relative;

}
}.pt-PT{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.pt-PT{
.u_c_HD05279.normal{
position:relative;

}
}.pt-PT{
.u_c_BAIN280.normal{
position:relative;

}
}.pt-PT{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.pt-PT{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.pt-PT{
.u_c_JV9F284.normal{
position:relative;

}
}.pt-PT{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.pt-PT{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.pt-PT{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.pt-PT{
.u_c_4KIA91.normal{
position:relative;

}
}.pt-PT{
.u_c_VSBS92.normal{
position:relative;

}
}.pt-PT{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.pt-PT{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.pt-PT{
.u_c_LRU896.normal{
position:relative;

}
}.pt-PT{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.pt-PT{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.pt-PT{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.pt-PT{
.u_c_OMHF291.normal{
position:relative;

}
}.pt-PT{
.u_c_GZL0292.normal{
position:relative;

}
}.pt-PT{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.pt-PT{
.u_c_SMOH296.normal{
position:relative;

}
}.pt-PT{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pt-PT{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pt-PT{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.pt-PT{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_TEW3303.normal{
position:relative;

}
}.pt-PT{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.pt-PT{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.pt-PT{
.u_c_FCR3307.normal{
position:relative;

}
}.pt-PT{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.pt-PT{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.pt-PT{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.pt-PT{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pt-PT{
.u_c_NX07322.normal{
position:relative;

}
}.pt-PT{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.pt-PT{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.pt-PT{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.pt-PT{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.pt-PT{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.pt-PT{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.pt-PT{
.u_c_AWZN29.normal{
position:relative;

}
}.pt-PT{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.pt-PT{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.pt-PT{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.pt-PT{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.pt-PT{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.pt-PT{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.pt-PT{
.u_c_2OTG19.normal{
position:relative;

}
}.pt-PT{
.u_c_N5XH81.normal{
position:relative;

}
}.pt-PT{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.pt-PT{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.pt-PT{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.pt-PT{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.pt-PT{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.pt-PT{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.pt-PT{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.pt-PT{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.pt-PT{
.u_c_DF8T332.normal{
position:relative;

}
}.pt-PT{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.pt-PT{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.pt-PT{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.pt-PT{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.pt-PT{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.pt-PT{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.pt-PT{
.u_c_PPX633.normal{
position:relative;

}
}.pt-PT{
.u_c_ODH034.normal{
position:relative;

}
}.pt-PT{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.pt-PT{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.pt-PT{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.pt-PT{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.pt-PT{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.pt-PT{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.pt-PT{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.pt-PT{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.pt-PT{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.pt-PT{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.pt-PT{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.pt-PT{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.pt-PT{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.pt-PT{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pt-PT{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.pt-PT{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.pt-PT{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pt-PT{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.pt-PT{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.pt-PT{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.pt-PT{
.u_c_E548372.normal{
position:relative;

}
}.pt-PT{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_GYDD382.normal{
position:relative;

}
}.pt-PT{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pt-PT{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.pt-PT{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.pt-PT{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.pt-PT{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.pt-PT{
.u_c_AMCZ32.normal{
position:relative;

}
}.pt-PT{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.pt-PT{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.pt-PT{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pt-PT{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.pt-PT{
.u_c_5MKI43.normal{
position:relative;

}
}.pt-PT{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.pt-PT{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.pt-PT{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pt-PT{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.pt-PT{
.u_c_0ALV52.normal{
position:relative;

}
}.pt-PT{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.pt-PT{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.pt-PT{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.pt-PT{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pt-PT{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.pt-PT{
.u_c_EGF4391.normal{
position:relative;

}
}.pt-PT{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.pt-PT{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.pt-PT{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.it-IT{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.it-IT{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.it-IT{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_EZ6A156.normal{
position:relative;

}
}.it-IT{
.u_c_MJVL157.normal{
position:relative;

}
}.it-IT{
.u_c_LU2L159.normal{
position:relative;

}
}.it-IT{
.u_c_KB6X161.normal{
position:relative;

}
}.it-IT{
.u_c_GIVF162.normal{
position:relative;

}
}.it-IT{
.u_c_O6EY163.normal{
position:relative;

}
}.it-IT{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.it-IT{
.u_c_L9U2167.normal{
position:relative;

}
}.it-IT{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.it-IT{
.u_c_QJ7T170.normal{
position:relative;

}
}.it-IT{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.it-IT{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.it-IT{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.it-IT{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.it-IT{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_U8C4201.normal{
position:relative;

}
}.it-IT{
.u_c_OKFQ202.normal{
position:relative;

}
}.it-IT{
.u_c_7CQY204.normal{
position:relative;

}
}.it-IT{
.u_c_PTZN206.normal{
position:relative;

}
}.it-IT{
.u_c_VRV4208.normal{
position:relative;

}
}.it-IT{
.u_c_Z2F7210.normal{
position:relative;

}
}.it-IT{
.u_c_3NW0211.normal{
position:relative;

}
}.it-IT{
.u_c_PAQY212.normal{
position:relative;

}
}.it-IT{
.u_c_TQ08214.normal{
position:relative;

}
}.it-IT{
.u_c_QZ3T216.normal{
position:relative;

}
}.it-IT{
.u_c_WUCL218.normal{
position:relative;

}
}.it-IT{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.it-IT{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_N0O054.normal{
position:relative;

}
}.it-IT{
.u_c_NTM477.normal{
position:relative;

}
}.it-IT{
.u_c_N48357.normal{
position:relative;

}
}.it-IT{
.u_c_IOWX59.normal{
position:relative;

}
}.it-IT{
.u_c_MSKH60.normal{
position:relative;

}
}.it-IT{
.u_c_RQ1579.normal{
position:relative;

}
}.it-IT{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.it-IT{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.it-IT{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.it-IT{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_HI7Z180.normal{
position:relative;

}
}.it-IT{
.u_c_D7T4181.normal{
position:relative;

}
}.it-IT{
.u_c_I55Y183.normal{
position:relative;

}
}.it-IT{
.u_c_OUV7185.normal{
position:relative;

}
}.it-IT{
.u_c_IJRB186.normal{
position:relative;

}
}.it-IT{
.u_c_OPFB187.normal{
position:relative;

}
}.it-IT{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.it-IT{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.it-IT{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.it-IT{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_7TVH30.normal{
position:relative;

}
}.it-IT{
.u_c_4FNG31.normal{
position:relative;

}
}.it-IT{
.u_c_4BRN33.normal{
position:relative;

}
}.it-IT{
.u_c_0PDC35.normal{
position:relative;

}
}.it-IT{
.u_c_CLRM36.normal{
position:relative;

}
}.it-IT{
.u_c_6DO837.normal{
position:relative;

}
}.it-IT{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.it-IT{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.it-IT{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.it-IT{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_IO9N199.normal{
position:relative;

}
}.it-IT{
.u_c_IOVB200.normal{
position:relative;

}
}.it-IT{
.u_c_U7GV202.normal{
position:relative;

}
}.it-IT{
.u_c_9ZDW204.normal{
position:relative;

}
}.it-IT{
.u_c_MH8K206.normal{
position:relative;

}
}.it-IT{
.u_c_OBVL207.normal{
position:relative;

}
}.it-IT{
.u_c_ML07208.normal{
position:relative;

}
}.it-IT{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.it-IT{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.it-IT{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_TKH9222.normal{
position:relative;

}
}.it-IT{
.u_c_F50B223.normal{
position:relative;

}
}.it-IT{
.u_c_ISPG225.normal{
position:relative;

}
}.it-IT{
.u_c_MWES227.normal{
position:relative;

}
}.it-IT{
.u_c_QJSK229.normal{
position:relative;

}
}.it-IT{
.u_c_OS9P230.normal{
position:relative;

}
}.it-IT{
.u_c_D5FO231.normal{
position:relative;

}
}.it-IT{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.it-IT{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.it-IT{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.it-IT{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.it-IT{
.u_c_H8Z1245.normal{
position:relative;

}
}.it-IT{
.u_c_DG2T246.normal{
position:relative;

}
}.it-IT{
.u_c_A3HT248.normal{
position:relative;

}
}.it-IT{
.u_c_SP4I250.normal{
position:relative;

}
}.it-IT{
.u_c_TQBB252.normal{
position:relative;

}
}.it-IT{
.u_c_BPDA254.normal{
position:relative;

}
}.it-IT{
.u_c_BG5S255.normal{
position:relative;

}
}.it-IT{
.u_c_PCW6256.normal{
position:relative;

}
}.it-IT{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.it-IT{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.it-IT{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.it-IT{
.u_c_TT13266.normal{
position:relative;

}
}.it-IT{
.u_c_BR8S267.normal{
position:relative;

}
}.it-IT{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.it-IT{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.it-IT{
.u_c_F9EU272.normal{
position:relative;

}
}.it-IT{
.u_c_JNPQ273.normal{
position:relative;

}
}.it-IT{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.it-IT{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.it-IT{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.it-IT{
.u_c_9W0637.normal{
position:relative;

}
}.it-IT{
.u_c_OWKT38.normal{
position:relative;

}
}.it-IT{
.u_c_HBXK40.normal{
position:relative;

}
}.it-IT{
.u_c_E33R42.normal{
position:relative;

}
}.it-IT{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.it-IT{
.u_c_HD05279.normal{
position:relative;

}
}.it-IT{
.u_c_BAIN280.normal{
position:relative;

}
}.it-IT{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.it-IT{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.it-IT{
.u_c_JV9F284.normal{
position:relative;

}
}.it-IT{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.it-IT{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.it-IT{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.it-IT{
.u_c_4KIA91.normal{
position:relative;

}
}.it-IT{
.u_c_VSBS92.normal{
position:relative;

}
}.it-IT{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.it-IT{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.it-IT{
.u_c_LRU896.normal{
position:relative;

}
}.it-IT{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.it-IT{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.it-IT{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.it-IT{
.u_c_OMHF291.normal{
position:relative;

}
}.it-IT{
.u_c_GZL0292.normal{
position:relative;

}
}.it-IT{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.it-IT{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.it-IT{
.u_c_SMOH296.normal{
position:relative;

}
}.it-IT{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.it-IT{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.it-IT{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.it-IT{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_TEW3303.normal{
position:relative;

}
}.it-IT{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.it-IT{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.it-IT{
.u_c_FCR3307.normal{
position:relative;

}
}.it-IT{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.it-IT{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.it-IT{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.it-IT{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.it-IT{
.u_c_NX07322.normal{
position:relative;

}
}.it-IT{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.it-IT{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.it-IT{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.it-IT{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.it-IT{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.it-IT{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.it-IT{
.u_c_AWZN29.normal{
position:relative;

}
}.it-IT{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.it-IT{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.it-IT{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.it-IT{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.it-IT{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.it-IT{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.it-IT{
.u_c_2OTG19.normal{
position:relative;

}
}.it-IT{
.u_c_N5XH81.normal{
position:relative;

}
}.it-IT{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.it-IT{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.it-IT{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.it-IT{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.it-IT{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.it-IT{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.it-IT{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.it-IT{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.it-IT{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.it-IT{
.u_c_DF8T332.normal{
position:relative;

}
}.it-IT{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.it-IT{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.it-IT{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.it-IT{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.it-IT{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.it-IT{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.it-IT{
.u_c_PPX633.normal{
position:relative;

}
}.it-IT{
.u_c_ODH034.normal{
position:relative;

}
}.it-IT{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.it-IT{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.it-IT{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.it-IT{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.it-IT{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.it-IT{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.it-IT{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.it-IT{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.it-IT{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.it-IT{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.it-IT{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.it-IT{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.it-IT{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.it-IT{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.it-IT{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.it-IT{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.it-IT{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.it-IT{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.it-IT{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.it-IT{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.it-IT{
.u_c_E548372.normal{
position:relative;

}
}.it-IT{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_GYDD382.normal{
position:relative;

}
}.it-IT{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.it-IT{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.it-IT{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.it-IT{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.it-IT{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.it-IT{
.u_c_AMCZ32.normal{
position:relative;

}
}.it-IT{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.it-IT{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.it-IT{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.it-IT{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.it-IT{
.u_c_5MKI43.normal{
position:relative;

}
}.it-IT{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.it-IT{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.it-IT{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.it-IT{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.it-IT{
.u_c_0ALV52.normal{
position:relative;

}
}.it-IT{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.it-IT{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.it-IT{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.it-IT{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.it-IT{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.it-IT{
.u_c_EGF4391.normal{
position:relative;

}
}.it-IT{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.it-IT{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.it-IT{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.tr-TR{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.tr-TR{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.tr-TR{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_EZ6A156.normal{
position:relative;

}
}.tr-TR{
.u_c_MJVL157.normal{
position:relative;

}
}.tr-TR{
.u_c_LU2L159.normal{
position:relative;

}
}.tr-TR{
.u_c_KB6X161.normal{
position:relative;

}
}.tr-TR{
.u_c_GIVF162.normal{
position:relative;

}
}.tr-TR{
.u_c_O6EY163.normal{
position:relative;

}
}.tr-TR{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.tr-TR{
.u_c_L9U2167.normal{
position:relative;

}
}.tr-TR{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.tr-TR{
.u_c_QJ7T170.normal{
position:relative;

}
}.tr-TR{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.tr-TR{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.tr-TR{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.tr-TR{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.tr-TR{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_U8C4201.normal{
position:relative;

}
}.tr-TR{
.u_c_OKFQ202.normal{
position:relative;

}
}.tr-TR{
.u_c_7CQY204.normal{
position:relative;

}
}.tr-TR{
.u_c_PTZN206.normal{
position:relative;

}
}.tr-TR{
.u_c_VRV4208.normal{
position:relative;

}
}.tr-TR{
.u_c_Z2F7210.normal{
position:relative;

}
}.tr-TR{
.u_c_3NW0211.normal{
position:relative;

}
}.tr-TR{
.u_c_PAQY212.normal{
position:relative;

}
}.tr-TR{
.u_c_TQ08214.normal{
position:relative;

}
}.tr-TR{
.u_c_QZ3T216.normal{
position:relative;

}
}.tr-TR{
.u_c_WUCL218.normal{
position:relative;

}
}.tr-TR{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.tr-TR{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_N0O054.normal{
position:relative;

}
}.tr-TR{
.u_c_NTM477.normal{
position:relative;

}
}.tr-TR{
.u_c_N48357.normal{
position:relative;

}
}.tr-TR{
.u_c_IOWX59.normal{
position:relative;

}
}.tr-TR{
.u_c_MSKH60.normal{
position:relative;

}
}.tr-TR{
.u_c_RQ1579.normal{
position:relative;

}
}.tr-TR{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.tr-TR{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.tr-TR{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.tr-TR{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_HI7Z180.normal{
position:relative;

}
}.tr-TR{
.u_c_D7T4181.normal{
position:relative;

}
}.tr-TR{
.u_c_I55Y183.normal{
position:relative;

}
}.tr-TR{
.u_c_OUV7185.normal{
position:relative;

}
}.tr-TR{
.u_c_IJRB186.normal{
position:relative;

}
}.tr-TR{
.u_c_OPFB187.normal{
position:relative;

}
}.tr-TR{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.tr-TR{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.tr-TR{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.tr-TR{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_7TVH30.normal{
position:relative;

}
}.tr-TR{
.u_c_4FNG31.normal{
position:relative;

}
}.tr-TR{
.u_c_4BRN33.normal{
position:relative;

}
}.tr-TR{
.u_c_0PDC35.normal{
position:relative;

}
}.tr-TR{
.u_c_CLRM36.normal{
position:relative;

}
}.tr-TR{
.u_c_6DO837.normal{
position:relative;

}
}.tr-TR{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.tr-TR{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.tr-TR{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.tr-TR{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_IO9N199.normal{
position:relative;

}
}.tr-TR{
.u_c_IOVB200.normal{
position:relative;

}
}.tr-TR{
.u_c_U7GV202.normal{
position:relative;

}
}.tr-TR{
.u_c_9ZDW204.normal{
position:relative;

}
}.tr-TR{
.u_c_MH8K206.normal{
position:relative;

}
}.tr-TR{
.u_c_OBVL207.normal{
position:relative;

}
}.tr-TR{
.u_c_ML07208.normal{
position:relative;

}
}.tr-TR{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.tr-TR{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.tr-TR{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_TKH9222.normal{
position:relative;

}
}.tr-TR{
.u_c_F50B223.normal{
position:relative;

}
}.tr-TR{
.u_c_ISPG225.normal{
position:relative;

}
}.tr-TR{
.u_c_MWES227.normal{
position:relative;

}
}.tr-TR{
.u_c_QJSK229.normal{
position:relative;

}
}.tr-TR{
.u_c_OS9P230.normal{
position:relative;

}
}.tr-TR{
.u_c_D5FO231.normal{
position:relative;

}
}.tr-TR{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.tr-TR{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.tr-TR{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.tr-TR{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.tr-TR{
.u_c_H8Z1245.normal{
position:relative;

}
}.tr-TR{
.u_c_DG2T246.normal{
position:relative;

}
}.tr-TR{
.u_c_A3HT248.normal{
position:relative;

}
}.tr-TR{
.u_c_SP4I250.normal{
position:relative;

}
}.tr-TR{
.u_c_TQBB252.normal{
position:relative;

}
}.tr-TR{
.u_c_BPDA254.normal{
position:relative;

}
}.tr-TR{
.u_c_BG5S255.normal{
position:relative;

}
}.tr-TR{
.u_c_PCW6256.normal{
position:relative;

}
}.tr-TR{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.tr-TR{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.tr-TR{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.tr-TR{
.u_c_TT13266.normal{
position:relative;

}
}.tr-TR{
.u_c_BR8S267.normal{
position:relative;

}
}.tr-TR{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.tr-TR{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.tr-TR{
.u_c_F9EU272.normal{
position:relative;

}
}.tr-TR{
.u_c_JNPQ273.normal{
position:relative;

}
}.tr-TR{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.tr-TR{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.tr-TR{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.tr-TR{
.u_c_9W0637.normal{
position:relative;

}
}.tr-TR{
.u_c_OWKT38.normal{
position:relative;

}
}.tr-TR{
.u_c_HBXK40.normal{
position:relative;

}
}.tr-TR{
.u_c_E33R42.normal{
position:relative;

}
}.tr-TR{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.tr-TR{
.u_c_HD05279.normal{
position:relative;

}
}.tr-TR{
.u_c_BAIN280.normal{
position:relative;

}
}.tr-TR{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.tr-TR{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.tr-TR{
.u_c_JV9F284.normal{
position:relative;

}
}.tr-TR{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.tr-TR{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.tr-TR{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.tr-TR{
.u_c_4KIA91.normal{
position:relative;

}
}.tr-TR{
.u_c_VSBS92.normal{
position:relative;

}
}.tr-TR{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.tr-TR{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.tr-TR{
.u_c_LRU896.normal{
position:relative;

}
}.tr-TR{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.tr-TR{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.tr-TR{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.tr-TR{
.u_c_OMHF291.normal{
position:relative;

}
}.tr-TR{
.u_c_GZL0292.normal{
position:relative;

}
}.tr-TR{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.tr-TR{
.u_c_SMOH296.normal{
position:relative;

}
}.tr-TR{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.tr-TR{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.tr-TR{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.tr-TR{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_TEW3303.normal{
position:relative;

}
}.tr-TR{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.tr-TR{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.tr-TR{
.u_c_FCR3307.normal{
position:relative;

}
}.tr-TR{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.tr-TR{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.tr-TR{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.tr-TR{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.tr-TR{
.u_c_NX07322.normal{
position:relative;

}
}.tr-TR{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.tr-TR{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.tr-TR{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.tr-TR{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.tr-TR{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.tr-TR{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.tr-TR{
.u_c_AWZN29.normal{
position:relative;

}
}.tr-TR{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.tr-TR{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.tr-TR{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.tr-TR{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.tr-TR{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.tr-TR{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.tr-TR{
.u_c_2OTG19.normal{
position:relative;

}
}.tr-TR{
.u_c_N5XH81.normal{
position:relative;

}
}.tr-TR{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.tr-TR{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.tr-TR{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.tr-TR{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.tr-TR{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.tr-TR{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.tr-TR{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.tr-TR{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.tr-TR{
.u_c_DF8T332.normal{
position:relative;

}
}.tr-TR{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.tr-TR{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.tr-TR{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.tr-TR{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.tr-TR{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.tr-TR{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.tr-TR{
.u_c_PPX633.normal{
position:relative;

}
}.tr-TR{
.u_c_ODH034.normal{
position:relative;

}
}.tr-TR{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.tr-TR{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.tr-TR{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.tr-TR{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.tr-TR{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.tr-TR{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.tr-TR{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.tr-TR{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.tr-TR{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.tr-TR{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.tr-TR{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.tr-TR{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.tr-TR{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.tr-TR{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.tr-TR{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.tr-TR{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.tr-TR{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.tr-TR{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.tr-TR{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.tr-TR{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.tr-TR{
.u_c_E548372.normal{
position:relative;

}
}.tr-TR{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_GYDD382.normal{
position:relative;

}
}.tr-TR{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.tr-TR{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.tr-TR{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.tr-TR{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.tr-TR{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.tr-TR{
.u_c_AMCZ32.normal{
position:relative;

}
}.tr-TR{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.tr-TR{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.tr-TR{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.tr-TR{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.tr-TR{
.u_c_5MKI43.normal{
position:relative;

}
}.tr-TR{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.tr-TR{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.tr-TR{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.tr-TR{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.tr-TR{
.u_c_0ALV52.normal{
position:relative;

}
}.tr-TR{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.tr-TR{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.tr-TR{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.tr-TR{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.tr-TR{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.tr-TR{
.u_c_EGF4391.normal{
position:relative;

}
}.tr-TR{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.tr-TR{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.tr-TR{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pl-PL{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.pl-PL{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.pl-PL{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_EZ6A156.normal{
position:relative;

}
}.pl-PL{
.u_c_MJVL157.normal{
position:relative;

}
}.pl-PL{
.u_c_LU2L159.normal{
position:relative;

}
}.pl-PL{
.u_c_KB6X161.normal{
position:relative;

}
}.pl-PL{
.u_c_GIVF162.normal{
position:relative;

}
}.pl-PL{
.u_c_O6EY163.normal{
position:relative;

}
}.pl-PL{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.pl-PL{
.u_c_L9U2167.normal{
position:relative;

}
}.pl-PL{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.pl-PL{
.u_c_QJ7T170.normal{
position:relative;

}
}.pl-PL{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.pl-PL{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.pl-PL{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.pl-PL{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.pl-PL{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_U8C4201.normal{
position:relative;

}
}.pl-PL{
.u_c_OKFQ202.normal{
position:relative;

}
}.pl-PL{
.u_c_7CQY204.normal{
position:relative;

}
}.pl-PL{
.u_c_PTZN206.normal{
position:relative;

}
}.pl-PL{
.u_c_VRV4208.normal{
position:relative;

}
}.pl-PL{
.u_c_Z2F7210.normal{
position:relative;

}
}.pl-PL{
.u_c_3NW0211.normal{
position:relative;

}
}.pl-PL{
.u_c_PAQY212.normal{
position:relative;

}
}.pl-PL{
.u_c_TQ08214.normal{
position:relative;

}
}.pl-PL{
.u_c_QZ3T216.normal{
position:relative;

}
}.pl-PL{
.u_c_WUCL218.normal{
position:relative;

}
}.pl-PL{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.pl-PL{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_N0O054.normal{
position:relative;

}
}.pl-PL{
.u_c_NTM477.normal{
position:relative;

}
}.pl-PL{
.u_c_N48357.normal{
position:relative;

}
}.pl-PL{
.u_c_IOWX59.normal{
position:relative;

}
}.pl-PL{
.u_c_MSKH60.normal{
position:relative;

}
}.pl-PL{
.u_c_RQ1579.normal{
position:relative;

}
}.pl-PL{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.pl-PL{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.pl-PL{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.pl-PL{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_HI7Z180.normal{
position:relative;

}
}.pl-PL{
.u_c_D7T4181.normal{
position:relative;

}
}.pl-PL{
.u_c_I55Y183.normal{
position:relative;

}
}.pl-PL{
.u_c_OUV7185.normal{
position:relative;

}
}.pl-PL{
.u_c_IJRB186.normal{
position:relative;

}
}.pl-PL{
.u_c_OPFB187.normal{
position:relative;

}
}.pl-PL{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.pl-PL{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.pl-PL{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.pl-PL{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_7TVH30.normal{
position:relative;

}
}.pl-PL{
.u_c_4FNG31.normal{
position:relative;

}
}.pl-PL{
.u_c_4BRN33.normal{
position:relative;

}
}.pl-PL{
.u_c_0PDC35.normal{
position:relative;

}
}.pl-PL{
.u_c_CLRM36.normal{
position:relative;

}
}.pl-PL{
.u_c_6DO837.normal{
position:relative;

}
}.pl-PL{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.pl-PL{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pl-PL{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.pl-PL{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_IO9N199.normal{
position:relative;

}
}.pl-PL{
.u_c_IOVB200.normal{
position:relative;

}
}.pl-PL{
.u_c_U7GV202.normal{
position:relative;

}
}.pl-PL{
.u_c_9ZDW204.normal{
position:relative;

}
}.pl-PL{
.u_c_MH8K206.normal{
position:relative;

}
}.pl-PL{
.u_c_OBVL207.normal{
position:relative;

}
}.pl-PL{
.u_c_ML07208.normal{
position:relative;

}
}.pl-PL{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.pl-PL{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.pl-PL{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_TKH9222.normal{
position:relative;

}
}.pl-PL{
.u_c_F50B223.normal{
position:relative;

}
}.pl-PL{
.u_c_ISPG225.normal{
position:relative;

}
}.pl-PL{
.u_c_MWES227.normal{
position:relative;

}
}.pl-PL{
.u_c_QJSK229.normal{
position:relative;

}
}.pl-PL{
.u_c_OS9P230.normal{
position:relative;

}
}.pl-PL{
.u_c_D5FO231.normal{
position:relative;

}
}.pl-PL{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pl-PL{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.pl-PL{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.pl-PL{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.pl-PL{
.u_c_H8Z1245.normal{
position:relative;

}
}.pl-PL{
.u_c_DG2T246.normal{
position:relative;

}
}.pl-PL{
.u_c_A3HT248.normal{
position:relative;

}
}.pl-PL{
.u_c_SP4I250.normal{
position:relative;

}
}.pl-PL{
.u_c_TQBB252.normal{
position:relative;

}
}.pl-PL{
.u_c_BPDA254.normal{
position:relative;

}
}.pl-PL{
.u_c_BG5S255.normal{
position:relative;

}
}.pl-PL{
.u_c_PCW6256.normal{
position:relative;

}
}.pl-PL{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.pl-PL{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.pl-PL{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.pl-PL{
.u_c_TT13266.normal{
position:relative;

}
}.pl-PL{
.u_c_BR8S267.normal{
position:relative;

}
}.pl-PL{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.pl-PL{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.pl-PL{
.u_c_F9EU272.normal{
position:relative;

}
}.pl-PL{
.u_c_JNPQ273.normal{
position:relative;

}
}.pl-PL{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.pl-PL{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.pl-PL{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.pl-PL{
.u_c_9W0637.normal{
position:relative;

}
}.pl-PL{
.u_c_OWKT38.normal{
position:relative;

}
}.pl-PL{
.u_c_HBXK40.normal{
position:relative;

}
}.pl-PL{
.u_c_E33R42.normal{
position:relative;

}
}.pl-PL{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.pl-PL{
.u_c_HD05279.normal{
position:relative;

}
}.pl-PL{
.u_c_BAIN280.normal{
position:relative;

}
}.pl-PL{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.pl-PL{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.pl-PL{
.u_c_JV9F284.normal{
position:relative;

}
}.pl-PL{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.pl-PL{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.pl-PL{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.pl-PL{
.u_c_4KIA91.normal{
position:relative;

}
}.pl-PL{
.u_c_VSBS92.normal{
position:relative;

}
}.pl-PL{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.pl-PL{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.pl-PL{
.u_c_LRU896.normal{
position:relative;

}
}.pl-PL{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.pl-PL{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.pl-PL{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.pl-PL{
.u_c_OMHF291.normal{
position:relative;

}
}.pl-PL{
.u_c_GZL0292.normal{
position:relative;

}
}.pl-PL{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.pl-PL{
.u_c_SMOH296.normal{
position:relative;

}
}.pl-PL{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.pl-PL{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.pl-PL{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.pl-PL{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_TEW3303.normal{
position:relative;

}
}.pl-PL{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.pl-PL{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.pl-PL{
.u_c_FCR3307.normal{
position:relative;

}
}.pl-PL{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.pl-PL{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.pl-PL{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.pl-PL{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.pl-PL{
.u_c_NX07322.normal{
position:relative;

}
}.pl-PL{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.pl-PL{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.pl-PL{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.pl-PL{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.pl-PL{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.pl-PL{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.pl-PL{
.u_c_AWZN29.normal{
position:relative;

}
}.pl-PL{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.pl-PL{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.pl-PL{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.pl-PL{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.pl-PL{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.pl-PL{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.pl-PL{
.u_c_2OTG19.normal{
position:relative;

}
}.pl-PL{
.u_c_N5XH81.normal{
position:relative;

}
}.pl-PL{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.pl-PL{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.pl-PL{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.pl-PL{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.pl-PL{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.pl-PL{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.pl-PL{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.pl-PL{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.pl-PL{
.u_c_DF8T332.normal{
position:relative;

}
}.pl-PL{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.pl-PL{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.pl-PL{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.pl-PL{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.pl-PL{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.pl-PL{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.pl-PL{
.u_c_PPX633.normal{
position:relative;

}
}.pl-PL{
.u_c_ODH034.normal{
position:relative;

}
}.pl-PL{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.pl-PL{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.pl-PL{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.pl-PL{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.pl-PL{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.pl-PL{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.pl-PL{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.pl-PL{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.pl-PL{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.pl-PL{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.pl-PL{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.pl-PL{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.pl-PL{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.pl-PL{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.pl-PL{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.pl-PL{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.pl-PL{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.pl-PL{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.pl-PL{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.pl-PL{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.pl-PL{
.u_c_E548372.normal{
position:relative;

}
}.pl-PL{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_GYDD382.normal{
position:relative;

}
}.pl-PL{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.pl-PL{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.pl-PL{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.pl-PL{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.pl-PL{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.pl-PL{
.u_c_AMCZ32.normal{
position:relative;

}
}.pl-PL{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.pl-PL{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.pl-PL{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pl-PL{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.pl-PL{
.u_c_5MKI43.normal{
position:relative;

}
}.pl-PL{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.pl-PL{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.pl-PL{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pl-PL{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.pl-PL{
.u_c_0ALV52.normal{
position:relative;

}
}.pl-PL{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.pl-PL{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.pl-PL{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.pl-PL{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.pl-PL{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.pl-PL{
.u_c_EGF4391.normal{
position:relative;

}
}.pl-PL{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.pl-PL{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.pl-PL{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.id-ID{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.id-ID{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.id-ID{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_EZ6A156.normal{
position:relative;

}
}.id-ID{
.u_c_MJVL157.normal{
position:relative;

}
}.id-ID{
.u_c_LU2L159.normal{
position:relative;

}
}.id-ID{
.u_c_KB6X161.normal{
position:relative;

}
}.id-ID{
.u_c_GIVF162.normal{
position:relative;

}
}.id-ID{
.u_c_O6EY163.normal{
position:relative;

}
}.id-ID{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.id-ID{
.u_c_L9U2167.normal{
position:relative;

}
}.id-ID{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.id-ID{
.u_c_QJ7T170.normal{
position:relative;

}
}.id-ID{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.id-ID{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.id-ID{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.id-ID{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.id-ID{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_U8C4201.normal{
position:relative;

}
}.id-ID{
.u_c_OKFQ202.normal{
position:relative;

}
}.id-ID{
.u_c_7CQY204.normal{
position:relative;

}
}.id-ID{
.u_c_PTZN206.normal{
position:relative;

}
}.id-ID{
.u_c_VRV4208.normal{
position:relative;

}
}.id-ID{
.u_c_Z2F7210.normal{
position:relative;

}
}.id-ID{
.u_c_3NW0211.normal{
position:relative;

}
}.id-ID{
.u_c_PAQY212.normal{
position:relative;

}
}.id-ID{
.u_c_TQ08214.normal{
position:relative;

}
}.id-ID{
.u_c_QZ3T216.normal{
position:relative;

}
}.id-ID{
.u_c_WUCL218.normal{
position:relative;

}
}.id-ID{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.id-ID{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_N0O054.normal{
position:relative;

}
}.id-ID{
.u_c_NTM477.normal{
position:relative;

}
}.id-ID{
.u_c_N48357.normal{
position:relative;

}
}.id-ID{
.u_c_IOWX59.normal{
position:relative;

}
}.id-ID{
.u_c_MSKH60.normal{
position:relative;

}
}.id-ID{
.u_c_RQ1579.normal{
position:relative;

}
}.id-ID{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.id-ID{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.id-ID{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.id-ID{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_HI7Z180.normal{
position:relative;

}
}.id-ID{
.u_c_D7T4181.normal{
position:relative;

}
}.id-ID{
.u_c_I55Y183.normal{
position:relative;

}
}.id-ID{
.u_c_OUV7185.normal{
position:relative;

}
}.id-ID{
.u_c_IJRB186.normal{
position:relative;

}
}.id-ID{
.u_c_OPFB187.normal{
position:relative;

}
}.id-ID{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.id-ID{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.id-ID{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.id-ID{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_7TVH30.normal{
position:relative;

}
}.id-ID{
.u_c_4FNG31.normal{
position:relative;

}
}.id-ID{
.u_c_4BRN33.normal{
position:relative;

}
}.id-ID{
.u_c_0PDC35.normal{
position:relative;

}
}.id-ID{
.u_c_CLRM36.normal{
position:relative;

}
}.id-ID{
.u_c_6DO837.normal{
position:relative;

}
}.id-ID{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.id-ID{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.id-ID{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.id-ID{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_IO9N199.normal{
position:relative;

}
}.id-ID{
.u_c_IOVB200.normal{
position:relative;

}
}.id-ID{
.u_c_U7GV202.normal{
position:relative;

}
}.id-ID{
.u_c_9ZDW204.normal{
position:relative;

}
}.id-ID{
.u_c_MH8K206.normal{
position:relative;

}
}.id-ID{
.u_c_OBVL207.normal{
position:relative;

}
}.id-ID{
.u_c_ML07208.normal{
position:relative;

}
}.id-ID{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.id-ID{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.id-ID{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_TKH9222.normal{
position:relative;

}
}.id-ID{
.u_c_F50B223.normal{
position:relative;

}
}.id-ID{
.u_c_ISPG225.normal{
position:relative;

}
}.id-ID{
.u_c_MWES227.normal{
position:relative;

}
}.id-ID{
.u_c_QJSK229.normal{
position:relative;

}
}.id-ID{
.u_c_OS9P230.normal{
position:relative;

}
}.id-ID{
.u_c_D5FO231.normal{
position:relative;

}
}.id-ID{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.id-ID{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.id-ID{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.id-ID{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.id-ID{
.u_c_H8Z1245.normal{
position:relative;

}
}.id-ID{
.u_c_DG2T246.normal{
position:relative;

}
}.id-ID{
.u_c_A3HT248.normal{
position:relative;

}
}.id-ID{
.u_c_SP4I250.normal{
position:relative;

}
}.id-ID{
.u_c_TQBB252.normal{
position:relative;

}
}.id-ID{
.u_c_BPDA254.normal{
position:relative;

}
}.id-ID{
.u_c_BG5S255.normal{
position:relative;

}
}.id-ID{
.u_c_PCW6256.normal{
position:relative;

}
}.id-ID{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.id-ID{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.id-ID{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.id-ID{
.u_c_TT13266.normal{
position:relative;

}
}.id-ID{
.u_c_BR8S267.normal{
position:relative;

}
}.id-ID{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.id-ID{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.id-ID{
.u_c_F9EU272.normal{
position:relative;

}
}.id-ID{
.u_c_JNPQ273.normal{
position:relative;

}
}.id-ID{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.id-ID{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.id-ID{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.id-ID{
.u_c_9W0637.normal{
position:relative;

}
}.id-ID{
.u_c_OWKT38.normal{
position:relative;

}
}.id-ID{
.u_c_HBXK40.normal{
position:relative;

}
}.id-ID{
.u_c_E33R42.normal{
position:relative;

}
}.id-ID{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.id-ID{
.u_c_HD05279.normal{
position:relative;

}
}.id-ID{
.u_c_BAIN280.normal{
position:relative;

}
}.id-ID{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.id-ID{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.id-ID{
.u_c_JV9F284.normal{
position:relative;

}
}.id-ID{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.id-ID{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.id-ID{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.id-ID{
.u_c_4KIA91.normal{
position:relative;

}
}.id-ID{
.u_c_VSBS92.normal{
position:relative;

}
}.id-ID{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.id-ID{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.id-ID{
.u_c_LRU896.normal{
position:relative;

}
}.id-ID{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.id-ID{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.id-ID{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.id-ID{
.u_c_OMHF291.normal{
position:relative;

}
}.id-ID{
.u_c_GZL0292.normal{
position:relative;

}
}.id-ID{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.id-ID{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.id-ID{
.u_c_SMOH296.normal{
position:relative;

}
}.id-ID{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.id-ID{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.id-ID{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.id-ID{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_TEW3303.normal{
position:relative;

}
}.id-ID{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.id-ID{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.id-ID{
.u_c_FCR3307.normal{
position:relative;

}
}.id-ID{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.id-ID{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.id-ID{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.id-ID{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.id-ID{
.u_c_NX07322.normal{
position:relative;

}
}.id-ID{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.id-ID{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.id-ID{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.id-ID{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.id-ID{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.id-ID{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.id-ID{
.u_c_AWZN29.normal{
position:relative;

}
}.id-ID{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.id-ID{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.id-ID{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.id-ID{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.id-ID{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.id-ID{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.id-ID{
.u_c_2OTG19.normal{
position:relative;

}
}.id-ID{
.u_c_N5XH81.normal{
position:relative;

}
}.id-ID{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.id-ID{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.id-ID{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.id-ID{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.id-ID{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.id-ID{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.id-ID{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.id-ID{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.id-ID{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.id-ID{
.u_c_DF8T332.normal{
position:relative;

}
}.id-ID{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.id-ID{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.id-ID{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.id-ID{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.id-ID{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.id-ID{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.id-ID{
.u_c_PPX633.normal{
position:relative;

}
}.id-ID{
.u_c_ODH034.normal{
position:relative;

}
}.id-ID{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.id-ID{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.id-ID{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.id-ID{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.id-ID{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.id-ID{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.id-ID{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.id-ID{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.id-ID{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.id-ID{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.id-ID{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.id-ID{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.id-ID{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.id-ID{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.id-ID{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.id-ID{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.id-ID{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.id-ID{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.id-ID{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.id-ID{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.id-ID{
.u_c_E548372.normal{
position:relative;

}
}.id-ID{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_GYDD382.normal{
position:relative;

}
}.id-ID{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.id-ID{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.id-ID{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.id-ID{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.id-ID{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.id-ID{
.u_c_AMCZ32.normal{
position:relative;

}
}.id-ID{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.id-ID{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.id-ID{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.id-ID{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.id-ID{
.u_c_5MKI43.normal{
position:relative;

}
}.id-ID{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.id-ID{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.id-ID{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.id-ID{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.id-ID{
.u_c_0ALV52.normal{
position:relative;

}
}.id-ID{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.id-ID{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.id-ID{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.id-ID{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.id-ID{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.id-ID{
.u_c_EGF4391.normal{
position:relative;

}
}.id-ID{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.id-ID{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.id-ID{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ar-SA{
.u_c_EEKH149.normal{
position:relative;
z-index:100;

}
}.ar-SA{
.u_c_93BI150.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_S1GB151.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_DVXM152.normal{
position:relative;
margin-top:-0.09rem;

}
}.ar-SA{
.u_c_TXUV154.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_INK7155.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_INK7155.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_INK7155.normal .th:last-child{
border-right:none;

}

.u_c_INK7155.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_INK7155.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_INK7155.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_EZ6A156.normal{
position:relative;

}
}.ar-SA{
.u_c_MJVL157.normal{
position:relative;

}
}.ar-SA{
.u_c_LU2L159.normal{
position:relative;

}
}.ar-SA{
.u_c_KB6X161.normal{
position:relative;

}
}.ar-SA{
.u_c_GIVF162.normal{
position:relative;

}
}.ar-SA{
.u_c_O6EY163.normal{
position:relative;

}
}.ar-SA{
.u_c_OQPL165.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_9F28166.normal{
position:relative;
white-space:pre-line;

}
}.ar-SA{
.u_c_L9U2167.normal{
position:relative;

}
}.ar-SA{
.u_c_RPCD168.normal{
position:relative;
color:#ffac00;

}
}.ar-SA{
.u_c_QJ7T170.normal{
position:relative;

}
}.ar-SA{
.u_c_T83Z172.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_JEBZ173.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ar-SA{
.u_c_4FYP175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_TUG9176.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_6N1J198.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ar-SA{
.u_c_3XOE227.normal{
position:relative;
margin-top:-0.09rem;

}
}.ar-SA{
.u_c_0FEY199.normal{
position:relative;
height:7.07rem;
overflow-y:auto;
top:0.16rem;
width:92%;
margin:0 auto;

}
}.ar-SA{
.u_c_V058200.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;
margin:0 auto;

}

.u_c_V058200.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_V058200.normal .th:last-child{
border-right:none;

}

.u_c_V058200.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_V058200.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_V058200.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_U8C4201.normal{
position:relative;

}
}.ar-SA{
.u_c_OKFQ202.normal{
position:relative;

}
}.ar-SA{
.u_c_7CQY204.normal{
position:relative;

}
}.ar-SA{
.u_c_PTZN206.normal{
position:relative;

}
}.ar-SA{
.u_c_VRV4208.normal{
position:relative;

}
}.ar-SA{
.u_c_Z2F7210.normal{
position:relative;

}
}.ar-SA{
.u_c_3NW0211.normal{
position:relative;

}
}.ar-SA{
.u_c_PAQY212.normal{
position:relative;

}
}.ar-SA{
.u_c_TQ08214.normal{
position:relative;

}
}.ar-SA{
.u_c_QZ3T216.normal{
position:relative;

}
}.ar-SA{
.u_c_WUCL218.normal{
position:relative;

}
}.ar-SA{
.u_c_TP6B220.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_N5TX48.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_O2L649.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_PT9650.normal{
position:relative;
margin-top:-0.09rem;

}
}.ar-SA{
.u_c_S49552.normal{
position:relative;
height:6.03rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_GQOA53.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GQOA53.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GQOA53.normal .th:last-child{
border-right:none;

}

.u_c_GQOA53.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GQOA53.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GQOA53.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_N0O054.normal{
position:relative;

}
}.ar-SA{
.u_c_NTM477.normal{
position:relative;

}
}.ar-SA{
.u_c_N48357.normal{
position:relative;

}
}.ar-SA{
.u_c_IOWX59.normal{
position:relative;

}
}.ar-SA{
.u_c_MSKH60.normal{
position:relative;

}
}.ar-SA{
.u_c_RQ1579.normal{
position:relative;

}
}.ar-SA{
.u_c_OXZT63.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_R9EH64.normal{
position:relative;
white-space:pre-line;

}
}.ar-SA{
.u_c_TTE470.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_VR7N71.normal{
position:absolute;
top:0.43rem;
right:0.32rem;

}
}.ar-SA{
.u_c_L29Z174.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_CJ7W175.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_HNVX176.normal{
position:relative;
margin-top:-0.07rem;

}
}.ar-SA{
.u_c_EG2Q178.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_GNB7179.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_GNB7179.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_GNB7179.normal .th:last-child{
border-right:none;

}

.u_c_GNB7179.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_GNB7179.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_GNB7179.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_HI7Z180.normal{
position:relative;

}
}.ar-SA{
.u_c_D7T4181.normal{
position:relative;

}
}.ar-SA{
.u_c_I55Y183.normal{
position:relative;

}
}.ar-SA{
.u_c_OUV7185.normal{
position:relative;

}
}.ar-SA{
.u_c_IJRB186.normal{
position:relative;

}
}.ar-SA{
.u_c_OPFB187.normal{
position:relative;

}
}.ar-SA{
.u_c_PJZV189.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_FLPZ190.normal{
position:relative;
white-space:pre-line;

}
}.ar-SA{
.u_c_SCGF191.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_P7ST192.normal{
position:absolute;
top:0.43rem;
right:0.48rem;

}
}.ar-SA{
.u_c_A7J224.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_ZBE225.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_ST6826.normal{
position:relative;
margin-top:-0.07rem;

}
}.ar-SA{
.u_c_29DH28.normal{
position:relative;
height:5.81rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_55OD29.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_55OD29.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_55OD29.normal .th:last-child{
border-right:none;

}

.u_c_55OD29.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_55OD29.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_55OD29.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_7TVH30.normal{
position:relative;

}
}.ar-SA{
.u_c_4FNG31.normal{
position:relative;

}
}.ar-SA{
.u_c_4BRN33.normal{
position:relative;

}
}.ar-SA{
.u_c_0PDC35.normal{
position:relative;

}
}.ar-SA{
.u_c_CLRM36.normal{
position:relative;

}
}.ar-SA{
.u_c_6DO837.normal{
position:relative;

}
}.ar-SA{
.u_c_99XC39.normal{
position:relative;
display:flex;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_4NV140.normal{
position:relative;
white-space:pre-line;

}
}.ar-SA{
.u_c_42GT41.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_A5AZ42.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ar-SA{
.u_c_JMGQ193.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_BNUG194.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_BH3T195.normal{
position:relative;
margin-top:-0.23rem;

}
}.ar-SA{
.u_c_F0VZ197.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_QCIY198.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_QCIY198.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_QCIY198.normal .th:last-child{
border-right:none;

}

.u_c_QCIY198.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_QCIY198.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_QCIY198.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_IO9N199.normal{
position:relative;

}
}.ar-SA{
.u_c_IOVB200.normal{
position:relative;

}
}.ar-SA{
.u_c_U7GV202.normal{
position:relative;

}
}.ar-SA{
.u_c_9ZDW204.normal{
position:relative;

}
}.ar-SA{
.u_c_MH8K206.normal{
position:relative;

}
}.ar-SA{
.u_c_OBVL207.normal{
position:relative;

}
}.ar-SA{
.u_c_ML07208.normal{
position:relative;

}
}.ar-SA{
.u_c_RB9U210.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_I9R6212.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_QSMZ214.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_HVLV215.normal{
position:absolute;
top:0.33rem;
right:0.23rem;

}
}.ar-SA{
.u_c_C5IC216.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_BV7B217.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_MEAK218.normal{
position:relative;
margin-top:0.29rem;

}
}.ar-SA{
.u_c_EO1W220.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_R0I4221.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_R0I4221.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_R0I4221.normal .th:last-child{
border-right:none;

}

.u_c_R0I4221.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_R0I4221.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_R0I4221.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_TKH9222.normal{
position:relative;

}
}.ar-SA{
.u_c_F50B223.normal{
position:relative;

}
}.ar-SA{
.u_c_ISPG225.normal{
position:relative;

}
}.ar-SA{
.u_c_MWES227.normal{
position:relative;

}
}.ar-SA{
.u_c_QJSK229.normal{
position:relative;

}
}.ar-SA{
.u_c_OS9P230.normal{
position:relative;

}
}.ar-SA{
.u_c_D5FO231.normal{
position:relative;

}
}.ar-SA{
.u_c_OO9E233.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_QUZN235.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_OHFG237.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_BDAJ238.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ar-SA{
.u_c_FMGB239.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_95KO240.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_CUB9241.normal{
position:relative;
margin-top:0.29rem;

}
}.ar-SA{
.u_c_9W8Y243.normal{
position:relative;
height:5.77rem;
overflow-y:auto;
margin-top:0.25rem;

}
}.ar-SA{
.u_c_CE0G244.normal{
position:relative;
width:100%;
border-collapse:collapse;
border-spacing:0;
text-align:center;

}

.u_c_CE0G244.normal .th{
border-left:none;
padding:0.19rem 0;
border-top:none;
font-weight:bold;

}

.u_c_CE0G244.normal .th:last-child{
border-right:none;

}

.u_c_CE0G244.normal .td{
border-left:none;
padding:0.13rem;
border-top:none;
border-bottom:none;

}

.u_c_CE0G244.normal .tr{
border-top:none;
border-left:none;
border-right:none;

}

.u_c_CE0G244.normal .td:last-child{
border-right:none;

}
}.ar-SA{
.u_c_H8Z1245.normal{
position:relative;

}
}.ar-SA{
.u_c_DG2T246.normal{
position:relative;

}
}.ar-SA{
.u_c_A3HT248.normal{
position:relative;

}
}.ar-SA{
.u_c_SP4I250.normal{
position:relative;

}
}.ar-SA{
.u_c_TQBB252.normal{
position:relative;

}
}.ar-SA{
.u_c_BPDA254.normal{
position:relative;

}
}.ar-SA{
.u_c_BG5S255.normal{
position:relative;

}
}.ar-SA{
.u_c_PCW6256.normal{
position:relative;

}
}.ar-SA{
.u_c_GGPP258.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_PYKE260.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_BGCM262.normal{
position:relative;
justify-content:space-around;
align-items:center;
flex-flow:wrap;
flex-direction:column;

}
}.ar-SA{
.u_c_K27Y264.normal{
position:absolute;
bottom:50%;
left:0;
width:100%;
text-align:center;

}
}.ar-SA{
.u_c_C3YB265.normal{
position:absolute;
top:0.68rem;
right:0.61rem;

}
}.ar-SA{
.u_c_TT13266.normal{
position:relative;

}
}.ar-SA{
.u_c_BR8S267.normal{
position:relative;

}
}.ar-SA{
.u_c_QA30268.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.04rem;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_GQHB270.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.23rem;
text-align:center;
line-height:150%;
height:5.03rem;
white-space:pre-line;

}
}.ar-SA{
.u_c_ESRJ271.normal{
position:relative;
width:100%;
border-collapse:collapse;

}
}.ar-SA{
.u_c_F9EU272.normal{
position:relative;

}
}.ar-SA{
.u_c_JNPQ273.normal{
position:relative;

}
}.ar-SA{
.u_c_LD96274.normal{
position:relative;
padding:0.27rem;
width:30%;

}
}.ar-SA{
.u_c_JQDW275.normal{
position:relative;
width:60%;

}
}.ar-SA{
.u_c_JLSA36.normal{
position:relative;
width:100%;
line-height:150%;

}
}.ar-SA{
.u_c_9W0637.normal{
position:relative;

}
}.ar-SA{
.u_c_OWKT38.normal{
position:relative;

}
}.ar-SA{
.u_c_HBXK40.normal{
position:relative;

}
}.ar-SA{
.u_c_E33R42.normal{
position:relative;

}
}.ar-SA{
.u_c_SN0I278.normal{
position:absolute;
top:0.67rem;
right:0.60rem;

}
}.ar-SA{
.u_c_HD05279.normal{
position:relative;

}
}.ar-SA{
.u_c_BAIN280.normal{
position:relative;

}
}.ar-SA{
.u_c_J1OY281.normal{
position:relative;
margin-top:-0.01rem;

}
}.ar-SA{
.u_c_HXDL283.normal{
position:relative;
height:auto;
margin-top:0.57rem;
display:flex;
justify-content:flex-start;
align-items:center;
flex-direction:column;
overflow-y:auto;
max-height:3.33rem;

}
}.ar-SA{
.u_c_JV9F284.normal{
position:relative;

}
}.ar-SA{
.u_c_NZ54285.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_D2YH286.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_BT5T287.normal{
position:relative;
margin:auto;
margin-top:0.72rem;

}
}.ar-SA{
.u_c_IOVK289.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ar-SA{
.u_c_MECU290.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ar-SA{
.u_c_4KIA91.normal{
position:relative;

}
}.ar-SA{
.u_c_VSBS92.normal{
position:relative;

}
}.ar-SA{
.u_c_WMZQ93.normal{
position:relative;
margin-top:0.52rem;

}
}.ar-SA{
.u_c_VHZ195.normal{
position:relative;
height:3.24rem;
overflow-y:auto;
overflow-x:hidden;
margin-top:0.68rem;

}
}.ar-SA{
.u_c_LRU896.normal{
position:relative;

}
}.ar-SA{
.u_c_57FV97.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_4BZD98.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_ZPDQ99.normal{
position:relative;
margin:auto;
margin-top:-0.15rem;

}
}.ar-SA{
.u_c_LDTL101.normal{
position:relative;
margin-top:0.21rem;
text-align:center;

}
}.ar-SA{
.u_c_OMDX102.normal{
position:absolute;
top:0.68rem;
right:0.60rem;

}
}.ar-SA{
.u_c_OMHF291.normal{
position:relative;

}
}.ar-SA{
.u_c_GZL0292.normal{
position:relative;

}
}.ar-SA{
.u_c_TSXD293.normal{
position:relative;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_OODK295.normal{
position:relative;
height:auto;
margin-top:0.47rem;
display:flex;
justify-content:center;
align-items:center;
flex-direction:column;

}
}.ar-SA{
.u_c_SMOH296.normal{
position:relative;

}
}.ar-SA{
.u_c_AKZ5297.normal{
position:relative;
margin-top:0.07rem;
text-align:center;
white-space:pre-line;

}
}.ar-SA{
.u_c_9CWK298.normal{
position:relative;
display:block;
margin:auto;
margin-top:0.40rem;
height:60%;
max-width:80%;

}
}.ar-SA{
.u_c_MNYN299.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_NS1R301.normal{
position:absolute;
top:0.65rem;
right:0.57rem;

}
}.ar-SA{
.u_c_HLVO302.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_TEW3303.normal{
position:relative;

}
}.ar-SA{
.u_c_NIE3304.normal{
position:relative;
margin-top:0.17rem;

}
}.ar-SA{
.u_c_F62T306.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
width:100%;
margin-top:0.45rem;

}
}.ar-SA{
.u_c_FCR3307.normal{
position:relative;

}
}.ar-SA{
.u_c_NP13309.normal{
position:relative;
margin-left:0.40rem;
display:none;

}
}.ar-SA{
.u_c_MDD3311.normal{
position:relative;
margin-top:0.40rem;
text-align:center;

}

.u_c_MDD3311.normal.hide{
opacity:0;

}
}.ar-SA{
.u_c_D7Y3313.normal{
position:absolute;
top:0.65rem;
right:0.56rem;

}
}.ar-SA{
.u_c_ATIJ314.normal{
position:relative;
margin:auto;
margin-top:0.27rem;

}
}.ar-SA{
.u_c_NX07322.normal{
position:relative;

}
}.ar-SA{
.u_c_O43Z323.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ar-SA{
.u_c_ISFL324.normal{
position:relative;
margin-top:0.23rem;

}
}.ar-SA{
.u_c_HY88326.normal{
position:relative;
width:7.77rem;
height:1.07rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2023/12/170142307360591495.png);
outline:none;
-webkit-tap-highlight-color:rgba(0,0,0,0);
background-size:100% 100%;
border:none;
margin:0.40rem auto 0;
padding:0 0.27rem;

}
}.ar-SA{
.u_c_F8EP327.normal{
position:absolute;
top:0.41rem;
right:0.40rem;

}
}.ar-SA{
.u_c_ML0F328.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ar-SA{
.u_c_RWPA330.normal{
position:relative;
margin:auto;
margin-top:0.96rem;

}

.u_c_RWPA330.normal.has{
filter:grayscale(1);
cursor:default;

}
}.ar-SA{
.u_c_AWZN29.normal{
position:relative;

}
}.ar-SA{
.u_c_9AEY30.normal{
position:relative;
display:flex;
flex-direction:column;

}
}.ar-SA{
.u_c_KAV634.normal{
position:absolute;
top:0.15rem;
right:0.40rem;

}
}.ar-SA{
.u_c_BRSA49.normal{
position:relative;
width:9.03rem;
height:3.65rem;
background:no-repeat center;
background-size:contain;
margin:0 auto;
margin-top:0.29rem;
object-fit:contain;

}
}.ar-SA{
.u_c_5CF243.normal{
position:relative;
font-size:0.32rem;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;
color:#fff;
margin-top:0.07rem;

}
}.ar-SA{
.u_c_FR0B31.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}

.u_c_FR0B31.normal .tag{
font-weight:bold;
font-style:italic;

}
}.ar-SA{
.u_c_9I7I19.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645797-19.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ar-SA{
.u_c_2OTG19.normal{
position:relative;

}
}.ar-SA{
.u_c_N5XH81.normal{
position:relative;

}
}.ar-SA{
.u_c_TD0150.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ar-SA{
.u_c_A5IO37.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_07SK51.normal{
position:relative;
margin:auto;
margin-top:0.13rem;

}
}.ar-SA{
.u_c_WRVM53.normal{
position:relative;
margin-top:0.23rem;
font-size:0.29rem;
display:flex;
align-items:center;

}
}.ar-SA{
.u_c_GV0A20.normal{
position:relative;
width:0.73rem;
height:0.75rem;
background:no-repeat center;
background-size:cover;
background-image:url(https://cdnimages.awselbcombine.com/public_images/auto_system_upload/2024/09/1727422645806-96.png);
margin-right:0.13rem;
flex-shrink:0;

}
}.ar-SA{
.u_c_QZJ855.normal{
position:relative;
display:flex;
justify-content:space-evenly;

}
}.ar-SA{
.u_c_MGM958.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ar-SA{
.u_c_DFSO19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ar-SA{
.u_c_4CUK19.normal{
position:relative;
margin:auto;
margin-top:0.13rem;
text-align:center;

}
}.ar-SA{
.u_c_DF8T332.normal{
position:relative;

}
}.ar-SA{
.u_c_EQD4333.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_BRKO334.normal{
position:relative;
box-sizing:border-box;
height:1.77rem;
padding:0 0.13rem;
overflow-y:auto;
margin-top:0.32rem;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_PX60336.normal{
position:relative;
text-align:right;

}
}.ar-SA{
.u_c_HEUB338.normal{
position:relative;
align-items:center;
display:flex;
justify-content:center;
top:-0.24rem;

}
}.ar-SA{
.u_c_B1ZY340.normal{
position:relative;
width:5.33rem !important;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ar-SA{
.u_c_NRD6342.normal{
position:relative;
margin:auto;
margin-top:0.33rem;

}
}.ar-SA{
.u_c_RQ4V344.normal{
position:relative;
margin-top:0.12rem;
text-align:center;

}
}.ar-SA{
.u_c_QE3E346.normal{
position:absolute;
top:0.35rem;
right:0.39rem;

}
}.ar-SA{
.u_c_PPX633.normal{
position:relative;

}
}.ar-SA{
.u_c_ODH034.normal{
position:relative;

}
}.ar-SA{
.u_c_UYAG35.normal{
position:relative;
margin-top:0.20rem;

}
}.ar-SA{
.u_c_P4PM37.normal{
position:relative;
margin-top:-0.31rem;
padding-right:1.60rem;

}
}.ar-SA{
.u_c_UO0E38.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.48rem;

}
}.ar-SA{
.u_c_DKKB40.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;

}
}.ar-SA{
.u_c_HG0342.normal{
position:relative;
align-items:center;
display:flex;
justify-content:flex-end;
margin-top:0.12rem;

}
}.ar-SA{
.u_c_EANT44.normal{
position:relative;
width:3.89rem;
height:1.07rem;
margin-left:0.40rem;
display:flex;
align-items:center;
padding-left:0.27rem;
background-size:100% 100%;
font-size:0.33rem;
white-space:pre;
overflow:auto;

}
}.ar-SA{
.u_c_QKY052.normal{
position:relative;
margin-top:-0.59rem;
font-size:0.29rem;
text-align:center;
display:flex;
white-space:pre-wrap;
line-height:1.5;
cursor:pointer;
justify-content:space-evenly;

}
}.ar-SA{
.u_c_EMSF53.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_LQQC54.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455465798073.png);

}
}.ar-SA{
.u_c_U47W56.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_SXH157.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455475183650.png);

}
}.ar-SA{
.u_c_GJVV59.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_HA2M60.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455451225549.png);

}
}.ar-SA{
.u_c_F1FS62.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_NVWC63.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455466195945.png);

}
}.ar-SA{
.u_c_MHOE65.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_H9WR66.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455556335432.png);

}
}.ar-SA{
.u_c_MPYF68.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_U1D569.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455499063992.png);

}
}.ar-SA{
.u_c_T86A71.normal{
position:relative;
display:flex;
justify-content:center;
align-items:center;
border-radius:0.13rem;
flex-direction:column;

}
}.ar-SA{
.u_c_ORHK72.normal{
position:relative;
margin-top:0.88rem;
height:1.28rem;
width:1.28rem;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170928455519433717.png);

}
}.ar-SA{
.u_c_AFO548.normal{
position:relative;
margin:auto;
margin-top:0.55rem;
height:0.80rem;
width:80%;
background:#9c8d8d;
font-size:0.33rem;
display:inline-block;
color:#000;
display:flex;
justify-content:center;
align-items:center;
text-decoration:none;
border-radius:0.13rem;

}
}.ar-SA{
.u_c_OQAA50.normal{
position:relative;
margin-top:0.21rem;
font-size:0.29rem;
color:#fff;
text-align:center;
font-weight:normal;
white-space:pre-wrap;
line-height:1.5;

}
}.ar-SA{
.u_c_ICZ552.normal{
position:absolute;
top:0.39rem;
right:0.44rem;

}
}.ar-SA{
.u_c_OVDX367.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_R9S3368.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_B27A369.normal{
position:relative;
margin-top:0;

}
}.ar-SA{
.u_c_EFHB371.normal{
position:relative;
margin:auto;
margin-top:0.39rem;
text-align:center;
font-size:0;

}

.u_c_EFHB371.normal .select-item{
margin-bottom:0.27rem;

}

.u_c_EFHB371.normal .select-item-select{
background:no-repeat center;
background-size:contain;
background-image:url(https://cdnimages.awselbcombine.com/public_images/one_image/2024/03/170927905281288923.jpg);
width:6.87rem;
height:1.07rem;
font-size:0.27rem;
-webkit-appearance:none;
appearance:none;
border:none;
outline:none;
webkit-tap-highlight-color:rgba(0,0,0,0);
padding-left:0.27rem;

}

.u_c_EFHB371.normal .select-item-option{
color:#333;

}
}.ar-SA{
.u_c_E548372.normal{
position:relative;

}
}.ar-SA{
.u_c_S66Y373.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_QFAK374.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_RCMS376.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_H8KL377.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_G2MY379.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_BPQQ380.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_GYDD382.normal{
position:relative;

}
}.ar-SA{
.u_c_DRLJ383.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_PK28384.normal{
position:relative;
width:2.67rem;
height:1.33rem;

}
}.ar-SA{
.u_c_954V386.normal{
position:relative;
margin:auto;
margin-top:0.47rem;

}
}.ar-SA{
.u_c_Q6CK388.normal{
position:relative;
margin-top:0.13rem;
text-align:center;

}
}.ar-SA{
.u_c_QNLO389.normal{
position:absolute;
top:0.44rem;
right:0.36rem;

}
}.ar-SA{
.u_c_NUO931.normal{
position:relative;
z-index:10;

}
}.ar-SA{
.u_c_AMCZ32.normal{
position:relative;

}
}.ar-SA{
.u_c_7TOD33.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:1.01rem;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_OWNH35.normal{
position:relative;
margin:auto;
margin-top:0.37rem;

}
}.ar-SA{
.u_c_UQRW38.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ar-SA{
.u_c_GD8Y37.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ar-SA{
.u_c_O19F42.normal{
position:relative;
z-index:10;

}
}.ar-SA{
.u_c_5MKI43.normal{
position:relative;

}
}.ar-SA{
.u_c_S93244.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.48rem;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_UL5C46.normal{
position:relative;
margin:auto;
margin-top:0.83rem;

}
}.ar-SA{
.u_c_NEZ348.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ar-SA{
.u_c_16M150.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ar-SA{
.u_c_Q8ME51.normal{
position:relative;
z-index:10;

}
}.ar-SA{
.u_c_0ALV52.normal{
position:relative;

}
}.ar-SA{
.u_c_1CGX53.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.65rem;
text-align:center;
line-height:150%;

}
}.ar-SA{
.u_c_RZ6G55.normal{
position:relative;
margin:auto;
margin-top:0.16rem;

}
}.ar-SA{
.u_c_45K757.normal{
position:relative;
margin-top:-0.05rem;
text-align:center;

}
}.ar-SA{
.u_c_8IJG59.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}.ar-SA{
.u_c_O92G390.normal{
position:relative;
z-index:10;

}
}.ar-SA{
.u_c_EGF4391.normal{
position:relative;

}
}.ar-SA{
.u_c_TL1N392.normal{
position:relative;
box-sizing:border-box;
padding:0 0.53rem;
overflow-y:auto;
margin-top:0.69rem;
text-align:center;
line-height:150%;
white-space:pre-wrap;
overflow-x:hidden;
max-height:60vh;

}
}.ar-SA{
.u_c_QFPE394.normal{
position:relative;
margin:auto;
margin-top:0.95rem;

}
}.ar-SA{
.u_c_QUWX396.normal{
position:absolute;
top:0.48rem;
right:0.60rem;

}
}
</style>
